<script>
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-tabs */
import { appConfig } from '../../config.js'
import { mapActions, mapGetters } from 'vuex'
import Axios from 'axios'
import _ from 'lodash'
import draggable from 'vuedraggable'
import { VueContext } from 'vue-context'
import DatePicker from '../utility/date-picker'
import FileUploader from '../utility/file-uploader'
import ImageLightbox from '../utility/image-lightbox/image-lightbox'
import NumberFormatter from '../utility/number-formatter'
import AmazonAds from '../utility/amazon-ads'
import AdvancedSearch from '../utility/advanced-search'
import ImageSelector from '../utility/image-selector'
import SiteFooter from '../common/site-footer'
import ActivityReplyMessage from '../activity-reply-message'
import vue2Dropzone from 'vue2-dropzone'
import GoogleLocation from '../utility/google-location'
import { FormWizard, TabContent, WizardStep } from 'vue-form-wizard'
import Multiselect from 'vue-multiselect'
import ActivityList from '../utility/activity-list/activity-list'
import CardNotes from '../utility/card-notes'
import CardFiles from '../utility/card-files'
import InsuranceBlock from '../utility/insurance.block.vue'
import VehicleBlock from '../utility/vehicle.block'
import EstimateSupplements from '../utility/estimate-supplements'
import { isMobile, isMobileOnly } from 'mobile-device-detect'
import { email, required } from 'vuelidate/lib/validators'
import RsFormWizard from '../rs-form-wizard'
import SmallFormWizard from '../small-form-wizard.vue'
import RsRipple from '../rs-ripple.vue'
import accounting from 'accounting'
import BlockPagination from '../utility/block-pagination'
import AdvertBanner from '../utility/advert-banner'

// Mixins
import dropdownOptions from '../../mixins/dropdownOptions'

import ItemList from './estimate-edit/item-list'

export default {
  name: 'estimates-edit',
  mixins: [
    dropdownOptions,
  ],
  data: function () {
    return {
      boardIn: {
        id: null,
        updatedDate: null,
        createdDate: null,
      },
      boardDeparture: {
        id: null,
        updatedDate: null,
        createdDate: null,
      },
      lastTimestampImages: 0,
      intervalUpdateImages: null,
      isCheckedEmail: true,
      isItemListLoaded: false,
      selectedVehicleSubTab: 'estimates-values',
      allowShowImportPdfParts: {},
      itemsList: [],
      selectedEstimateItem: {
        part: {},
        type: '',
      },
      isCanDrag: true,
      isNeedCopy: false,
      selectedText: '',
      currentItemListId: null,
      selectedCard: '', //ToDo temp var
      properties: {
        isAutoSave: true,
        isCanSendToClaimlinq: false,
        isCanSendToPartssearch: false,
        isFromIag: false,
        isRegoAlwaysLookup: false,
        isRegoLookup: false,
        isRegoLookupWithCompliance: false,
        isVinAlwaysLookup: false,
        isVinLookup: false,
        isVinLookupWithCompliance: false,
        isHideSeries: false,
        isRatesRREditable:true,
        isRatesRepairEditable:true,
        isRatesPaintEditable:true,
        isRatesEditable:true,
        isSmsFeatureEnabled: false,
      },
      filterAssignTo: '',
      newTask: {
        name: '',
        date: '',
        time: '00:00',
        notes: '',
        type: { key: 'to-do', value: 'ToDo' },
        assignedTo: { id: '-1', name: 'Estimators' },
        status: { key: 'none', value: 'None' },
      },
      note: '',
      note_id: null,
      isOpenNewTaskForm: false,
      showAddEnvironmentLevy: false,
      showAddPaintSetup: false,
      backdoor: 0,
      backdoorButterflyCustomMatrix: 0,
      paintMaterials: [
        { key: 'not_set', value: '' },
        { key: 'S1', value: 'S1' },
        { key: 'S2', value: 'S2' },
        { key: 'M1', value: 'M1' },
        { key: 'M2', value: 'M2' },
        { key: 'M3', value: 'M3' },
        { key: 'M3PLUS', value: 'M3+' },
      ],
      estimateMethodologies: [
        { key: 'custom', value: 'Custom' },
        { key: 'ntar', value: 'NTAR' },
        { key: 'ltar', value: 'LTAR' },
      ],
      classTabContent: 'tab-content',
      isHiddenOptions: false,
      isHiddenNewNote: true,
      isSentToInsurer: false,
      isLoadTimesForItemPart: false,
      notes: [],
      heightOptions: '',
      currentNewPaintCode: '',
      vehiclePaintCodes: [],
      currentNewMake: '',
      currentNewModel: '',
      currentNewSeries: '',
      currentNewScheduleNumber: '',
      newVehiclePaintCode: {},
      isShowPaintMaterialNotification: false,
      showEnviromentLevy: true,
      showPaintSetupTime: true,
      isShowNewPaintColourNotification: false,
      timesForItemPart: {},
      estimateAmount: {
        estimate_number: '',
        supplement_number: 0,
        parent_estimate_id: 0,
        state: '',
        amount: '',
        amount_str: '',
        tech_assigned: 'None',
        assignedTo: { id: null, name: null },
        parts_purchase_order: '',
        parts_markup_profit: '',
      },
      filesAfterUpload: [],
      imagesAfterUpload: [],
      isAutoSave: false,
      autoSaveMessage: '',
      originalData: '',
      updateData: {},
      updateData2: {},
      autoUpdateItemsList: {},
      manualUpdateItemsList: {},
      activitySortTypes: {
        email: 'Email',
        sms: 'SMS',
        external: 'External',
        assignment: 'Assignment',
        status_change: 'Status/Change',
        show_all: 'Show All',
      },
      activitySortTypeText: 'Sort By',
      isMobile,
      isMobileOnly,
      imageUploadDropzoneOptions: {
        headers: { 'Authorization': localStorage.getItem('token') },
        resizeWidth: 1500,
        resizeQuality: 0.7,
        capture: 'camera',
        clickable: '.drop-clickable',
        url: appConfig.baseAPIURL + '/fe/card/uploadImagesDropzone',
        method: 'post',
        maxFilesize: 50,
        // maxFiles: 2,     //Can be used to limit the maximum number of files that will be handled by this Dropzone
        thumbnailWidth: 200,
        timeout: 300000,
        addRemoveLinks: false,
        acceptedFiles: 'image/jpeg, image/jpg, image/png',
        dictFileTooBig: 'Your file has exceeded the maximum limit of 5MB per file. Please reduce the file size and upload again',
      },
      fileUploadDropzoneOptions: {
        headers: { 'Authorization': localStorage.getItem('token') },
        url: appConfig.baseAPIURL + '/fe/card/uploadFilesDropzone',
        method: 'post',
        maxFilesize: 50,
        timeout: 300000,
        clickable: '.browse-btn-files',
        // maxFiles: 2,     //Can be used to limit the maximum number of files that will be handled by this Dropzone
        thumbnailWidth: 200,
        addRemoveLinks: false,
        acceptedFiles: 'application/pdf, .doc, .docx',
        dictFileTooBig: 'Your file has exceeded the maximum limit of 5MB per file. Please reduce the file size and upload again',
      },
      itemsListImageUploadDropzoneOptions: {
        headers: { 'Authorization': localStorage.getItem('token') },
        resizeWidth: 1500,
        resizeQuality: 0.7,
        url: appConfig.baseAPIURL + '/fe/card/uploadImagesDropzone',
        method: 'post',
        maxFilesize: 5,
        thumbnailWidth: 160,
        thumbnailHeight: 160,
        addRemoveLinks: false,
        acceptedFiles: 'image/jpeg, image/jpg, image/png',
        dictFileTooBig: 'Your file has exceeded the maximum limit of 5MB per file. Please reduce the file size and upload again',
      },
      changeEstimentChapter: 'All',
      currentTab: 'vehicleDetails',
      selectedVehicleMake: {},
      selectedVehicleModel: {},
      count: 0,
      estimateToCustomer: null,
      status: '',
      newImageAdded: false,
      newFileAdded: false,
      customerContacts: Array(),
      new_customer_email: '',
      new_customer_name: '',
      new_insurer_name: '',
      new_insurer_email: '',
      supplements: [],
      activity: [],
      countries: {
        'AU': 'Australia',
        'NZ': 'New Zealand'
      },
      states: {
        QLD: 'Queensland',
        NT: 'Northern Territory',
        NSW: 'New South Wales',
        VIC: 'Victoria',
        TAS: 'Tasmania',
        SA: 'South Australia',
        WA: 'Western Australia'
      },
      image: '',
      images: [],
      image_ids: [],
      image_categories: [],
      selectedImages: [],
      file: '',
      files: [],
      file_ids: [],
      draft: 'N',
      insurers: [],
      assessors: [],
      card_id: '',
      cardProgress: {
        startIndex: 0,
        color: '#142742',
        stepSize: 'xs',
        width: '',
        widthActiveProgress: '',
      },
      ceStatuses: [],
      state: '',
      card: {
        customer: {
          customer_id: null,
          name: '',
          mobile: '',
          email: '',
          customer_type: '',
          abn: '',
          address: '',
          level_unit_lot: '',
          street_name: '',
          suburb: '',
          state: '',
          postcode: '',
          country: '',
          phone: '',
        },
        vehicle: {
          customer_vehicle_id: null,
          dom: '',
          complianceDate: '',
          rego_number: '',
          make: '',
          model: '',
          series: '',
          series_shedule_number: '',
          colour: '',
          colour_variant: '',
          vin: '',
          odometer: '',
          transmission: ''
        },
        insurance: {
          id: null,
          insurance_claim_type: null,
          insurer_id: null,
          insurer_name: '',
          insurer_location: '',
          insurer_assessor_id: null,
          assessor_name: '',
          assessor_email: '',
          assessor_phone: '',
          policy_number: '',
          claim_number: '',
          assessment_date: '',
          excess: '',
          contribution: '',
          discount: '',
          market_value: '',
          agreed_value: '',
          accidentDescription: '',
          sumInsured: '',
          pav: '',
          rates: {
            estimate_methodology: 'custom',
            estimate_rates_rr: null,
            estimate_rates_repair: null,
            estimate_rates_paint: null
          },
          custom_paint_times: {
            s1: 0,
            s2: 0,
            m1: 0,
            m2: 0,
            m3: 0,
            m3plus: 0
          },
        },
        customer_contact_2: '',
        insurance_repair: 'true',
        booking_date: '',
        completion_date: '',
        card_number: '',
        card_id: '',
        card_status: '',
        statuses: [],
        isTotalLoss: false,
        vehicleDriverName: '',
        contactNumber1: '',
        contactNumber2: '',
        contactEmail: '',
      },
      invoice: {
        id: null,
        status: '',
        number: '',
      },
      excess_invoice: {
        id: null,
        status: '',
        number: '',
      },
      completion_date: '',
      booking_date: '',
      defaultValues: {
        rates: {
          custom: {
            default_rates_estimate_methodology: '',
            default_rates_paint_material: '',
            default_rates_rr: '',
            default_rates_repair: '',
            default_rates_paint: '',
            default_rates_mechanical: '',
            is_active: false,
          },
          ntar: {
            default_rates_estimate_methodology: '',
            default_rates_paint_material: '',
            default_rates_rr: '',
            default_rates_repair: '',
            default_rates_paint: '',
            default_rates_mechanical: '',
            is_active: false,
          },
          ltar: {
            default_rates_estimate_methodology: '',
            default_rates_paint_material: '',
            default_rates_rr: '',
            default_rates_repair: '',
            default_rates_paint: '',
            default_rates_mechanical: '',
            is_active: false,
          },
          rs: {
            default_rates_estimate_methodology: '',
            default_rates_paint_material: '',
            default_rates_rr: '',
            default_rates_repair: '',
            default_rates_paint: '',
            default_rates_mechanical: '',
            is_active: false,
          },
          active: 'custom',
        }
      },
      estimate: {
        id: 0,
        templateId: 0,
        shop: {},
        isEstimateForButterfly: true,
        isShowEnvironmentLevyCalculation: true,
        isShowPaintSetupCalculation: true,
        dateCreated: '',
        rates: {
          estimate_methodology: 'custom',
          rr: 95,
          repair: 95,
          paint: 95,
          partmarkup: 0,
          paint_material: 'not_set',
          material_use_levy: 'Y',
          subtotal: 0,
          adjSubtotal: 0,
          mechanical: 0,
        },
        isSentToIntegrationSystem: false,
      },
      iagOrmItems: {
                    'RR': [],
                    'Repair': [],
                    'Paint': [],
                    'Part': [],
                    'Materials': [],
                    'MaterialsCalc': [],
                    'Sublet': [],
                    'Other': [],
                    'PDR': [],
                },
                estimateParts: {
                    'RR': [],
                    'Repair': [],
                    'Paint': [],
                    'Part': [],
                    'Materials': [],
                    'MaterialsCalc': [],
                    'Sublet': [],
                    'Other': [],
                    'PDR': [],
                },
                removeEstimateParts: {
                    'RR': [],
                    'Repair': [],
                    'Paint': [],
                    'Part': [],
                    'Materials': [],
                    'Sublet': [],
                    'Other': [],
                    'PDR': [],
                },
                overrideIndex: -1, // override index in items list -> material tab -> total
                estimate_number: '',
                supplement_number: 0,
                parent_estimate_id: 0,
                drImageOptions: {
                    messages: {
                        'default': 'Drag and drop an image here or click to select it from your computer',
                        'replace': 'Drag and drop or click to add new image',
                        'remove': 'Remove',
                        'error': 'Ooops, something went wrong.'
                    }
                },
                drFilesOptions: {
                    messages: {
                        'default': 'Drag and drop a file here or click to select it from your computer',
                        'replace': 'Drag and drop or click to add new file',
                        'remove': 'Remove',
                        'error': 'Ooops, something went wrong.'
                    }
                },
                error: {
                    exists: false,
                    messages: []
                },
                pinImage: false,
                pinImagePage: false,
                assignedToUsers: [],
                assignedToUser: '',
                assignedTo: '',
                assignedToArr: [],
                assignedName: '',
                assignedToText: '',
                loaderAssignTo: false,
                resultSortingImages: {},
                uploadImageCategories: ['Uncategorised', 'Existing Damage', 'Accident Damage', 'Supplementary Damage',],
                fields: [
                    {
                        label: 'File Name',
                        key: 'name',
                        sortable: true,
                        tdClass: 'file-name',
                        thClass: 'file-name'
                    },
                    {
                        label: 'Uploaded By',
                        key: 'user',
                        sortable: true,
                        tdClass: 'uploaded-by',
                        thClass: 'uploaded-by'
                    },
                    {
                        label: 'Date',
                        key: 'sortDate',
                        sortable: true,
                        tdClass: 'uploaded-date',
                        thClass: 'uploaded-date'
                    },
                    {
                        label: 'File Size',
                        key: 'fileSize',
                        sortable: true,
                        tdClass: 'file-size',
                        thClass: 'file-size'
                    },
                    {
                        label: 'Action',
                        key: 'action',
                        tdClass: 'action',
                        thClass: 'action'
                    }
                ],
                cardsPerPage: 10,
                cardsCurrentPage: 1,
                topSticky: 0,
            }
  },
  beforeRouteLeave (to, from, next) {
    if (!_.isEmpty(this.updateData2)) {
      if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
        return
      }
    }
    this.$storage.remove('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView')
    next()
  },
  filters: {
    valuePDRMaterial: function (value) {
      if (value === 'PushToPaint') {
        return 'Push To Paint'
      }
      return value
    }
  },
  validations: {
    new_customer_email: {
      email,
    },
    new_insurer_email: {
      email,
    },
    card: {
      customer: {
        email: {
          email,
        }
      },
      contactEmail: {
        email,
      },
      insurance: {
        assessor_email: {
          email,
        }
      },
      vehicle: {
        rego_number: {
          required,
        },
        make: {
          required,
        },
        model: {
          required,
        },
      },
    }
  },
  methods: {
    ...mapActions([
      'clearFileIdsInCardEdit',
      'updateFiles',
      'unshiftFileInCardEdit',
      'setButterflyMatrixOrder',
      'addToButterflyCustomMatrix',
      'removeFromButterflyCustomMatrix'
    ]),
    pT (value) {
      return parseFloat(accounting.toFixed(parseFloat(value), 2))
    },
    checkUpdate () {
      Axios.get(`/fe/updater/estimate/${this.$route.params.estimate_id}/${this.lastTimestampImages}`)
          .then((response) => {
            this.lastTimestampImages = response.data._timestamp
            if (response.data._status && response.data._update && (response.data._update.images > 0 || response.data._update.deletedImages > 0)) {
              this.loadEstimate(this.$route.params.estimate_id, data => {
                this.images = data.images
              })
            }
            if (response.data._status && response.data._update && response.data._update.parts > 0) {
              let vm = this
              this.loadItemsList(this.estimate.id, function (items) {
                _.forEach(items, item => {
                  let currentItemList = _.find(vm.itemsList, (list) => {
                    return Number(list.id) === Number(item.id)
                  })
                  if (currentItemList && currentItemList.parts) {
                    for (let partType in currentItemList.parts) {
                      _.forEach(currentItemList.parts[partType], (part, index) => {
                        let newPart = _.find(item.parts[partType], nPart => {
                          return Number(nPart.id) === Number(part.id)
                        })
                        if (newPart && !_.isEqual(part.comments, newPart.comments)) {
                          vm.$set(currentItemList.parts[partType][index], 'comments', newPart.comments)
                        }
                      })
                    }
                  }
                })
              })
            }
          })
    },
    changedEmailAddress () {
      this.checkEmail2()
      this.autoUpdateContacts()
    },
    checkEmail () {
      if (this.card.contactEmail.includes('@')) {
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        this.isCheckedEmail = re.test(this.card.contactEmail)
      } else {
        this.isCheckedEmail = true
      }
    },
    checkEmail2 () {
      if (this.card.contactEmail === '' || !(this.card.contactEmail && this.card.contactEmail.trim())) {
        return
      }
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      this.isCheckedEmail = re.test(this.card.contactEmail)
    },
    setDefaultValues (rates) {
      let type = 'custom';
      if (rates) {
        this.estimate.rates.estimate_methodology = rates.estimate_methodology;
        this.estimate.rates.rr = rates.estimate_rates_rr ? rates.estimate_rates_rr : '0.00';
        this.estimate.rates.mechanical = rates.estimate_rates_rr ? rates.estimate_rates_mechanical : '0.00'
        this.estimate.rates.repair = rates.estimate_rates_repair ? rates.estimate_rates_repair : '0.00';
        if (!rates.estimate_rates_paint || !(this.estimate && this.estimate.rates && this.estimate.rates.paint_material)) {
          this.estimate.rates.paint = '0.00';
        } else {
          this.estimate.rates.paint = this.card.insurance.custom_paint_times[this.estimate.rates.paint_material.toLowerCase()] || 0
        }
      } else {
        type = this.estimate.rates.estimate_methodology.toLowerCase()
        this.estimate.rates.rr = this.defaultValues.rates[type].default_rates_rr
        this.estimate.rates.repair = this.defaultValues.rates[type].default_rates_repair
        this.estimate.rates.paint = this.defaultValues.rates[type].default_rates_paint
        this.estimate.rates.mechanical = this.defaultValues.rates[type].default_rates_mechanical
        if (type == 'ltar' || type == 'ntar') {
          this.estimate.rates.paint_material = this.defaultValues.rates[type].default_rates_paint_material;
        }
      }
      this.autoUpdateRates();
    },
    selectedEstimateMethodology () {
      let type = this.estimate.rates.estimate_methodology;
      if (!this.isDisabledRates) {
        this.estimate.rates.rr = this.defaultValues.rates[type].default_rates_rr;
        this.estimate.rates.repair = this.defaultValues.rates[type].default_rates_repair;
        this.estimate.rates.paint = this.defaultValues.rates[type].default_rates_paint;
        this.estimate.rates.mechanical = this.defaultValues.rates[type].default_rates_mechanical
      } else {
        if (!this.isDisabledRatesRR) {
          this.estimate.rates.rr = this.defaultValues.rates[type].default_rates_rr;
        }
        if (!this.isDisabledRatesRepair) {
          this.estimate.rates.repair = this.defaultValues.rates[type].default_rates_repair;
        }
        if (!this.isDisabledRatesPaint) {
          this.estimate.rates.paint = this.defaultValues.rates[type].default_rates_paint;
        }
      }

      if (type == 'ltar' || type == 'ntar') {
        this.estimate.rates.paint_material = this.defaultValues.rates[type].default_rates_paint_material;
      }
      this.autoUpdateRates()
    },
    selectedPaintMaterial () {
      this.backdoor
      if (this.isEstimateMethodologyCustom && this.isInsuranceRepairYes) {
        if (this.estimate.rates.paint_material == 'not_set' || !(this.estimate.rates.paint_material)) {
          this.estimate.rates.paint = 0;
        } else {
          this.estimate.rates.paint = this.card.insurance.custom_paint_times[this.estimate.rates.paint_material.toLowerCase()] || 0
        }
      }
      this.backdoor++
    },
    changedColour (col) {
      this.backdoor
      this.estimate.rates.paint_material = col
      this.autoUpdateRates()
      this.backdoor++
    },
    changedSubTabs (selectedTab) {
      this.selectedVehicleSubTab = selectedTab.tab.id
    },
    updateShowImportPdfParts (estimateId, status) {
      this.$set(this.allowShowImportPdfParts, estimateId, status)
    },
    copyToClipboard () {
      let item = document.createElement('textarea')
      document.body.appendChild(item)
      item.value = this.selectedText
      item.select()
      document.execCommand('copy')
      document.body.removeChild(item)
      this.$refs.rightClickMenuForPart.close()
    },
    openMenuForFiles: function (item, index, event) {
      if (!this.isStatusActive) {
        return
      }
      event.preventDefault()
      this.$refs.rightClickMenuForFiles.open(event, item)
    },
    totalParts: function (parts) {
      let result = 0
      if (parts['RR']) {
        result += parts['RR'].length
      }
      if (parts['Repair']) {
        result += parts['Repair'].length
      }
      if (parts['Paint']) {
        result += parts['Paint'].length
      }
      if (parts['Part']) {
        result += parts['Part'].length
      }
      if (parts['Materials']) {
        result += parts['Materials'].length
      }
      if (parts['Sublet']) {
        result += parts['Sublet'].length
      }
      if (parts['Other']) {
        result += parts['Other'].length
      }
      if (parts['PDR']) {
        result += parts['PDR'].length
      }

      return result
    },
    onClickSaveButton () {
      this.manualSave()
    },
    isEmpty (val) {
      return _.isEmpty(val)
    },
    saveNewTask: function (newTask) {
      let update = {}
      update.newTask = newTask
      this.setUpdateData(update)
      //this.autoSave();
      toastr.success('The New Task created')
      this.isOpenNewTaskForm = false
    },
    closeNewTask: function () {
      //this.isOpenNewTask = false;
      this.newTask = {}
      this.isOpenNewTaskForm = false
    },
    closeTask: function () {
    },
    deleteActivity: function (id, isEmail = false) {
      Axios.post('/fe/activity/delete',
          {
            'activityId': id
          }
      )
          .then(response => {
            if (response.data._status) {
              toastr.success('The Activity list entry deleted')
              let removedItem = _.filter(this.activity, function (item) {
                return item.activity_id == id
              })
              let index = this.activity.indexOf(removedItem[0])
              this.activity.splice(index, 1)
              if (isEmail) {
                this.$store.commit('dashboard/deleteEmail', id)
              }
            }
          })
          .catch(error => {
            console.log(error)
          })
    },
    deleteTask: function (task) {
      let update = {}
      update.task = task
      this.setUpdateData(update)
      this.$store.commit('dashboard/deleteTask', task.id)
      this.$store.commit('dashboard/deleteComment', task.id)
      //this.autoSave();
      toastr.success('The Task deleted')
    },
    saveTask: function (task) {
      let update = {}
      update.task = task
      this.setUpdateData(update)
      //this.autoSave();
      //task.newComment = null;
      toastr.success('The Task updated')
    },
    openNewTask: function () {
      const today = new Date()
      let month = ('0' + (today.getMonth() + 1)).slice(-2)
      let date = ('0' + today.getDate()).slice(-2)
      let year = today.getFullYear()

      this.newTask = {
        name: '',
        date: null,
        time: null,
        notes: '',
        type: { key: 'to-do', value: 'ToDo' },
        assignedTo: { id: '-1', name: 'Estimators' },
        status: { key: 'none', value: 'None' },
      }
      this.$refs['activity-tab-link'].click()
      this.isOpenNewTaskForm = true
    },
    importPdfForParts () {
      if (!_.isEmpty(this.updateData2)) {
        if (!confirm('Do you really want to perform this operation? Estimate has unsaved data')) {
          return
        }
      }
      NProgress.start()
      let estimateId = this.computedEstimateId
      let self = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(self.autoSave())
        }, 100)
      })
      promise.then(
          result => {
            NProgress.done()
            let estimate = this.getItemList(estimateId)
            self.$router.push({
              name: 'parseExternalPdf', params: {
                estimate_id: self.computedEstimateId, tab: self.currentTab, parentId: self.$route.params.estimate_id,
                dataForHeader: {
                  estimateNumber: estimate.supplement_number ? this.estimate_number + ' - ' + estimate.supplement_number : this.estimate_number,
                  ownerName: ' | ' + this.card.customer.name,
                  rego: ' | ' + this.showUpperRegoNumber,
                }
              }
            })
          })
    },
    addTemplateToEstimate (template) {
      // console.log('template', template);
      NProgress.start()
      Axios.post('/fe/estimate/' + this.computedEstimateId + '/apply-template/' + template.id)
          .then(response => {
            if (response.status === 200) {
              this.loadItemsList(this.estimate.id)
              toastr.success(template.name + ' template has been applied successfully')
            }
          })
          .catch(error => {
            toastr.error('The template could not be applied')
            console.log(error)
            NProgress.done()
          })

    },
    removeTemplateFromEstimate (templateId) {
      //console.log('templateId', templateId);
      NProgress.start()
      Axios.post('/fe/estimate/' + this.computedEstimateId + '/remove-template')
          .then(response => {
            if (response.status === 200) {
              this.loadItemsList(this.estimate.id)
              toastr.success('The template has been removed successfully')
              this.currentItemListId = this.$route.params.estimate_id
            }
          })
          .catch(error => {
            toastr.error('The template could not be removed')
            console.log(error)
            NProgress.done()
          })
    },
    addToCardFiles: function (file) {
      //  console.log(file);
      Axios.post(`/fe/estimate/changeFileAccess/` + file.id, { isCardAccess: true })
          .then(response => {
            if (response.status === 200) {
              toastr.success(response.data.msg)
              file.isCardAccess = true
            }
          })
          .catch(error => {
            console.log(error)
          })
    },
    removeFromCardFiles: function (file) {
      Axios.post(`/fe/estimate/changeFileAccess/` + file.id, { isCardAccess: false })
          .then(response => {
            if (response.status === 200) {
              toastr.success(response.data.msg)
              file.isCardAccess = false
            }
          })
          .catch(error => {
            console.log(error)
          })
    },

    addNote: function () {
      this.note_id = null
      this.note = ''
    },
    saveNote: function () {
      NProgress.start()
      let card_id = this.card_id
      let url = ''

      if (this.note_id == null) {
        url = '/fe/note'
      } else {
        url = `/fe/note/${this.note_id}`
      }
      Axios({
        method: 'post',
        responseType: 'json',
        url: url,
        validateStatus: function (status) {
          return status < 500
        },
        data: JSON.stringify({ note: this.note, card_id: card_id })
      })
          .then(response => {
            if (response.status == 200) {
              toastr.success(response.data.msg)
              if (this.note_id == null) {
                this.note_id = response.data.note_id
              }
              this.loadNotes()
            } else {
              toastr.error(response.data.msg)
            }
            NProgress.done()
          })
          .catch(error => {
            NProgress.done()
            toastr.error(error)
          })
    },
    addNewVehiclePaintCode: function (data) {
      this.newVehiclePaintCode = data
      this.estimate.rates.paint_material = ''
      this.isShowNewPaintColourNotification = true
      //   console.log('addNewVehiclePaintCode', data);
      this.$refs['estimate-details'].click()
      this.$refs['RatesPaintMaterial'].scrollIntoView({ block: 'center', inline: 'center' })
      let vm = this
      setTimeout(function () {
        vm.$refs['RatesPaintMaterial'].focus()
      }, 50)
    },
    changeNewPaintColourAfterSetPaintMaterial: function () {
      if (this.estimate.rates.paint_material != '' && this.isShowNewPaintColourNotification) {
        // console.log('changeNewPaintColourAfterSetPaintMaterial');
        let data = this.newVehiclePaintCode
        //console.log('newVehiclePaintCode', data);
        if (data.group == '') {
          data.group = this.estimate.rates.paint_material
          this.card.vehicle.colour = data.oem_paint_code + ' - ' + data.group
          this.isShowNewPaintColourNotification = false
          this.newVehiclePaintCode = {}
          this.vehiclePaintCodes.push(data)
          this.autoUpdateCardVehicle()
        }
      }
    },
    loadNotes: function () {
      let card_id = this.card.card_id
      Axios.get(`/fe/note/${card_id}`)
          .then(response => {
            this.notes = response.data
          })
          .catch(error => {
            NProgress.done()
          })
    },
    saveItemsList (estimateId, data) {
      if (!this.isAutoSave) {
        return
      }
      this.setUpdateData(data, estimateId)
      //  console.log('saveItemsList', estimateId);
    },
    setUpdateData: function (v, estimateId = null) {
      if (!this.isAutoSave) {
        return
      }
      if (!estimateId) {
        estimateId = this.estimate.id
      }
      //   console.log('setUpdateData', v, estimateId)
      let uid = Date.now().toString() + Math.random().toString(36).substr(2, 4)
      if (!this.isAutoSaveEnable && !(this.currentTab === 'notes' || this.currentTab === 'images' || this.currentTab === 'files' || this.currentTab === 'activity')) {
        if (!this.updateData2[estimateId]) {
          this.updateData2[estimateId] = {}
        }
        this.updateData2[estimateId][uid] = v
      } else {
        if (!this.updateData[estimateId]) {
          this.updateData[estimateId] = {}
        }
        this.updateData[estimateId][uid] = v
      }
      this.beforeDebouncedAutoSave()
    },
    labelVehiclePaintCode: function (t) {
      if (t.oem_paint_code == '-1') {
        return t.colour_name + ' - ' + t.group
      }
      return t.oem_paint_code + ' - ' + t.colour_name + ' - ' + t.group
    },
    changePaintMaterial: function (paint_material) {
      //console.log('paint material change', paint_material);
      this.estimate.rates.paint_material = paint_material
    },
    loadPaintCodes: function () {
      if (this.isEstimateMethodologyCustom) {
        console.log('not paint code')
        return false
      }
      let make = this.card.vehicle.make
      if (make != '') {
        Axios({
          method: 'get',
          responseType: 'json',
          url: `/fe/vehicle/paint-code/${make}`,
          validateStatus: function (status) {
            return status < 500
          },
        })
            .then(response => {
              if (response.status === 200) {
                this.vehiclePaintCodes = response.data
              }
            })
            .catch(error => {
              console.log('loadPaintCodes')
              console.log(error)
            })
      }
    },
    setDefaultEstimateRates: function () {
      this.estimate.rates.estimate_methodology = this.defaultValues.rates.default_rates_estimate_methodology
      this.estimate.rates.paint = this.defaultValues.rates.default_rates_paint
      this.estimate.rates.paint_material = this.defaultValues.rates.default_rates_paint_material
      this.estimate.rates.repair = this.defaultValues.rates.default_rates_repair
      this.estimate.rates.rr = this.defaultValues.rates.default_rates_rr
      this.estimate.rates.mechanical = this.defaultValues.rates.default_rates_mechanical
      this.autoUpdateRates()
    },
    paintMaterialNotificationCompleted: function () {
      this.isShowPaintMaterialNotification = true
      this.$refs.paintMaterialNotificationModal.hide()
      this.$refs['estimate-details'].click()
      if (this.$refs.RatesPaintMaterial) {
        this.$refs.RatesPaintMaterial.$el.scrollIntoView({ block: 'center', inline: 'center' })
        var vm = this
        setTimeout(function () {
          vm.$refs.RatesPaintMaterial.$el.focus()
        }, 50)
      }
    },
    showPaintMaterialNotification: function () {
      if (this.isShowPaintMaterialNotification || this.isEstimateMethodologyCustom || this.estimate.rates.paint_material !== 'not_set') {
        return
      }
      this.$refs.paintMaterialNotificationModal.show()
    },
    isZero: function (item) {
      if (item == 0 || item == '0' || item == '0.0' || item == '0.00') {
        return true
      }
      return false
    },
    onChangeCardProgress: function (id) {
      if (!this.isStatusActive) {
        return
      }
      this.card.card_status = id
      this.autoUpdateCardStatus()
    },
    tabEstimateChange (tab, itemListId = false) {
      if (itemListId) {
        this.currentItemListId = itemListId
      }
      this.currentTab = tab
      this.changeEstimentChapter = 'All'
      this.pinImagePage = true
      this.classTabContent = 'tab-content'
      this.isHiddenOptions = false
      this.isHiddenNewNote = true
      this.$storage.set('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView', tab)
    },
    vehicleDetailsTabChange () {
      this.currentTab = 'vehicleDetails'
      this.changeEstimentChapter = 'All'
      this.classTabContent = 'tab-content'
      this.isHiddenOptions = false
      this.isHiddenNewNote = true
      this.$storage.set('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView', 'vehicleDetails')
    },
    notesTabChange () {
      this.currentTab = 'notes'
      this.changeEstimentChapter = 'All'
      this.classTabContent = 'tab-content-table'
      this.isHiddenOptions = false
      this.isHiddenNewNote = false
      this.$storage.set('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView', 'notes')
    },
    imagesTabChange () {
      this.currentTab = 'images'
      this.changeEstimentChapter = 'Images'
      this.classTabContent = 'tab-content'
      this.isHiddenOptions = false
      this.isHiddenNewNote = true
      this.$storage.set('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView', 'images')
    },
    filesTabChange () {
      this.currentTab = 'files'
      this.changeEstimentChapter = 'Files'
      this.classTabContent = 'tab-content-table'
      this.isHiddenOptions = false
      this.isHiddenNewNote = true
      this.$storage.set('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView', 'files')
    },
    supplementsTabChange () {
      this.currentTab = 'supplements'
      this.changeEstimentChapter = 'All'
      this.classTabContent = 'tab-content-table'
      this.isHiddenOptions = false
      this.isHiddenNewNote = true
      this.$storage.set('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView', 'supplements')
    },
    activityTabChange () {
      this.currentTab = 'activity'
      this.changeEstimentChapter = 'All'
      this.classTabContent = 'tab-content'
      this.isHiddenOptions = false
      this.isHiddenNewNote = true
      this.$storage.set('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView', 'activity')
    },
    autoUpdateCardCustomerEmail: function (value) {
      this.card.customer.email = value
      this.$v.card.customer.email.$touch()
      this.autoUpdateCardCustomer()
    },
    autoUpdateCardCustomer: function () {
      if (this.$v.card.customer.$anyError) {
        this.showUnsavedChanges()
        return
      }
      let update = {}
      update.customer = this.card.customer
      update.customer_id = this.card.customer.customer_id
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    autoUpdateContacts: function () {
      let update = {}
      update.vehicleDriverName = this.card.vehicleDriverName
      update.contactNumber1 = this.card.contactNumber1
      update.contactNumber2 = this.card.contactNumber2
      update.contactEmail = this.card.contactEmail
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    autoUpdateBusinessABN: function (event) {
      let update = {}
      update.abn = this.card.customer.abn
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    autoUpdateCardStatus: function (event) {
      this.beforeDebouncedUnsavedChanges()
      this.updateCardProgressBar()
      let update = {}
      update.card_status = this.card.card_status
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    changedCardCustomerAddress: function (addr) {
      this.card.customer.address = addr['address']
      this.card.customer.level_unit_lot = addr['levelUnitLot']
      this.card.customer.street_name = addr['street_name']
      this.card.customer.suburb = addr['suburb']
      this.card.customer.state = addr['state']
      this.card.customer.postcode = addr['postcode']
      this.card.customer.country = addr['country']
      this.autoUpdateCardCustomer()
    },
    showActivityTab () {
      this.changeEstimentChapter = 'All'
      //this.$refs.cardProgress.changeTab(0, this.cardProgress.startIndex);
      //this.$refs.cardProgress.tabs.forEach((tab, i) => {
      //    if (i <= this.cardProgress.startIndex) {
      //        tab.active = true;
      //        tab.checked = true;
      //    } else {
      //        tab.active = false;
      //        tab.checked = false;
      //    }
      //});

      setTimeout(function () {
        let circlesNum = document.querySelectorAll('.wizard-nav-pills li').length
        document.getElementsByClassName('wizard-navigation')[0].style.width = 89.3 * circlesNum + 'px'
      }, 10)
    },
    updateCardProgressBar () {
      //this.showUnsavedChanges();
      this.card.statuses = []
      let currentStatusIndex = 0
      this.ceStatuses.forEach((ce_status, i) => {
        if (ce_status.ce_status_id.toString() === this.card.card_status) {
          currentStatusIndex = i
        }
      })
      let count = this.ceStatuses.length
      if (count > 0) {
        this.cardProgress.width = 'width: ' + (count * 89.3) + 'px'
        this.cardProgress.widthActivePercent = 'width: ' + (89.3 * (currentStatusIndex + 1) - 25) + 'px'
      } else {
        this.cardProgress.width = 'width: 0px'
        this.cardProgress.widthActivePercent = 'width: 0px'
      }

      this.cardProgress.startIndex = currentStatusIndex
      this.ceStatuses.forEach((ce_status, i) => {
        let status = {
          id: ce_status.ce_status_id,
          title: ce_status.name,
          active: false,
        }
        if (currentStatusIndex >= i) {
          status.active = true
          status.icon = 'ti-check'
        } else {
          status.active = false
          status.icon = ' '
        }
        this.card.statuses.push(status)
      })
      //this.autoSaveMessage = '';
      //this.showUnsavedChanges();
    },
    loadCEStatuses () {
      this.$store.dispatch('loadCEStatuses').then((res) => {
        if (res.status === 200) {
          this.ceStatuses = res.data
          this.updateCardProgressBar()
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    markAs: function (state) {
      let update = {}
      if (state == 0) {
        this.draft = 'Y'
        update.draft = 'Y'
      } else {
        this.draft = 'N'
        update.draft = 'N'
      }
      this.state = state
      update.state = state
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    markAsRead: function () {
      this.$store.dispatch('updateActivityViewedStatus', {
        card_id: this.card.card_id,
        viewed: 1
      })
      _.forEach(_.filter(this.activity, { 'viewed': '0' }), function (item) {
        item.viewed = '1'
      })
    },
    removeDraft: function () {

    },
    updateRRRepairPaint (type, data, estimate) {
      var vm = this
      estimate.parts[type].splice(0)
      setTimeout(() => {
        data.forEach(function (elem) {
          estimate.parts[type].push(elem)
        })
      }, 100)

    },
    updateRR: function (data, estimateId = false) {

      if (data) {
        if (!estimateId) {
          estimateId = this.estimate.id
        }
        let estimate = this.getItemList(estimateId)
        this.updateRRRepairPaint('RR', data, estimate)
      }
    },
    updateRepair: function (data, estimateId = false) {
      var vm = this
      if (data) {
        if (!estimateId) {
          estimateId = this.estimate.id
        }
        let estimate = this.getItemList(estimateId)
        this.updateRRRepairPaint('Repair', data, estimate)
      }
    },
    updatePaint: function (data, estimateId = false) {
      var vm = this
      if (data) {
        if (!estimateId) {
          estimateId = this.estimate.id
        }
        let estimate = this.getItemList(estimateId)
        this.updateRRRepairPaint('Paint', data, estimate)
      }
    },
    getItemList (estimateId) {
      return _.find(this.itemsList, function (i) {
        return Number(i.id) == Number(estimateId)
      })
    },
    updateCalculation: function (data, estimateId = false) {
      //  console.log('data',data)
      var vm = this
      if (!estimateId) {
        estimateId = this.estimate.id
      }
      let estimate = this.getItemList(estimateId)
      estimate.parts['Materials'] = []
      if (data && data.Materials) {
        this.$nextTick(() => {
          data.Materials.forEach(function (elem) {
            if (elem && elem.type && elem.type === 'calculation') {
              if (elem.id > 0) {
                elem.isOverrided = true
              }
            }
            estimate.parts['Materials'].push(elem)
          })
        })
      }

      estimate.parts['MaterialsCalc'] = []
      if (data && data.MaterialsCalc) {
        // this.estimateParts['MaterialsCalc'].splice(0);
        this.$nextTick(() => {
          data.MaterialsCalc.forEach(function (elem) {
            estimate.parts['MaterialsCalc'].push(elem)
          })
        })
      }
    },
    showUnsavedChanges: function () {
      this.autoSaveMessage = 'Unsaved Changes'
    },
    autoSave () {
      let vm = this
      _.forEach(this.updateData, function (data, key) {
        //console.log('!!!!', key, data);
        if (key && Number(key) > 0 && !_.isEmpty(data)) {
          let response = vm.saveData(key, data)
        }
      })
    },
    manualSave () {
      if (this.isAutoSaveEnable) {
        return
      }
      NProgress.start()
      let vm = this
      _.forEach(this.updateData2, function (data, key) {
        //console.log('!!!!', key, data);
        if (key && Number(key) > 0 && !_.isEmpty(data)) {
          let response = vm.saveData(key, data)
        }
      })
      NProgress.done()
    },
    saveData: function (estimateId, data) {
      if (_.isEmpty(data)) {
        return
      }
      // console.log('saveData', data)
      this.showPaintMaterialNotification()
      this.autoSaveMessage = 'Saving...'
      let vm = this
      return Axios({
        method: 'post',
        responseType: 'json',
        headers: { 'Autosave': true },
        url: `/fe/estimate/${estimateId}`,
        validateStatus: function (status) {
          return status < 500
        },
        data: data
      })
          .then(response => {
            if (response.status === 200) {
              this.autoSaveMessage = 'Saved'
              this.changedNameOfAssignedTo()
              // this.originalData = saveData;
              if (response.data.response.update.calculation) {
                this.updateCalculation(response.data.response.update.calculation, estimateId)
              }
              if (response.data.response.update.calculationOnlyNames) {
                // this.updateCalculation(response.data.response.update.calculationOnlyNames, true);
              }
              if (response.data.response.update.images) {
                this.images = response.data.response.update.images
              }
              if (response.data.response.update.files) {
                this.files = response.data.response.update.files
              }
              if (response.data.response.update.rr) {
                this.updateRR(response.data.response.update.rr, estimateId)
              }
              if (response.data.response.update.repair) {
                this.updateRepair(response.data.response.update.repair, estimateId)
              }
              if (response.data.response.update.paint) {
                this.updatePaint(response.data.response.update.paint, estimateId)
              }
              if (response.data.response.update.template_removed) {
                this.loadEstimate(this.estimate.id)
              }
              if (response.data.response.update.logActivity) {
                this.loadActivity()
              }
              if (response.data.response.update.isLoadItems) {
                this.loadTimesForItemPart()
                this.loadItemsList(this.estimate.id, function (items) {
                  _.forEach(items, function (item) {
                    vm.updateRR(item.parts.RR, item.id)
                    vm.updateRepair(item.parts.Repair, item.id)
                    vm.updatePaint(item.parts.Paint, item.id)
                    vm.updateCalculation({
                      Materials: item.parts.Materials,
                      MaterialsCalc: item.parts.MaterialsCalc
                    }, item.id)
                  })
                })
              }

              if (!this.isAutoSaveEnable && (this.currentTab === 'vehicleDetails' || this.currentTab.includes('itemList'))) {
                toastr.success('Estimate updated')
                if (_.isEmpty(this.updateData2[estimateId])) {
                  delete this.updateData2[estimateId]
                }
              }

              if (response.data.response && response.data.response.result) {
                _.forEach(response.data.response.result, function (val, k) {
                  if (vm.updateData && vm.updateData[estimateId] && vm.updateData[estimateId][k]) {
                    let s = delete vm.updateData[estimateId][k]
                  }
                  if (vm.updateData2 && vm.updateData2[estimateId] && vm.updateData2[estimateId][k]) {
                    let s = delete vm.updateData2[estimateId][k]
                  }
                })
              }

              if (_.isEmpty(this.updateData2[estimateId])) {
                delete this.updateData2[estimateId]
              }

              return response
            } else {
              this.autoSaveMessage = 'Unsaved Changes'
              return false
            }
          })
          .catch(error => {
            console.log(error)
            this.autoSaveMessage = 'Unsaved Changes'
            return false
          })
          .finally(() => {

          })
    },
    autoUpdateImage: function (event) {
      let update = {}
      update.image_ids = this.image_ids
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    autoUpdateFile: function (event) {
      let update = {}
      update.file_ids = this.file_ids
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    autoUpdateCardVehicle: function (event) {
      let update = {}
      update.vehicle = this.card.vehicle
      update.customer_id = this.card.customer.customer_id
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    autoUpdateVehicleTotalLoss: function (event) {
      if (this.card.isTotalLoss == 'true') {
        this.card.isTotalLoss = true
      }
      if (this.card.isTotalLoss == 'false') {
        this.card.isTotalLoss = false
      }
      let update = {}
      update.isTotalLoss = this.card.isTotalLoss
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    autoUpdateInsuranceAssessorEmail: function (value) {
      this.card.insurance.assessor_email = value
      this.$v.card.insurance.assessor_email.$touch()
      this.autoUpdateInsurance()
    },
    autoUpdateInsurance: function (event) {
      this.loadPaintCodes()
      if (this.$v.card.insurance.$anyError) {
        this.showUnsavedChanges()
        return
      }
      let update = {}
      update.insurance = this.card.insurance
      update.insurance_repair = this.card.insurance_repair
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    autoUpdatePaintMaterial: function () {
      if (this.isAutoSave) {
        let update = {}
        update.change_paint_material = this.estimate.rates.paint_material
        this.setUpdateData(update)
        this.autoUpdateRates()
        this.beforeDebouncedAutoSave()
      }
      if (this.isShowNewPaintColourNotification) {
        this.changeNewPaintColourAfterSetPaintMaterial()
      }
    },
    autoUpdateEstimateDateCreated: function () {
      let update = {}
      update.estimate = { dateCreated: this.estimate.dateCreated }
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    autoUpdateRates: function (event) {
      let update = {}
      update.estimateRates = this.estimate.rates
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },

    sctollToTop: function () {
      setTimeout(() => {
        document.getElementsByClassName('modal-dialog')[0].scrollIntoView()
        return true
      }, 100)
    },
    beforeImageSwitch: function () {
      // console.log('inside beforeImageSwitch')
      NProgress.start()
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if (this.count < 1) {
            this.count++
            reject('Please note that this is a Test environment and <strong>no actual emails will be sent</strong> to the customers yet. Click "Send" again to complete this wizard')
          } else {
            this.count = 0
            resolve(true)
          }
          NProgress.done()
        }, 1000)
      })
    },
    customerModalFormCompleted: function () {
      return
    },
    sendToCustomer: function () {
      this.$v.card.vehicle.$touch()
      if (!this.isInsuranceRepairOther && this.$v.card.vehicle.$anyError) {
        var vm = this
        toastr.error('An error occurred while sending the estimate. Customer information was found to be missing.')
        let missingErrorText = ''
        if (this.$v.card.vehicle.rego_number.$anyError) {
          setTimeout(function () {
            vm.$refs.errorTextCardVehicleRegoNumber.scrollIntoView({ block: 'center', inline: 'center' })
          }, 150)
          missingErrorText += '<li>Missing Vehicle Rego</li>'
        }
        if (this.$v.card.vehicle.make.$anyError) {
          setTimeout(function () {
            vm.$refs.errorTextCardVehicleMake.scrollIntoView({ block: 'center', inline: 'center' })
          }, 150)
          missingErrorText += '<li>Missing Vehicle Make</li>'
        }
        if (this.$v.card.vehicle.model.$anyError) {
          setTimeout(function () {
            vm.$refs.errorTextCardVehicleModel.scrollIntoView({ block: 'center', inline: 'center' })
          }, 150)
          missingErrorText += '<li>Missing Vehicle Model</li>'
        }
        if (missingErrorText != '') {
          toastr.error(missingErrorText)
        }
        return
      }

      if (!_.isEmpty(this.updateData2)) {
        if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
          return
        }
      }

      NProgress.start()
      let self = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(self.autoSave())
        }, 100)
      })
      promise.then(
          result => {
            NProgress.done()
            self.$router.push({
              name: 'sendToCustomer',
              params: { estimate_id: self.computedEstimateId, tab: self.currentTab }
            })
            //Axios.get(`/fe/estimate/to/customer/${estimate_id}`)
            //    .then(response => {
            //        self.estimateToCustomer = response.data;
            //
            //        self.customerContacts = Array({
            //            customer_name: response.data.customer.customer_name,
            //            email: response.data.customer.email
            //        });
            //
            //
            //        self.$refs.customerModal.show();
            //    })
            //    .catch(error => {
            //        toastr.error("Error occurred while loading estimate to customer info");
            //        // console.log(error)
            //        NProgress.done();
            //    });
          })
    },
    showPreADJEstimateModal: function () {

      if (!_.isEmpty(this.updateData2)) {
        toastr.error('Estimate has unsaved data')
        return

      }

      var self = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(self.autoSave())
        }, 1000)
      })

      promise.then(
          resolve => {
            NProgress.start()
            Axios.get(`/fe/estimate/to/customer/${this.computedEstimateId}/pre-adjusted`)
                .then(response => {
                  self.estimateToCustomer = response.data
                  if (self.estimateToCustomer && self.estimateToCustomer.line_items && self.estimateToCustomer.line_items.lines) {
                    let countSubtotal = 0
                    _.forEach(self.estimateToCustomer.line_items.lines, function (i) {
                      if (i.length > 0) {
                        countSubtotal++
                      }
                    })
                    self.estimateToCustomer.line_items.countSubtotal = countSubtotal
                  }

                  self.customerContacts = Array({
                    customer_name: response.data.customer.customer_name,
                    email: response.data.customer.email
                  })

                  NProgress.done()
                  self.$refs.previewADJPreEstimateModal.show()
                })
                .catch(error => {
                  toastr.error('Error occurred while loading estimate to customer info')
                  //  console.log(error)
                  NProgress.done()
                })
          }
      )
    },
    showPreviewEstimateModal: function () {

      if (!_.isEmpty(this.updateData2)) {
        toastr.error('Estimate has unsaved data')
        return

      }

      var self = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(self.autoSave())
        }, 1000)
      })

      promise.then(
          resolve => {
            NProgress.start()
            Axios.get(`/fe/estimate/to/customer/${this.computedEstimateId}`)
                .then(response => {
                  self.estimateToCustomer = response.data
                  if (self.estimateToCustomer && self.estimateToCustomer.line_items && self.estimateToCustomer.line_items.lines) {
                    let countSubtotal = 0
                    _.forEach(self.estimateToCustomer.line_items.lines, function (i) {
                      if (i.length > 0) {
                        countSubtotal++
                      }
                    })
                    self.estimateToCustomer.line_items.countSubtotal = countSubtotal
                  }
                  /**
                   * TODO: Remove This after backend supported for PDR
                   * manual added for FE work
                   */

                  //// add PDR data manually
                  //let PDRSubtotal = 0;
                  //// mapping current data
                  //const PDRParts = this.estimateParts['PDR'].map(part => {
                  //    PDRSubtotal += part.total * 1.1;
                  //    return {
                  //        gst: 10,
                  //        gst_amount: part.total * 0.1, // 20
                  //        gst_amount_str: `$${(Number(part.total) * 0.1).toFixed(2)}`, // "$20.00"
                  //        gst_str: "10.00%",
                  //        material: part.material.label,
                  //        action: part.action.label,
                  //        qty: 1,
                  //        qty_str: "",
                  //        name: part.name,
                  //        comment: part.comment,
                  //        price: part.price,
                  //        price_str: `$${part.price}.00`,
                  //        sub_total: part.total,
                  //        sub_total_str: `$${Math.floor(part.total * 1.1).toFixed(2)}`,
                  //        total: (Number(part.total) * 1.1).toFixed(2),
                  //        total_str: `$${Number(part.total * 1.1).toFixed(2)}`,
                  //        show_pdr_price: this.isVisibleToPDRTech,
                  //        type: part.type,
                  //    }
                  //});
                  //const PDRsubtotalStr = `$${Math.floor(PDRSubtotal).toFixed(2)}`;
                  //this.$set(self.estimateToCustomer.line_items.lines, 'PDR', PDRParts)
                  //this.$set(self.estimateToCustomer.line_items.summary, 'PDR-Total-SubTotal-Str', PDRsubtotalStr)
                  /** END manual added */

                  self.customerContacts = Array({
                    customer_name: response.data.customer.customer_name,
                    email: response.data.customer.email
                  })

                  NProgress.done()
                  self.$refs.previewEstimateModal.show()
                })
                .catch(error => {
                  toastr.error('Error occurred while loading estimate to customer info')
                  //  console.log(error)
                  NProgress.done()
                })
          }
      )
    },
    insurerModalFormCompleted: function () {
      //if (this.new_insurer_email) {
      //    this.addNewInsurerContact();
      //}
      //
      //let estimate_id = this.$route.params.estimate_id;
      //
      //NProgress.start();
      //Axios({
      //    method: 'post',
      //    responseType: 'json',
      //    url: `/fe/email/insurer/${estimate_id}`,
      //    validateStatus: function (status) {
      //        return status < 500;
      //    },
      //    data: JSON.stringify({
      //        insurers: this.insurerContacts,
      //        images: this.selectedImages,
      //    })
      //})
      //    .then(response => {
      //        if (response.status == 200) {
      //            toastr.success(response.data.msg);
      //            if (this.state == 0) {
      //                this.markAs(1);
      //            }
      //           // this.isSentToInsurer = true;
      //            this.$refs.insurerModal.hide();
      //        } else {
      //            toastr.error(response.data.msg);
      //        }
      //        NProgress.done();
      //    })
      //    .catch(error => {
      //        NProgress.done();
      //        toastr.error(error);
      //    });
    },
    sendToInsurer: function () {
      this.$v.card.vehicle.$touch()
      if (!this.isInsuranceRepairOther && this.$v.card.vehicle.$anyError) {
        toastr.error('An error occurred while sending the estimate. Insurer information was found to be missing.')
        let missingErrorText = ''
        if (this.$v.card.vehicle.rego_number.$anyError) {
          setTimeout(function () {
            vm.$refs.errorTextCardVehicleRegoNumber.scrollIntoView({ block: 'center', inline: 'center' })
          }, 150)
          missingErrorText += '<li>Missing Vehicle Rego</li>'
        }
        if (this.$v.card.vehicle.make.$anyError) {
          setTimeout(function () {
            vm.$refs.errorTextCardVehicleMake.scrollIntoView({ block: 'center', inline: 'center' })
          }, 150)
          missingErrorText += '<li>Missing Vehicle Make</li>'
        }
        if (this.$v.card.vehicle.model.$anyError) {
          setTimeout(function () {
            vm.$refs.errorTextCardVehicleModel.scrollIntoView({ block: 'center', inline: 'center' })
          }, 150)
          missingErrorText += '<li>Missing Vehicle Model</li>'
        }
        if (missingErrorText != '') {
          toastr.error(missingErrorText)
        }
        return
      }

      if (!_.isEmpty(this.updateData2)) {
        if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
          return
        }
      }

      NProgress.start()
      let self = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(self.autoSave())
        }, 100)
      })
      promise.then(
          result => {
            NProgress.done()
            self.$router.push({
              name: 'sendToInsurer',
              params: { estimate_id: self.computedEstimateId, tab: self.currentTab }
            })

          })
    },
    addNewInsurerContact: function () {
      if (!this.$v.new_insurer_email.email) {
        toastr.error('Your changes could not be saved, please check the form fields again')
        return
      }
      this.insurerContacts.push({
        insurer_name: this.new_insurer_name,
        // assessor_name: this.new_assessor_name,
        // assessor_email: this.new_assessor_email
        insurer_email: this.new_insurer_email
      })
      this.new_insurer_name = ''
      this.new_insurer_email = ''
      // this.new_assessor_name = ''
      // this.new_assessor_email = ''
    },
    goToSendToOrm: function() {
                if (!_.isEmpty(this.updateData2)) {
                    if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
                        return;
                    }
                }
                let estimate_id = this.$route.params.estimate_id;
                let vm = this;
                var promise = new Promise(function (resolve, reject) {
                    setTimeout(() => {
                        resolve(vm.autoSave());
                    }, 100);
                });
                promise.then(
                    result => {
                        vm.$router.push('/estimates/view/' + estimate_id + '/options/sendToORM');
                    });
                return;
            },
            goToSendToSuppliers: function () {
                if (!_.isEmpty(this.updateData2)) {
                    if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
                        return
        }
      }

      let vm = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(vm.autoSave())
        }, 100)
      })
      promise.then(
          result => {
            vm.$router.push({
              name: 'sendToSupplier',
              params: { estimate_id: vm.computedEstimateId, tab: vm.currentTab }
            })
          })
      return
    },
    goToSendToPartssearch: function () {
      if (!_.isEmpty(this.updateData2)) {
        if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
          return
        }
      }

      let vm = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(vm.autoSave())
        }, 100)
      })
      promise.then(
          result => {
            vm.$router.push({
              name: 'sendToPartssearch',
              params: { estimate_id: vm.computedEstimateId, tab: vm.currentTab }
            })
          })
      return
    },
    sendToClaimLinq: function () {
      if (!_.isEmpty(this.updateData2)) {
        if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
          return
        }
      }

      let vm = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(vm.autoSave())
        }, 100)
      })
      promise.then(
          result => {
            vm.$router.push({
              name: 'sendToClaimlinq',
              params: { estimate_id: vm.computedEstimateId, tab: vm.currentTab }
            })
          })
      return
    },
    onImageSelect: function (imgs) {
      // console.log(imgs)
      this.selectedImages = imgs
    },
    downloadEstimate: function (is_pre_adjusted = false) {
      let estimateId = this.estimate.id
      if (this.isSupplementItemListTab) {
        estimateId = this.currentItemListId
      }
      let token = localStorage.getItem('token')
      let url = appConfig.baseAPIURL + `/fe/pdf/estimate/${estimateId}`
      if (is_pre_adjusted) {
        url += '/pre-adjusted'
      }
      url += `?at=${token}`
      window.open(url)
      return
    },
    downloadPreAdjEstimate: function () {
      this.downloadEstimate(true)
      return
    },
    createSupplement: function () {
      Axios.post(`/fe/estimate/supplement/${this.$route.params.estimate_id}`)
          .then(response => {
            let suppEstimateId = response.data.estimate_id
            this.loadItemsList(this.$route.params.estimate_id, data => {
              let vm = this
              _.forEach(data, function (item) {
                if (Number(item.id) == Number(suppEstimateId)) {
                  vm.itemsList.push(item)
                  vm.currentTab = 'itemList' + suppEstimateId
                  vm.currentItemListId = suppEstimateId
                }
              })
            })
            toastr.success('Supplement estimate created')
          })
          .catch(error => {
            NProgress.done()
            toastr.error(error)
          })
          .finally(() => {
            NProgress.done()
          })
    },
    createInvoice: function () {
      let card_id = this.card_id

      if (!_.isEmpty(this.updateData2)) {
        if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
          return
        }
      }

      var self = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(self.autoSave())
        }, 1000)
      })
      promise.then(
          result => {
            self.$router.push(`/invoice/new/${card_id}`)
          })
    },
    createExcessInvoice: function () {
      let card_id = this.card_id

      if (!_.isEmpty(this.updateData2)) {
        if (!confirm('Do you really want to lose the page? Estimate has unsaved data')) {
          return
        }
      }

      var self = this
      var promise = new Promise(function (resolve, reject) {
        setTimeout(() => {
          resolve(self.autoSave())
        }, 1000)
      })
      promise.then(
          result => {
            self.$router.push(`/invoice/new/${card_id}/excess`)
          })
    },
    clickBrowse: function (id) {
      $(id).trigger('click')
    },
    clickCancelDropzoneImages: function (event) {
      event.preventDefault()
      this.$refs.imgUpDrop.removeAllFiles(true)
      this.image_ids = []
      this.image_categories = []
    },
    clickCancelDropzoneFiles: function () {
      this.$refs.fileUpDrop.removeAllFiles(true)
      this.file_ids = []
    },
    removeFileDropzone ($event) {
      let filesReplace = []

      this.files.forEach((file) => {
        if (!file.uuid) {
          filesReplace.push(file)
        } else if (file.uuid && file.uuid !== $event.upload.uuid) {
          filesReplace.push(file)
        }
      })
      this.files = filesReplace
    },
    sendImgUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].style.display = 'none'
    },
    sendFileUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].style.display = 'none'
      let reader = new FileReader()
      reader.onload = (e) => {
        let fileBase60Code = e.target.result
        this.addFile({
          name: $event.name,
          src: fileBase60Code,
          user: this.$store.state.userInfo.first_name + ' ' + this.$store.state.userInfo.last_name,
          date: '',
          uuid: $event.upload.uuid
        })
      }
      reader.readAsDataURL($event)
    },
    sendFileRemove: function (file) {
      NProgress.start()
      let url = '/fe/card/sendFileRemove'
      Axios({
        method: 'post',
        responseType: 'json',
        url: url,
        validateStatus: function (status) {
          return status < 500
        },
        data: { key: file.key, id: file.id, card_id: this.card_id }
      })
          .then(response => {
            if (response.status == 200) {
              // toastr.success(response.data.msg);

            } else {
              // toastr.error(response.data.msg);
            }
            NProgress.done()

          })
          .catch(error => {
            NProgress.done()
            toastr.error(error)
          })
    },
    remTableFile: function (id) {
      if (!this.isStatusActive) {
        return
      }
      const index = this.files.findIndex(file => file.id === id)
      const filename = this.files[index].name

      if (this.files[index].id) {
        this.$refs.fileUpDrop.dropzone.files.forEach((file, i) => {
          if (file.upload.uuid === this.files[index].uuid) {
            this.$refs.fileUpDrop.removeFile(file)
          }
        })

        if (this.files[index].id != null) {
          this.sendFileRemove(this.files[index])
        }
        this.files.splice(index, 1)
      }
      toastr.success(filename + 'has been deleted')
    },
    completeImgUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].removeAttribute('style')
    },
    completeFileUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].removeAttribute('style')
    },
    successAllImgUpload (files, response) {
      // console.log(files);
      //   console.log(response);
    },
    successImgUpload (file, response) {
      //console.log(response, 111);
      if (response.status) {
        this.image_ids.push(response.file_id)
        this.imagesAfterUpload.push({ id: response.file_id, file: file })
        this.autoUpdateImage()
        var vm = this
        setTimeout(function () {
          vm.$refs.imgUpDrop.removeFile(file)
        }, 1000)
      }
    },
    successFileUpload (file, response) {
      if (response.status) {
        this.file_ids.push(response.file_id)
        this.filesAfterUpload.push({ id: response.file_id, file: file })
        this.autoUpdateFile()
        var vm = this
        setTimeout(function () {
          vm.$refs.fileUpDrop.removeFile(file)
        }, 1000)
      }
    },
    addImgUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].style.display = 'none'
    },
    addFileUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].style.display = 'none'
    },
    deleteImage: function (data) {
      let correctItem = this.resultSortingImages[data.key].filter(_ => {
        return _.id === data.id
      })
      var filename = correctItem[0].name
      if (correctItem[0].id != null) {
        this.sendFileRemove(correctItem[0])
      }
      let findIndex = this.images.indexOf(correctItem[0])
      this.images.splice(findIndex, 1)
      toastr.success(filename + ' has been deleted')
    },
    //saveData: function (isDraft) {
    //    if (this.changeEstimentChapter === 'Images' && this.$refs.imgUpDrop.dropzone.files.length) {
    //        let vm = this.$refs.imgUpDrop;
    //        let files = this.$refs.imgUpDrop.dropzone.files;
    //
    //        if (!files.length) {
    //            vm.$emit('input', '');
    //            return;
    //        }
    //
    //        files.forEach((item, i) => {
    //            if (item.accepted) {
    //                this.addImage({
    //                    name: item.name,
    //                    src: item.dataURL,
    //                    user: this.$store.state.userInfo.first_name + ' ' + this.$store.state.userInfo.last_name,
    //                    date: ''
    //                });
    //            }
    //        });
    //    }
    //    let estimate_id = this.$route.params.estimate_id;
    //    // let obj = this
    //    if (this.validateForm()) {
    //        return;
    //    }
    //    this.files.forEach((file, i) => {
    //        if (file.uuid) {
    //            delete file.uuid;
    //        }
    //    });
    //    NProgress.start();
    //    Axios({
    //        method: 'post',
    //        responseType: 'json',
    //        url: `/fe/estimate/${estimate_id}`,
    //        validateStatus: function (status) {
    //            return status < 500;
    //        },
    //        data: JSON.stringify({
    //            estimate: this.estimate,
    //            card: this.card,
    //            parts: this.estimateParts,
    //            removeParts: this.removeEstimateParts,
    //            file_ids: this.file_ids,
    //            image_ids: this.image_ids,
    //            draft: isDraft,
    //            status: this.status,
    //            insurance: this.card.insurance,
    //            insurance_repair: this.card.insurance_repair
    //        })
    //    })
    //        .then(response => {
    //            if (response.status == 200) {
    //                if (isDraft == 'N') {
    //                    toastr.success('Estimate updated');
    //                    // this.$router.push('/estimates')
    //                } else {
    //                    toastr.success('Draft saved!');
    //                    // this.$router.push('/estimates/drafts')
    //                }
    //                this.removeEstimateParts = {
    //                    'RR': [],
    //                    'Repair': [],
    //                    'Paint': [],
    //                    'Part': [],
    //                    'Materials': [],
    //                    'Sublet': [],
    //                    'Other': [],
    //                    'PDR': []
    //                };
    //                this.loadEstimate(estimate_id);
    //                this.$refs.imgUpDrop.removeAllFiles(true);
    //                this.$refs.fileUpDrop.removeAllFiles(true);
    //                this.file_ids = [];
    //                this.image_ids = [];
    //
    //                // this.$router.push('/cards')
    //            } else {
    //                toastr.error(response.data.msg);
    //            }
    //            NProgress.done();
    //        })
    //        .catch(error => {
    //            NProgress.done();
    //            toastr.error(error);
    //        });
    //},
    loadCustomDirectory (type) {

    },
    loadTimesForItemPart: function () {
      if (this.isEstimateMethodologyCustom) {
        return
      }
      if (this.isLoadTimesForItemPart) {
        return
      }
      this.isLoadTimesForItemPart = true
      // if (!this.currentSeriesSheduleNumber) {
      //     return;
      // }
      NProgress.start()
      if (this.card.vehicle.body != '' && this.card.vehicle.series_shedule_number != '' && this.card.vehicle.series_shedule_number != 0) {
        var url = `/fe/parts/directory/${this.card.vehicle.series_shedule_number}/${this.card.vehicle.body}`
      } else {
        var url = `/fe/parts/directory/0`
      }
      Axios.get(url)
          .then(response => {
            this.timesForItemPart = response.data
            NProgress.done()
            this.isLoadTimesForItemPart = false
          })
          .catch(error => {
            console.log(error)
            NProgress.done()
            this.isLoadTimesForItemPart = false
          })
    },
    loadItemsList (estimateId, callBack = false) {
      NProgress.start()
      let vm = this
      Axios.get(`/fe/estimate/${estimateId}/items-list`)
          .then(response => {
            if (response.data && response.data._status) {
              if (callBack) {
                callBack(response.data.itemsList)
                return
              }
              vm.itemsList.splice(0)
              _.forEach(response.data.itemsList, function (item) {
                vm.itemsList.push(item)
                //console.log('push!!!');
              })
            }
          })
          .catch(error => {
            console.log(error)
          }).finally(() => {
        NProgress.done()
        this.isItemListLoaded = true
      })
    },
    autoSaveItemsList () {
      let estimateId = this.$route.params.estimate_id
      let data = []

      NProgress.start()
      Axios.post(`/fe/estimate/${estimateId}/items-list`)
          .then(response => {
            if (response.data && response.data._status) {
              this.itemsList = response.data.itemsList
            }
          })
          .catch(error => {
            console.log(error)
          }).finally(() => {
        NProgress.done()
      })

    },
    loadEstimate: function (estimateId, callbackToReturn = false) {
      NProgress.start()
      Axios.get(`/fe/estimate/${estimateId}`)
          .then(response => {
            if (response.data.estimate && response.data.estimate.parent_estimate_id && Number(response.data.estimate.parent_estimate_id) > 0) {
              this.$router.push('/estimates/view/' + Number(response.data.estimate.parent_estimate_id))
              return
            }
            if (callbackToReturn) {
              callbackToReturn(response.data)
              return
            }
            this.estimateAmount = response.data.estimate
            this.card = response.data.card
            this.invoice = response.data.invoice
            this.excess_invoice = response.data.excess_invoice

            this.assignedToUser = response.data.card.assignedTo.name
            this.assignedToArr = response.data.users
            this.assignedToUsers = response.data.users

            this.files = response.data.files
            this.images = response.data.images
            //this.estimateParts = response.data.parts;
            this.estimate = response.data.estimate
            this.estimate.rates = response.data.rates
            this.isVisibleToPDRTech = response.data.estimate.isVisibleToPDRTech
            this.defaultValues.rates = response.data.default_rates
            this.estimate_number = response.data.estimate_number
            this.supplement_number = response.data.supplement_number
            this.parent_estimate_id = response.data.parent_estimate_id
            this.card_id = response.data.card_id
            this.card.card_number = response.data.card_number
            this.draft = response.data.draft
            this.booking_date = response.data.booking_date
            this.completion_date = response.data.completion_date
            this.status = response.data.status
            this.insurers = response.data.insurers
            this.assessors = response.data.assessors
            this.properties = response.data.properties
            this.boardDeparture = response.data.boardDeparture
            this.boardIn = response.data.boardIn
            this.iagOrmItems = response.data.iagOrmItems;
            //ToDo turn off
            //this.$refs.rr.setValue(this.estimate.rates.rr);
            //this.$refs.repair.setValue(this.estimate.rates.repair);
            //this.$refs.paint.setValue(this.estimate.rates.paint);
            //this.$refs.partmarkup.setValue(this.estimate.rates.partmarkup);

            this.selectedVehicleMake = this.card.vehicle.make
            this.selectedVehicleModel = this.card.vehicle.model

            //  this.updateCalculation(Object.assign({}, response.data.parts));
            this.checkEmail2()
            this.loadCEStatuses()
            this.loadPaintCodes()
            this.loadNotes()
            this.loadItemsList(estimateId)
            //NProgress.done();

            //if (this.supplement_number === 0) {
            //    this.loadSupplements();
            //}

            this.loadTimesForItemPart()
            var vm = this
            setTimeout(function () {
              vm.showPaintMaterialNotification()
              vm.isAutoSave = true
            }, 500)

            // REMOVE THIS - FOR TESTING ONLY
            //this.$set(this.estimateParts, 'PDR', []);
            //this.$set(this.removeEstimateParts, 'PDR', []);

          })
          .catch(error => {
            toastr.error('Estimate error')
            console.log(error)
            this.$router.push('/estimates')
          }).finally(() => {
        NProgress.done()
      })
    },
    //loadSupplements: function () {
    //    let estimate_id = this.$route.params.estimate_id;
    //    Axios.get(`/fe/estimate/supplement/${estimate_id}`)
    //        .then(response => {
    //            this.supplements = response.data;
    //            if (!_.isEmpty((this.currentItemList))) {
    //                //update supp
    //                let self = this;
    //                let supp = _.find(response.data, function (s) {
    //                    return s.estimate_id == self.currentItemList.estimate_id;
    //                });
    //                this.currentItemList = supp;
    //                console.log(this.currentItemList, 'currentSupp');
    //            } else if (_.isEmpty(this.currentItemList) && this.isItemListTab) {
    //                let suppNum = this.currentTab.split('supplementItemsList')[1];
    //                let self = this;
    //                let supp = _.find(this.supplements, function (supp) {
    //                    let index = self.supplements.indexOf(supp) + 1;
    //                    return index == suppNum;
    //                });
    //                this.currentItemList = supp;
    //            }
    //        })
    //        .catch(error => {
    //            toastr.error("Error occurred while loading supplements");
    //            console.log(error, 'supp error');
    //            NProgress.done();
    //        });
    //},
    loadActivity (sort_type) {
      const estimate_id = this.$route.params.estimate_id
      let payload = { estimate_id: estimate_id }
      if (sort_type) {
        payload.sort_type = sort_type
      }
      this.$store.dispatch('loadEstimateActivity', payload).then(response => {
        if (response.status === 200) {
          this.activity = response.data
        } else if (response.status === 400) {
          toastr.error(response.data.msg)
        } else {
          toastr.warning(response.data.msg)
        }
      }).catch(error => {
        toastr.error('Error occurred while loading estimate activity')
        console.log(error)
        NProgress.done()
      })
    },
    addImage: function (img) {
      // console.log(img)
      if (img.src == '' || img.src === undefined || img.src === null) {
        return
      } else {
        this.images.unshift(img)
        this.newImageAdded = true
      }
    },
    addFile: function (file) {
      if (file.src == '' || file.src === undefined || file.src === null) {
        return
      } else {
        this.files.unshift(file)
        this.newFileAdded = true
      }
    },
    validateForm: function () {
      this.error.messages = []
      let status = false

      if (this.error.messages.length > 0) {
        status = false
      } else {
        status = true
      }
      this.error.exists = !status

      return status
    },
    onCustomerSelect: function (c) {
      // console.log(c)
      this.card.customer.customer_id = c.customer_id
      this.card.customer.name = c.customer_name
      this.card.customer.address = c.address
      this.card.customer.level_unit_lot = c.level_unit_lot
      this.card.customer.street_name = c.street_name
      this.card.customer.suburb = c.suburb
      this.card.customer.state = c.state
      this.card.customer.postcode = c.postcode
      this.card.customer.country = c.country
      this.card.customer.mobile = c.mobile
      this.card.customer.phone = c.phone
      this.card.customer.fax = c.fax
      this.card.customer.email = c.email

      this.card.vehicle.customer_vehicle_id = c.customer_vehicle_id
      this.card.vehicle.rego_number = c.rego_number
      this.card.vehicle.make = c.make
      this.card.vehicle.model = c.model
      this.card.vehicle.series = c.series
      this.card.vehicle.colour = c.colour
      this.card.vehicle.colour_variant = c.colour_variant
      this.card.vehicle.vin = c.vin

      // this.showCustomerSearchBox = false
    },
    onInsurerSelect: function (i) {
      if (i === null) {
        this.card.insurance.insurer_id = null
        this.card.insurance.insurer_location = ''
        this.estimate.rates.estimate_methodology = 'custom'
      } else {
        this.card.insurance.insurer_name = i.insurer_name
        this.card.insurance.insurer_id = i.insurer_id
        this.card.insurance.insurer_location = i.insurer_location
        if (i.rates.estimate_methodology) {
          this.estimate.rates.estimate_methodology = i.rates.estimate_methodology
        }
        if (i.rates.estimate_rates_rr) {
          this.estimate.rates.rr = i.rates.estimate_rates_rr
        }
        if (i.rates.estimate_rates_repair) {
          this.estimate.rates.repair = i.rates.estimate_rates_repair
        }
        if (i.rates.estimate_rates_paint) {
          this.estimate.rates.paint = i.rates.estimate_rates_paint
        }
        if (i.rates.estimate_rates_mechanical) {
          this.estimate.rates.mechanical = i.rates.estimate_rates_mechanical
        }
      }
      this.card.insurance.assessor_name = ''
      this.card.insurance.assessor_email = ''
      this.card.insurance.assessor_phone = ''
      this.autoUpdateRates()
    },
    onAssessorSelect: function (a) {
      if (a === null) {
        this.card.insurance.insurer_assessor_id = null
        this.card.insurance.assessor_email = ''
        this.card.insurance.assessor_phone = ''
      } else {
        this.card.insurance.insurer_assessor_id = a.insurer_assessor_id
        this.card.insurance.assessor_name = a.assessor_name
        this.card.insurance.assessor_email = a.assessor_email
        this.card.insurance.assessor_phone = a.assessor_phone
      }
    },
    getFocus: function (el) {
      if (el) {
        document.getElementById(el).focus()
      }
    },
    dismissError: function () {
      this.error.exists = false
    },
    refreshItemsList: function () {
      //   console.log(this.cardSubParts);
    },
    replyActivity (index) {
      const refIndex = 'activityReplyMessageRef' + index
      if (this.$refs[refIndex]) {
        this.$refs[refIndex][0].showReplyMessage(false)
      }
    },
    replyToAllActivity (index) {
      const refIndex = 'activityReplyMessageRef' + index
      if (this.$refs[refIndex]) {
        this.$refs[refIndex][0].showReplyMessage(true)
      }
    },
    changeActivitySortBy (sort_by) {
      this.activitySortTypeText = sort_by
      this.card.sort_type = sort_by
      this.loadActivity(sort_by)
    },

    beforeDebouncedAutoSave: function () {
      if (!this.isAutoSave || (!this.isAutoSaveEnable && (this.currentTab === 'vehicleDetails' || this.currentTab.includes('itemList')))) {
        console.log('return from debounce')
        return
      }
      this.debouncedAutoSave()
    },
    beforeDebouncedUnsavedChanges: function () {
      if (!this.isAutoSave || (!this.isAutoSaveEnable && (this.currentTab === 'vehicleDetails' || this.currentTab.includes('itemList')))) {
        return
      }
      this.debouncedUnsavedChanges()
    },
    assignedToOpen () {
      if (!this.isStatusActive) {
        return
      }
      setTimeout(() => {
        document.addEventListener('click', (e) => {
          if (!e.target.closest('.filterAssigned') && !e.target.closest('.openfilterTarget') && this.$refs.AssignedfilterRef) {
            this.$refs.AssignedfilterRef.classList.remove('openFilterAssigned')
          }
        })
      }, 0)
      this.$refs.AssignedfilterRef.classList.add('openFilterAssigned')
    },
    changeAssignedName (elem) {
      let update = {}
      this.loaderAssignTo = true
      update.assignedTo = { id: elem.id }
      this.assignedToText = elem.name
      this.$refs.AssignedfilterRef.classList.remove('openFilterAssigned')
      this.setUpdateData(update)
      this.beforeDebouncedAutoSave()
    },
    changedNameOfAssignedTo () {
      this.loaderAssignTo = false
      this.assignedToUser = this.assignedToText
    },
    handleItemRead: function (el) {
      const activityTabLink = this.$refs['activity-tab-link']
      if (activityTabLink && activityTabLink.classList.contains('active')) {
        const isChecked = el.target.checked ? 1 : 0
        this.$store.dispatch('updateActivityViewedStatus', {
          activity_id: el.target.id,
          card_id: this.card.card_id,
          viewed: isChecked
        })
      }
    },
    replaceCharAtCategories: function (elem) {
      return (elem.split(' ').length > 1) ?
          elem.split(' ').map(_ => _.replace(_.charAt(0), _.charAt(0))).join(' ').replace(/ /g, '_') : elem
      //elem.split(' ').map(_ => _.replace(_.charAt(0), _.charAt(0).toLowerCase())).join(' ').replace(/ /g, '_') : elem.toLowerCase()
    },
    updateImageCategory: function (info) {
      if (!info) {
        return
      }
      this.beforeDebouncedUnsavedChanges()
      let update = {}
      if (info.imgInfo) {
        let key = _.findIndex(this.image_categories, { file_id: info.imgInfo.id })
        if (key >= 0) {
          this.image_categories[key] = {
            file_id: info.imgInfo.id,
            category: info.categoryName,
          }
        } else {
          this.image_categories.push({
            file_id: info.imgInfo.id,
            category: info.categoryName,
          })
        }
        update.imageCategories = this.image_categories
      }
      if (info.imagesSort) {
        update.imagesSort = info.imagesSort
      }
      this.setUpdateData(update)
      //console.log('updateImageCategory', update)
      this.beforeDebouncedAutoSave()
    },
    removeSupplement: function () {
      let sid = this.computedEstimateId
      Axios.post(`/fe/estimate/supplement/${sid}/remove`)
          .then((response) => {
            if (response.data && response.data._status) {
              this.tabEstimateChange('itemList' + (this.estimate.id), this.estimate.id)
              let index = _.findIndex(this.itemsList, function (i) {
                return i.id == sid
              })
              console.log('index.remove.supplement', index)
              if (index != -1) {
                this.itemsList.splice(index, 1)
              }
              this.$refs.deleteSuppModal.hide()
              toastr.success('Supplement was removed successfully')
            }
          })
          .catch(error => {
            console.log(error)
          }).finally(() => {
        NProgress.done()
      })
    },

    saveAsTemplate () {
      let name = this.searchTemplateInput
      Axios.post(`/fe/estimate/${this.$route.params.estimate_id}/save-as-template`, { name })
          .then(response => {
            if (response.data && response.data._status) {
              toastr.success(`Template "${name}" has been created`)
              this.searchTemplateInput = ''
              sessionStorage.selectedTemplateId = response.data.templateId
            } else {
              toastr.error('Woops! Something went wrong')
              console.log('SaveAsTemplate Response: ', response.data)
            }
          }).catch(e => {
        toastr.error('Error: ' + e)
        console.error(e)
      }).finally(() => {
        this.loadEstimateTemplates()
      })
    },
    calculateTopSticky () {
      const tabsComponent = this.$refs.tabsComponent
      const pageHeader = document.querySelector('.page-header')
      const pageHeaderHeight = pageHeader ? pageHeader.offsetHeight : 75
      if (tabsComponent) {
        // site-header + page-header + tabs-component
        this.topSticky = 60 + pageHeaderHeight + this.$refs.tabsComponent.offsetHeight
      } else {
        // default
        this.topSticky = 0
      }
    },
    updateHeightOptionsMenu (event) {
      if (document.body.offsetHeight < 900) {
        this.heightOptions = document.body.offsetHeight - event.clientY - 30
      }
    },
  },
  computed: {
    ...mapGetters({
      addressStates: 'addressStates',
      addressCountries: 'addressCountries',
      isTechnicalUser: 'isTechnicalUser',
      isCustomerUser: 'isCustomerUser',
      isEstimatorUser: 'isEstimatorUser',
      isPDRTechnicianUser: 'isPDRTechnicianUser',
      isShopManagerUser: 'isShopManagerUser',
      isProductionManagerUser: 'isProductionManagerUser',
      butterflyCategories: 'butterflyCategories',
      butterflyMatrix: 'butterflyMatrix',
      butterflyCustomMatrix: 'butterflyCustomMatrix',
      butterflySubcategories: 'butterflySubcategories',
      butterflyBodies: 'butterflyBodies',
      butterflyMatrixOrder: 'butterflyMatrixOrder',
      getterActiveUsers: 'activeUsers',
      getterVisibleUsers: 'visibleUsers',
      isStatusActive: 'isStatusActive',
      getterBusinessName: 'getBusinessName',
      isRsEnabled: 'isRsEnabled',
      customerVehicles: 'getAllCustomers',
    }),
    isDisabledRates() {
      return this.properties.isFromIag && this.properties.isRatesEditable === false;
    },
    isDisabledRatesRR() {
      return (this.properties.isFromIag && this.properties.isRatesRREditable === false);
    },
    isDisabledRatesRepair() {
      return this.properties.isFromIag && this.properties.isRatesRepairEditable === false;
    },
    isDisabledRatesPaint() {
      return this.properties.isFromIag && this.properties.isRatesPaintEditable === false;
    },
    isSmsAvailable() {
      return this.properties.isSmsFeatureEnabled;
    },
    computedEstimateMethodologies () {
      let em = this.estimateMethodologies.slice()
      if (this.isRsEnabled) {
        em.push({ key: 'rs', value: 'RS' })
      }
      return em
    },
    boardInId () {
      if (this.boardIn && this.boardIn.id) {
        return this.boardIn.id
      }
      return ''
    },
    boardDepartureId () {
      if (this.boardDeparture && this.boardDeparture.id) {
        return this.boardDeparture.id
      }
      return ''
    },
    isShowImportPdfForParts () {
      return Boolean((this.isShopManagerUser || this.isProductionManagerUser || this.isEstimatorUser || this.isCustomerUser)
          && this.isItemListTab
          && this.allowShowImportPdfParts[this.computedEstimateId] === true)
    },
    orderedItemsList () {
      return _.orderBy(this.itemsList, ['type', 'supplementNumber'], ['asc', 'asc'])
    },
    computedTimesForItemPart () {
      return this.timesForItemPart
    },
    isItemListTab () {
      return this.currentTab.includes('itemList')
    },
    isEstimateItemList () {
      let itemsList = this.getItemList(this.currentItemListId)
      return !!(this.isItemListTab && itemsList && itemsList.type == 'estimate')
    },
    isSupplementItemListTab () {
      return !!(this.isItemListTab && !this.isEstimateItemList)
    },
    computedTemplateId () {
      if (this.isItemListTab) {
        let itemsList = this.getItemList(this.currentItemListId)
        if (!_.isEmpty(itemsList)) {
          return itemsList.templateId
        }
      }
      return 0
    },
    isHasTemplates () {
      let itemsList = this.getItemList(this.currentItemListId)
      return !!(this.isItemListTab && itemsList && itemsList.templateId > 0)
    },
    computedEstimateId () {
      let estimateId = this.estimate.id

      if (this.isSupplementItemListTab) {
        estimateId = this.currentTab.split('itemList')[1]
        //estimateId = this.itemsList[Number(index) - 1].id;
      }
      return estimateId
    },
    computedEstimateAmount () {
      let result = 0
      let vm = this
      _.forEach(this.itemsList, function (supp) {
        if (supp.amount) {
          result += vm.pT(supp.amount)
          // console.log('computedEstimateAmount.forEach', result, parseFloat(supp.amount), vm.pT(supp.amount), supp.amount)
        }
      })
      //let gst = _.round((result * 0.1),2);
      //result = (gst+result);
      return result
    },
    isShowSaveButtonInCurrentTab () {
      return true
    },
    isAutoSaveEnable () {
      if (this.properties && this.properties.hasOwnProperty('isAutoSave')) {
        return this.properties.isAutoSave
      }
      return true
    },
    computedActiveUsers () {
      if (!this.filterAssignTo || this.filterAssignTo == '') {
        let users = this.getterVisibleUsers.slice()
        users.unshift({
          id: null,
          name: 'None',
          groupId: null,
          group_id: null,
          isActive: true,
          isVisible: true,
          lastName: null,
          firstName: null,
          role: null,
        })
        return users
      }
      let self = this
      let filterUsers = _.filter(this.getterVisibleUsers, function (user) {
        let search = []
        search.push(_.toLower(user.name))
        return !!(search.join(',').indexOf(_.toLower(self.filterAssignTo)) > -1)
      })
      return filterUsers
    },
    isRSEstimateMethodology () {
      this.backdoor++
      return !!(this.isRsEnabled && this.estimate && this.estimate.rates && this.estimate.rates.estimate_methodology && this.estimate.rates.estimate_methodology == 'rs')
    },
    computedEstimateMethodology: {
      get: function () {
        this.backdoor
        let vm = this
        try {
          let item = _.find(this.computedEstimateMethodologies, function (itm) {
            return itm.key.toLowerCase() === vm.estimate.rates.estimate_methodology.toLowerCase()
          })
          return item
        } catch (e) {
          return { key: 'custom', value: 'Custom' }
        }
      },
      set: function (item) {
        this.estimate.rates.estimate_methodology = item.key
        this.backdoor++
      },
    },
    computedCustomerState: {
      get: function () {
        let vm = this
        try {
          let item = _.find(this.addressStates, function (itm) {
            return itm.key === vm.card.customer.state
          })
          return item
        } catch (e) {
          return {}
        }
      },
      set: function (item) {
        this.card.customer.state = item.key
      },
    },
    computedCustomerCountry: {
      get: function () {
        let vm = this
        try {
          let item = _.find(this.addressCountries, function (itm) {
            return itm.key === vm.card.customer.country
          })
          return item
        } catch (e) {
          return []
        }
      },
      set: function (item) {
        this.card.customer.country = item.key
      },
    },
    isInsuranceRepairYes: function () {
      if (this.card.insurance_repair == 'true') {
        return true
      }
      return false
    },
    isShowPaintRateForCustomMethodology: function () {
      return !!(this.isEstimateMethodologyCustom && this.isInsuranceRepairYes)
    },
    isInsuranceRepairNo: function () {
      if (this.card.insurance_repair == 'false') {
        return true
      }
      return false
    },
    isInsuranceRepairOther: function () {
      if (this.card.insurance_repair == 'other' || this.card.insurance_repair == '2') {
        return true
      }
      return false
    },
    isNoNeedVehicleRego: function () {
      if (this.isInsuranceRepairOther) {
        return true
      }
      return false
    },
    showUpperRegoNumber: {
      get: function () {
        return _.toUpper(this.card.vehicle.rego_number)
      },
      set: function (rego) {
        this.card.vehicle.rego_number = _.toUpper(rego)
      }
    },
    totalNotes: function () {
      return this.notes.length
    },
    showButtonInHeaderForInsurerModal: function () {

    },
    isEstimateMethodologyCustom: function () {
      this.backdoor
      if (this.estimate.rates.estimate_methodology == 'custom') {
        return true
      }
      return false
    },
    isInsurance: function () {
      if (this.card.insurance_repair === 'true') {
        return true
      }
      return false
    },
    isExcess: function () {
      if (this.isInsurance) {
        if (this.card.insurance.excess > 0) {
          return true
        }
        return false
      }
    },
    isTotalLoss: function () {
    },
    isShowMarkAsRead () {
      if (_.find(this.activity, { 'viewed': '0' })) {
        return true
      }
      return false
    },
    isShowRedMessageForBody: function () {
      if (this.computedBodies && this.computedBodies.length > 0 && this.card.vehicle.body === '') {
        return true
      }
      return false
    },
    isShowRedBorderForPaintMaterial: function () {
      if (this.isShowPaintMaterialNotification && !this.isShowRedBorderIfNewPaintColour && !this.isEstimateMethodologyCustom && this.estimate.rates.paint_material === 'not_set') {
        return true
      }
      return false
    },
    isShowRedBorderIfNewPaintColour: function () {
      if (this.isShowNewPaintColourNotification) {
        return true
      }
      return false
    },
    currentSeriesSheduleNumber: function () {
      if (this.card.vehicle.series_shedule_number) {
        return this.card.vehicle.series_shedule_number
      } else {
        return this.computedSheduleNumber
      }

      return null
    },
    imageSource: function () {
      let _uncategoriesArr = [],
          _dataObj = {}
      Array.from(this.uploadImageCategories).forEach(el => {
        _dataObj[this.replaceCharAtCategories(el)] = []
      });
      [].slice.call(Array.from(this.images)).forEach((el, ind) => {
        if (!el.hasOwnProperty('category') || !el.category || this.replaceCharAtCategories(el.category) === 'Uncategorised') {
          _uncategoriesArr.push(el)
          _dataObj.Uncategorised = _uncategoriesArr
        } else {
          let _categReplace = this.replaceCharAtCategories(el.category)
          _dataObj[_categReplace].push(el)
        }
      })
      this.resultSortingImages = _dataObj

      return this.resultSortingImages
    },
    estimateStatus: function () {
      if (this.cardProgress && this.cardProgress.startIndex && this.ceStatuses) {
        let name = this.ceStatuses[this.cardProgress.startIndex].name
        return name
      }
      return ''
    },
    totalImages: function () {
      return this.images.length
    },
    totalFiles: function () {
      return this.files.length
    },
    totalSupplements: function () {
      return this.supplements.length
    },
    selectedCardPartsCount: function () {
      return this.estimateParts[this.selectedCard].length
    },
    customers: function () {
      return this.$store.state.customers
    },
    insurerAssessors: function () {
      try {
        if (this.card.insurance.insurer_id) {
          return this.assessors[this.card.insurance.insurer_id]
        }
        return []
      } catch (erro) {
        return []
      }
    },

    vendorInfo: function () {
      return this.$store.state.vendorInfo
    },
    userInfo: function () {
      return this.$store.state.userInfo
    },
    fromFiles: function () {
      if (!this.files) return 0
      else return (this.cardsCurrentPage - 1) * this.cardsPerPage + 1
    },

    toFiles: function () {
      const toFiles = (this.cardsCurrentPage - 1) * this.cardsPerPage + this.cardsPerPage
      if (toFiles > this.totalFiles) return this.totalFiles
      return toFiles
    },

    showClaimLinqButton: function () {
      let val = (
          this.card.insurance.insurer_id
          && (this.isShopManagerUser || this.isProductionManagerUser || this.isEstimatorUser)
      )

      // console.log("INSURER: " + this.card.insurance.insurer_id + ', VAL: ' + (val ? 'true' : 'false'));

      return val
    },
  },
  watch: {
    file_ids: function () {
      this.beforeDebouncedUnsavedChanges()
    },
    image_ids: function () {
      this.beforeDebouncedUnsavedChanges()
    },
    image_categories: function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.name': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.mobile': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.email': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.customer_type': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.abn': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.address': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.level_unit_lot': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.street_name': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.suburb': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.state': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.postcode': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer.country': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.customer_contact_2': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.dom': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.rego_number': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.make': function () {
      this.loadTimesForItemPart()
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.model': function () {
      this.loadTimesForItemPart()
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.badge': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.series': function () {
      this.loadTimesForItemPart()
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.series_shedule_number': function () {
      console.log('test.series_shedule_number', this.card.vehicle.series_shedule_number)
      this.loadTimesForItemPart()
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.colour': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.body': function () {
      this.loadTimesForItemPart()
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.vin': function () {
      this.loadTimesForItemPart()
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.odometer': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.complianceDate': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.vehicle.transmission': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance_repair': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.id': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.insurance_claim_type': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.insurer_id': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.insurer_name': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.insurer_location': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.insurer_assessor_id': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.assessor_name': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.assessor_email': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.assessor_phone': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.policy_number': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.claim_number': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.assessment_date': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.excess': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.contribution': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.discount': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.market_value': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.agreed_value': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.statuses': function () {
      this.beforeDebouncedUnsavedChanges()
    },
    'card.insurance.rates': {
      deep: true,
      handler (newVal, oldVal) {
        if (!this.isAutoSave) {
          return
        }
        console.log('card.insurance.rates', newVal, oldVal)
        this.estimate.rates.estimate_methodology = _.toLower(this.card.insurance.rates.estimate_methodology)
        this.estimate.rates.rr = this.card.insurance.rates.estimate_rates_rr || 0
        this.estimate.rates.mechanical = this.card.insurance.rates.estimate_rates_mechanical || 0
        this.estimate.rates.repair = this.card.insurance.rates.estimate_rates_repair || 0
        if (_.toLower(this.card.insurance.rates.estimate_methodology) === 'custom') {
          if (this.estimate.rates.paint_material == 'not_set' || !(this.estimate.rates.paint_material)) {
            this.estimate.rates.paint = 0
          } else {
            this.estimate.rates.paint = this.card.insurance.custom_paint_times[this.estimate.rates.paint_material.toLowerCase()] || 0
          }
        } else {
          this.estimate.rates.paint = this.card.insurance.rates.estimate_rates_paint || 0
        }
        this.backdoor++
        this.autoUpdateRates()
      }
    },
    'estimate.rates.estimate_methodology': function () {
      if (!this.isAutoSave) {
        return
      }
      console.log('wather.methodology', this.estimate.rates.estimate_methodology)
      if (!this.isEstimateMethodologyCustom) {
        this.loadTimesForItemPart()
      }
      this.beforeDebouncedUnsavedChanges()
    },
    'estimate.rates.rr': function () {
      if (!this.isAutoSave) {
        return
      }
      this.beforeDebouncedUnsavedChanges()
    },
    'estimate.rates.mechanical': function () {
      if (!this.isAutoSave) {
        return
      }
      this.beforeDebouncedUnsavedChanges()
    },
    'estimate.rates.repair': function () {
      if (!this.isAutoSave) {
        return
      }
      this.beforeDebouncedUnsavedChanges()
    },
    'estimate.rates.paint': function () {
      if (!this.isAutoSave) {
        return
      }
      this.beforeDebouncedUnsavedChanges()
    },
    'estimate.rates.partmarkup': function () {
      if (!this.isAutoSave) {
        return
      }
      this.beforeDebouncedUnsavedChanges()
    },
    'estimate.rates.paint_material': function () {
      console.log('UPD!!')
      console.log(this.estimate.rates.paint_material)
      if (_.toLower(this.card.insurance.rates.estimate_methodology) === 'custom') {
        if (this.estimate.rates.paint_material == 'not_set' || !(this.estimate.rates.paint_material)) {
          this.estimate.rates.paint = 0
        } else {
          this.estimate.rates.paint = this.card.insurance.custom_paint_times[this.estimate.rates.paint_material.toLowerCase()] || 0
        }
      }

      if (!this.isAutoSave) {
        return
      }
      this.autoUpdatePaintMaterial()
      this.beforeDebouncedUnsavedChanges()
    },
    backdoor () {
      console.log('backdoor UPD')
      if (!this.isAutoSave) {
        return
      }
      this.autoUpdatePaintMaterial()
      this.beforeDebouncedUnsavedChanges()
    },
    //'estimate.dateCreated': function (newVal) {
    //    if (!this.isAutoSave) {
    //        return;
    //    }
    //    if (newVal) {
    //        this.autoUpdateEstimateDateCreated();
    //        this.beforeDebouncedUnsavedChanges();
    //    }
    //},
  },
  beforeDestroy () {
    if (this.intervalUpdateImages !== null) {
      clearInterval(this.intervalUpdateImages)
    }
  },
  mounted: function () {
    this.loadItemsList(this.$route.params.estimate_id)
    if (this.$route.params.tab) {
      this.currentTab = this.$route.params.tab
    } else if (!_.isEmpty(this.$storage.get('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView'))) {
      this.currentTab = this.$storage.get('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView')
    }
    if (this.currentTab.includes('itemList')) {
      this.currentItemListId = this.currentTab.split('itemList')[1]
    }
    this.loadEstimate(this.$route.params.estimate_id)
    this.loadActivity()
    if (this.customerVehicles.length == 0) {
      this.$store.dispatch('loadCustomerVehicles')
    }
    this.$store.dispatch('loadVehiclesForCustom')

    let params = this.$route.params
    this.$nextTick(() => {
      if (params && params.action && params.action == 'goToTask') {
        this.activityTabChange()
      }
    })

    this.intervalUpdateImages = setInterval(() => {
      this.checkUpdate()
    }, 5000)

    this.calculateTopSticky()
    window.addEventListener('resize', this.calculateTopSticky)
  },
  unmounted () {
    window.removeEventListener('resize', this.calculateTopSticky)
  },
  created: function () {
    this.debouncedAutoSave = _.debounce(this.autoSave, 500)
    this.debouncedUnsavedChanges = _.debounce(this.showUnsavedChanges, 100)
  },
  components: {
    ItemList,
    EstimateSupplements,
    FileUploader,
    ImageLightbox,
    SiteFooter,
    NumberFormatter,
    AdvancedSearch,
    ImageSelector,
    DatePicker,
    draggable,
    AmazonAds,
    ActivityReplyMessage,
    vueDropzone: vue2Dropzone,
    VueContext,
    GoogleLocation,
    FormWizard,
    TabContent,
    WizardStep,
    Multiselect,
    ActivityList,
    CardNotes,
    CardFiles,
    InsuranceBlock,
    VehicleBlock,
    RsFormWizard,
    SmallFormWizard,
    RsRipple,
    BlockPagination,
    AdvertBanner,
  }
}
</script>

<template>
  <div class="estimates-edit-page" :class="{'is-mobile-only': isMobileOnly}">
    <div class="page-header">
      <h4>Edit Estimate - {{ estimate_number }} <span v-if="supplement_number">-{{ supplement_number }}</span> <span
          class="text-muted"> | </span> {{ card.customer.name }} <span
          class="text-muted"> | </span>
        {{ showUpperRegoNumber }}
        <!--                <span class="autosave" v-if="isAutoSaveEnable || !(currentTab === 'vehicleDetails' || currentTab.includes('itemList')">{{autoSaveMessage}}</span></h4>-->
        <span class="autosave" v-if="isAutoSaveEnable">{{ autoSaveMessage }}</span></h4>
      <ol class="breadcrumbs">
        <li class="breadcrumb-item">
          <router-link to="/">Home</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link :to="'/estimates'">View Estimates</router-link>
        </li>
        <li v-if="parent_estimate_id" class="breadcrumb-item">
          <router-link :to="'/estimates/view/' + parent_estimate_id">{{ estimate_number }}</router-link>
        </li>
        <li class="breadcrumb-item active">Edit Estimate</li>
      </ol>
      <h4 class="header-display-name">{{ getterBusinessName }}</h4>
      <div class="desktop-b-promo-block estimare-header-b-promo">

      </div>
      <div v-if="!isMobile" class="page-header-nav-pin-images">
        <label class="form-check-inline checkbox"
               v-b-tooltip.hover="{customClass: 'ps-tooltip', title:'Click to view images', placement:'left'}">
          <input class="form-check-input" name="pinimage" v-model="pinImage" type="checkbox">
          <span class="icon"><i class='bx bx-check'></i></span><span class="text">Pin Images</span>
        </label>
      </div>
      <div v-if="!isHiddenOptions" class="page-header-nav-options">
        <div class="navbar-nav nav dropdown dropdown-options  show inline">
          <button type="button"
                  class="btn waves-effect waves-light ex-options-button"
                  id="dropdownMenuLink1" data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                  @click="updateHeightOptionsMenu($event)">Options
            <span class="dropdown-arrow  pull-right" style="
                                                  box-sizing: border-box;
                                                  width: 32px;
                                                  border-left: 1px solid rgba(27,30,56,0.25);
                                                  "> <i class="fa fa-chevron-down pull-right"></i>
                                                </span>
          </button>
          <div class="dropdown-menu dropdown-menu-right animated fadeInUp" aria-labelledby="dropdownMenuLink1"
               :style="{'max-height': heightOptions + 'px'}" :class="{'options-menu-height': heightOptions != ''}">
            <a v-if="isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser"
               @click="showPreviewEstimateModal" class="dropdown-item">
              {{ isSupplementItemListTab ? 'Preview Supplement' : 'Preview Estimate' }}</a>
            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isInsuranceRepairYes"
               @click="showPreADJEstimateModal" class="dropdown-item">
              {{ isSupplementItemListTab ? 'Print Pre-ADJ Supplement' : 'Print Pre-ADJ Estimate' }}</a>
            <a v-if="isStatusActive" @click="addNote" data-toggle="modal" data-target="#noteBoxModal"
               class="dropdown-item">Add Note</a>
            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && !isHasTemplates && isStatusActive"
               class="dropdown-item has-child" @click="addTemplate">
              <span>Add Template</span>
              <div class="dropdown-menu-child">
                <input type="text" placeholder="Search" autofocus v-model="searchTemplateInput">
                <ul v-if="templates.length" type="none">
                  <li v-for="(template, index) of filteredTemplates" :key="template.id">
                    <a href="#">{{ template.name }}</a>
                  </li>
                </ul>
                <ul type="none" v-else>
                  <li>Loading...</li>
                </ul>
              </div>
            </a>
            <a v-else-if="isStatusActive" class="dropdown-item" @click="removeTemplateFromEstimate(computedTemplateId)">
              Remove Template</a>
            <a v-if="properties.isFromIag" @click.prevent="goToSendToOrm" class="dropdown-item">Send To ORM</a>
                        <a v-if="isShowImportPdfForParts && isStatusActive" class="dropdown-item"
               @click="importPdfForParts">Import Pricing</a>
            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isStatusActive"
               @click="goToSendToSuppliers" class="dropdown-item"> Send To Supplier</a>
            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && properties.isCanSendToPartssearch && isStatusActive"
               @click="goToSendToPartssearch" class="dropdown-item"> Send To
              PartsSearch</a>
            <a v-if="showClaimLinqButton && properties.isCanSendToClaimlinq && isStatusActive" @click="sendToClaimLinq"
               class="dropdown-item"> Send To ClaimLinq</a>
            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && isInsuranceRepairYes && isStatusActive"
               @click="sendToInsurer" class="dropdown-item"> Send To Insurance</a>
            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isStatusActive"
               @click="sendToCustomer" class="dropdown-item"> Send To Customer</a>
            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isStatusActive"
               @click="createSupplement" class="dropdown-item"> Add Supplement</a>
            <!--                        <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && state != 0" @click="markAs(0)" class="dropdown-item"> Mark As Draft</a>-->
            <!--                        <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && state != 1" @click="markAs(1)" class="dropdown-item"> Mark As Sent</a>-->
            <!--                        <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && state != 2" @click="markAs(2)" class="dropdown-item"> Mark As On Hold</a>-->
            <!--                        <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && state != 3" @click="markAs(3)" class="dropdown-item"> Mark As Closed</a>-->
            <a v-if="isStatusActive" @click="openNewTask" class="dropdown-item text-primary p-1 clickable">Add New
              Task</a>
            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isShowMarkAsRead && isStatusActive"
               @click="markAsRead" class="dropdown-item"> Mark As Read</a>
            <a v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser) && invoice.id > 0"
               @click="createInvoice" class="dropdown-item"> Go To Invoice</a>
            <a v-else-if="(isShopManagerUser|| isProductionManagerUser || isCustomerUser) && isStatusActive"
               @click="createInvoice" class="dropdown-item"> Create Invoice</a>
            <a v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser) && isExcess && excess_invoice.id > 0"
               @click="createExcessInvoice" class="dropdown-item"> Go To Excess
              Invoice</a>
            <a v-else-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser) && isExcess && isStatusActive"
               @click="createExcessInvoice" class="dropdown-item"> Create Excess Invoice</a>
            <a v-if="isSupplementItemListTab && (isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isStatusActive"
               @click="$refs.deleteSuppModal.show()"
               class="dropdown-item">Delete Supplement</a>
          </div>
        </div>
      </div>
    </div>
    <div class="box-block bg-white">
      <div class="row">
        <div>
          <div class="estimates-edit">
            <div ref="tabsComponent" class="tabs-component" :class="{'is-mobile-only': isMobileOnly}">
              <ul class="nav nav-tabs nav-tabs-2 float-sm-left rs-scroll rs-scroll--x hide-scrollbar"
                  :class="{'is-mobile-only': isMobileOnly}">
                <li class="tabs-component-tab nav-item" role="tablist">
                  <a :class="{'active': currentTab === 'vehicleDetails'}" class="tabs-component-tab-a nav-link"
                     @click="vehicleDetailsTabChange()" data-toggle="tab"
                     href="#estimate-details" ref="estimate-details" role="tab">
                    Vehicle Details
                  </a>
                </li>
                <li class="tabs-component-tab nav-item">
                  <a :class="{'active': currentTab === 'notes'}" class="tabs-component-tab-a nav-link "
                     @click="notesTabChange()"
                     data-toggle="tab" href="#card-notes" role="tab"
                     style="min-width: 95px;"
                  >
                    Notes
                    <span v-if="totalNotes" class="tag tag-info">{{ totalNotes }}</span>
                  </a>
                </li>
                <li v-if="!isItemListLoaded"
                    class="tabs-component-tab nav-item">
                  <a @click="tabEstimateChange('itemList'+$route.params.estimate_id, $route.params.estimate_id)"
                     class="tabs-component-tab-a nav-link clickable"
                     data-toggle="tab" role="tab"
                     style="min-width: 145px;">
                    EST-Items List
                  </a>
                </li>
                <li v-else
                    v-for="(itemList, itemIndex) in orderedItemsList"
                    :key="'itemListKey'+itemList.id"
                    class="tabs-component-tab nav-item">
                  <template v-if="itemList.type == 'estimate'">
                    <a :class="{'active': currentTab === 'itemList'+(itemList.id)}"
                       @click="tabEstimateChange('itemList'+(itemList.id), itemList.id)"
                       class="tabs-component-tab-a nav-link clickable"
                       data-toggle="tab"
                       role="tab"
                       style="min-width: 145px;">
                      EST-Items List
                      <span v-if="totalParts(itemList.parts)"
                            class="tag tag-info">{{ totalParts(itemList.parts) }}</span>
                    </a>
                  </template>
                  <template v-else>
                    <a :class="{'active': currentTab === 'itemList'+(itemList.id)}"
                       @click="tabEstimateChange('itemList'+(itemList.id), itemList.id)"
                       class="tabs-component-tab-a nav-link clickable"
                       data-toggle="tab"
                       role="tab">
                      SUPP-Items List {{ itemList.supplementNumber }}
                      <span v-if="totalParts(itemList.parts)"
                            class="tag tag-info">{{ totalParts(itemList.parts) }}</span>
                    </a>
                  </template>
                </li>
                <li class="tabs-component-tab nav-item">
                  <a :class="{'active': currentTab === 'images'}" class="tabs-component-tab-a nav-link"
                     @click="imagesTabChange()"
                     data-toggle="tab" href="#upload-images" role="tab"
                     style="min-width: 103px;">
                    Images
                    <span v-if="totalImages" class="tag tag-info">{{ totalImages }}</span>
                  </a>
                </li>
                <li class="tabs-component-tab nav-item">
                  <a :class="{'active': currentTab === 'files'}" class="tabs-component-tab-a nav-link"
                     @click="filesTabChange"
                     data-toggle="tab" href="#upload-files" role="tab"
                     style="min-width: 88px;">
                    Files
                    <span v-if="totalFiles" class="tag tag-info">{{ totalFiles }}</span>
                  </a>
                </li>
                <!--                                <li v-if="supplement_number === 0" class="tabs-component-tab nav-item">-->
                <!--                                    <a :class="{'active': currentTab === 'supplements'}" class="tabs-component-tab-a nav-link" @click="supplementsTabChange" data-toggle="tab" href="#supplements"-->
                <!--                                       role="tab">-->
                <!--                                        Supplements-->
                <!--                                        <span v-if="totalSupplements" class="tag tag-info">{{totalSupplements}}</span></a>-->
                <!--                                </li>-->
                <li class="tabs-component-tab nav-item">
                  <a :class="{'active': currentTab === 'activity'}" id="activity-tab"
                     class="tabs-component-tab-a nav-link" @click="activityTabChange" data-toggle="tab"
                     href="#activity" role="tab" ref="activity-tab-link">
                    Activity
                  </a>
                </li>
                <li class="tabs-component-tab nav-item  mobile-hide">
                  <a class="tabs-component-tab-a nav-link openfilterTarget pr-0" style="cursor:pointer"
                     @click="assignedToOpen()">Assigned To: {{
                      (!assignedToUser || assignedToUser === 'None') ? '' :
                          assignedToUser
                    }}
                    <img v-if="loaderAssignTo" class="loaderAssignTo" src="../../assets/img/wait.gif" alt="loading"></a>
                  <div class="filterAssigned" ref="AssignedfilterRef">
                    <input type="text" placeholder="Search" v-model="filterAssignTo">
                    <ul type="none">
                      <li @click="changeAssignedName(elem)" v-for="elem in computedActiveUsers">
                        {{ elem.name }}
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="mobile-pin-images" v-if="isStatusActive">
                  <label class="form-check-inline checkbox">
                    <input class="form-check-input" name="pinimage" v-model="pinImage" type="checkbox">
                    <span class="icon"><i class='bx bx-check'></i></span><span class="text">Pin Images</span>
                  </label>
                </li>
              </ul>
              <div class="rs-btn-group tab-header float-sm-right mt-1-sm additional-padding-btn">

                <!--
                                                                <div :class="!isHiddenOptions ? 'tabs-absolute-right' : 'tabs-absolute-right-notes-btn'">
                                                                        <label class="pin-image">
                                                                            <input type="checkbox" name="pinimage" v-model="pinImage">
                                                                            <span class="pin-checkmark"></span>
                                                                        </label>
                                                                </div>
                                  -->
                <div class="tabs-nav-right-btn" v-if="isStatusActive">
                  <label class="form-check-inline checkbox"
                         v-b-tooltip.hover="{customClass: 'ps-tooltip', title:'Click to view images', placement:'left'}">
                    <input class="form-check-input" name="pinimage" v-model="pinImage" type="checkbox">
                    <span class="icon"><i class='bx bx-check'></i></span><span class="text">Pin Images</span>
                  </label>
                </div>
                <div
                    v-if="!isAutoSaveEnable && (currentTab === 'vehicleDetails' || currentTab.includes('itemList')) && isStatusActive"
                    class="tabs-nav-right-btn">
                  <button @click="onClickSaveButton" type="button"
                          class="btn btn-primary w-min-sm waves-effect waves-light"
                          style="margin-right:5px">Save
                  </button>
                </div>
                <!-- <div v-if="!isHiddenNewNote" class="tabs-nav-right-btn">
                                    <button @click="addNote" data-toggle="modal" data-target="#noteBoxModal" type="button"
                                            class="btn btn-primary w-min-sm waves-effect waves-light mr-2">
                                        <i class="ti-plus"></i><span> New Note</span>
                                    </button>
                                </div> -->
                <div v-if="!isHiddenOptions || (!isShopManagerUser && !isProductionManagerUser && !isEstimatorUser)"
                     class="tabs-nav-right-options">
                  <div class="navbar-nav nav dropdown dropdown-options  show inline">
                    <button type="button"
                            class="btn waves-effect waves-light ex-options-button"
                            id="dropdownMenuLink" data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="true"
                            @click="updateHeightOptionsMenu($event)">Options
                      <span class="dropdown-arrow  pull-right" style="
                                                  box-sizing: border-box;

                                                  width: 32px;
                                                  border-left: 1px solid rgba(27,30,56,0.25);
                                                  "> <i class="fa fa-chevron-down pull-right"></i>
                                                </span>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right animated fadeInUp" aria-labelledby="dropdownMenuLink"
                         :style="{'max-height': heightOptions + 'px'}"
                         :class="{'options-menu-height': heightOptions != ''}">
                      <a v-if="isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser"
                         @click="showPreviewEstimateModal" class="dropdown-item">
                        {{ isSupplementItemListTab ? 'Preview Supplement' : 'Preview Estimate' }}</a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser)  && isInsuranceRepairYes"
                         @click="showPreADJEstimateModal" class="dropdown-item">
                        {{ isSupplementItemListTab ? 'Print Pre-ADJ Supplement' : 'Print Pre-ADJ Estimate' }}</a>
                      <a v-if="isStatusActive" @click="addNote" data-toggle="modal" data-target="#noteBoxModal"
                         class="dropdown-item">Add Note</a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && !isHasTemplates && isStatusActive"
                         class="dropdown-item has-child"
                         @click="addTemplate">
                        <span>Add Template</span>
                        <!-- <i class="fa fa-angle-right additional-menu-icon"></i> -->
                        <div class="dropdown-menu-child">
                          <input class="searchInput" type="text" placeholder="Search" autofocus
                                 v-model="searchTemplateInput">
                          <ul v-if="templates.length" class="addTemplateList" type="none">
                            <li v-for="(template, index) of filteredTemplates" :key="template.id">
                              <a @click="addTemplateToEstimate(template)" href="#">{{ template.name }}</a>
                            </li>
                          </ul>
                          <ul type="none" v-else>
                            <li><a>Loading...</a></li>
                          </ul>
                        </div>
                      </a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && isStatusActive"
                         class="dropdown-item has-child">
                        <span>Save As Template</span>
                        <!-- <i class="fa fa-angle-right additional-menu-icon"></i> -->
                        <div class="dropdown-menu-child" style="width: 300px">
                          <h6 style="margin: 0 10px 10px">Create New Name</h6>
                          <input style="width: calc(100% - 20px)" type="text" placeholder="New Name" autofocus
                                 v-model="searchTemplateInput">
                          <div style="padding: 10px">
                            <button :disabled="!searchTemplateInput" @click="saveAsTemplate" class="pull-right"
                                    style="border: none; background: #3E70C9; color: white; font-size: 10px; padding: 3px 10px;">
                              Save
                            </button>
                          </div>
                          <ul v-if="templates.length" class="saveAsTemplateList" type="none">
                            <li style="padding: 10px 10px 6px"><span>Existing templates</span></li>
                            <li class="li-in-save-as-template" style="padding: 2px 10px; color: #373A3C;"
                                v-for="(template, index) of filteredTemplates" :key="template.id">
                              <span>{{ template.name }}</span>
                            </li>
                          </ul>
                          <ul type="none" v-else>
                            <li><a>Loading...</a></li>
                          </ul>
                        </div>
                      </a>
                      <a v-if="isShowImportPdfForParts && isStatusActive"
                         class="dropdown-item"
                         @click="importPdfForParts">Import Pricing</a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && isHasTemplates && isStatusActive"
                         class="dropdown-item"
                         @click="removeTemplateFromEstimate(computedTemplateId)">Remove Template</a>
                      <a v-if="properties.isFromIag" @click.prevent="goToSendToOrm" class="dropdown-item">Send To ORM</a>

                                            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isStatusActive "
                         @click="goToSendToSuppliers" class="dropdown-item"> Send To
                        Supplier</a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && properties.isCanSendToPartssearch && isStatusActive"
                         @click="goToSendToPartssearch"
                         class="dropdown-item"> Send To PartsSearch</a>
                      <a v-if="showClaimLinqButton && properties.isCanSendToClaimlinq && isStatusActive"
                         @click="sendToClaimLinq" class="dropdown-item"> Send To ClaimLinq</a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && isInsuranceRepairYes && isStatusActive"
                         @click="sendToInsurer" class="dropdown-item"> Send To
                        Insurer</a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isStatusActive"
                         @click="sendToCustomer" class="dropdown-item"> Send To
                        Customer</a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isStatusActive"
                         @click="createSupplement" class="dropdown-item"> Add
                        Supplement</a>
                      <!--                                            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && state != 0" @click="markAs(0)" class="dropdown-item"> Mark As Draft</a>-->
                      <!--                                            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && state != 1" @click="markAs(1)" class="dropdown-item"> Mark As Sent</a>-->
                      <!--                                            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && state != 2" @click="markAs(2)" class="dropdown-item"> Mark As On Hold</a>-->
                      <!--                                            <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser) && state != 3" @click="markAs(3)" class="dropdown-item"> Mark As Closed</a>-->
                      <a v-if='isStatusActive' @click="openNewTask" class="dropdown-item text-primary p-1 clickable">Add
                        New Task</a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isShowMarkAsRead && isStatusActive"
                         @click="markAsRead" class="dropdown-item">
                        Mark As Read</a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser) && invoice.id > 0"
                         @click="createInvoice" class="dropdown-item"> Go To Invoice</a>
                      <a v-else-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser) && isStatusActive"
                         @click="createInvoice" class="dropdown-item"> Create Invoice</a>
                      <a v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser) && isExcess && excess_invoice.id > 0"
                         @click="createExcessInvoice"
                         class="dropdown-item"> Go To
                        Excess Invoice</a>
                      <a v-else-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser)  && isExcess && isStatusActive"
                         @click="createExcessInvoice" class="dropdown-item"> Create
                        Excess Invoice</a>
                      <a v-if="isSupplementItemListTab && (isShopManagerUser || isProductionManagerUser || isEstimatorUser || isCustomerUser) && isStatusActive"
                         @click="$refs.deleteSuppModal.show()" class="dropdown-item">Delete Supplement</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="error.exists" class="alert alert-danger-outline alert-dismissible fade in ma-1-25 mb-0"
                 role="alert">
              <button type="button" @click="dismissError()" class="close" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <strong>Error!</strong> please fix following before submitting the form,
              <ul>
                <li v-for="msg in error.messages" @click="getFocus(msg.id)" :class="{ 'cursor-ptr': msg.id }"
                    v-html="msg.value"></li>
              </ul>
            </div>
            <div :class="classTabContent">
              <div v-if="currentTab === 'vehicleDetails'" id="estimate-details" role="tabpanel">
                <div class="row">
                  <div class="col-md-4" style="padding-right: 0">
                    <!-- <div class="box box-block bg-white"> -->
                    <div class="card">
                      <div class="card-header bg-navyblue">
                        <strong>Vehicle Owner</strong>
                      </div>
                      <div class="card-block rs-scroll rs-scroll--x bg-white">
                        <div class="form-group row">
                          <label for="owner" class="col-sm-4 col-4 col-form-label">Vehicle Owner</label>
                          <div class="col-sm-8 col-8">
                            <input style="opacity: 1" type="text" v-model="card.customer.name" class="form-control"
                                   id="owner" placeholder="Name" disabled="disabled">
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="mobile" class="col-sm-4 col-4 col-form-label">Owner Type</label>
                          <div class="col-sm-8 col-8">
                            <div class="checkbox-group">
                              <div class="checkbox-p">
                                <label class="form-check-inline radio" style="margin-top: 5px">
                                  <input v-model="card.customer.customer_type"
                                         class="form-check-input" type="radio" name="customer_type"
                                         id="individual_customer_type" value="I"
                                         @change="autoUpdateCardCustomer" :disabled="isTechnicalUser || true">
                                  <span class="icon"><i class='bx bx-check'></i></span><span
                                    class="text">Individual</span>
                                </label>
                              </div>
                              <div class="checkbox-p">
                                <label class="form-check-inline radio" style="margin-top: 5px">
                                  <input v-model="card.customer.customer_type"
                                         class="form-check-input" type="radio" name="customer_type"
                                         id="business_customer_type" value="B"
                                         @change="autoUpdateCardCustomer" :disabled="isTechnicalUser || true">
                                  <span class="icon"><i class='bx bx-check'></i></span><span
                                    class="text">Business</span>
                                </label>
                              </div>
                              <div class="checkbox-p">
                                <label class="form-check-inline radio" style="margin-top: 5px">
                                  <input v-model="card.customer.customer_type"
                                         class="form-check-input" type="radio" name="customer_type"
                                         id="business_fleet_customer_type" value="F"
                                         @change="autoUpdateCardCustomer" :disabled="isTechnicalUser || true">
                                  <span class="icon"><i class='bx bx-check'></i></span><span style="min-width: 121px"
                                                                                             class="text">Business Fleet</span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div v-if="card.customer.customer_type === 'F' && !isTechnicalUser"
                             class="form-group row">
                          <label class="col-sm-4 col-4 col-form-label">Business ABN</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" :disabled="!card.customer.customer_id"
                                   v-model="card.customer.abn" class="form-control" :readonly="!isStatusActive"
                                   placeholder="Business ABN"
                                   @change="autoUpdateBusinessABN">
                          </div>
                        </div>

                        <div v-if="card.customer.customer_type === 'F'" class="form-group row">
                          <label class="col-sm-4 col-4 col-form-label">Vehicle Driver</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" v-model="card.vehicleDriverName" class="form-control"
                                   placeholder="Vehicle Driver" :readonly="!isStatusActive"
                                   :disabled="!card.customer.customer_id"
                                   @change="autoUpdateContacts">
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="mobile" class="col-sm-4 col-4 col-form-label">Contact Number 1</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" v-model="card.contactNumber1" class="form-control" id="mobile"
                                   placeholder="Phone Number" :readonly="!isStatusActive"
                                   :disabled="!card.customer.customer_id"
                                   @change="autoUpdateContacts">
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="phone" class="col-sm-4 col-4 col-form-label">Contact Number 2</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" v-model="card.contactNumber2" class="form-control" id="phone"
                                   placeholder="Phone Number" :readonly="!isStatusActive"
                                   @change="autoUpdateContacts">
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="fax" class="col-sm-4 col-4 col-form-label">Fax</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" v-model="card.customer.fax" class="form-control" id="fax"
                                   placeholder="Fax Number" :readonly="!isStatusActive"
                                   :disabled="!card.customer.customer_id"
                                   @change="autoUpdateCardCustomer">
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="email" class="col-sm-4 col-4 col-form-label">Email Address</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" v-model="card.contactEmail" class="form-control" placeholder="Email"
                                   :disabled="!card.customer.customer_id || !isStatusActive"
                                   @input="checkEmail"
                                   @blur="checkEmail2"
                                   @change="changedEmailAddress">
                            <small v-if="!isCheckedEmail" class="form-text show-help-for-body">
                              Please enter a valid email address
                            </small>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="address" class="col-sm-4 col-4 col-form-label">Search Address</label>
                          <div class="col-sm-8 col-8">
                            <google-location type="text" v-model="card.customer.address" id="address"
                                             placeholder="Search for an Address"
                                             @onPlaceChange="changedCardCustomerAddress"
                                             :isDisabled="!card.customer.customer_id || !isStatusActive">
                            </google-location>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="level_unit_lot" class="col-sm-4 col-4 col-form-label">Level/Unit/Lot Nbr</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" v-model="card.customer.level_unit_lot" class="form-control"
                                   id="level_unit_lot" placeholder="Lot, Unit, or Level number"
                                   :disabled="!card.customer.customer_id" :readonly="!isStatusActive"
                                   @change="autoUpdateCardCustomer">
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="street_name" class="col-sm-4 col-4 col-form-label">Street Nbr/Name</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" v-model="card.customer.street_name" class="form-control" id="street_name"
                                   placeholder="Street Number or Name"
                                   :disabled="!card.customer.customer_id" :readonly="!isStatusActive"
                                   @change="autoUpdateCardCustomer">
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="suburb" class="col-sm-4 col-4 col-form-label">Suburb</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" v-model="card.customer.suburb" :readonly="!isStatusActive"
                                   class="form-control" id="suburb" placeholder="Suburb"
                                   :disabled="!card.customer.customer_id"
                                   @change="autoUpdateCardCustomer">
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="state" class="col-sm-4 col-4 col-form-label">State</label>
                          <div class="col-sm-8 col-8">
                            <multiselect
                                id="state"
                                ref="vehicleOwnerAddressState"
                                v-model="computedCustomerState"
                                :options="addressStates"
                                :showLabels="false"
                                :option-height="29"
                                :max-height="203"
                                :close-on-select="true"
                                placeholder="Select State"
                                track-by="key"
                                label="value"
                                style="opacity: 1"
                                :disabled="!card.customer.customer_id || !isStatusActive"
                                @select="autoUpdateCardCustomer"
                            >
                            </multiselect>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="postcode" class="col-sm-4 col-4 col-form-label">Postcode</label>
                          <div class="col-sm-8 col-8">
                            <input type="text" v-model="card.customer.postcode" class="form-control" id="postcode"
                                   placeholder="Postcode"
                                   :disabled="!card.customer.customer_id" :readonly="!isStatusActive"
                                   @change="autoUpdateCardCustomer">
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="country" class="col-sm-4 col-4 col-form-label">Country</label>
                          <div class="col-sm-8 col-8">
                            <multiselect
                                id="country"
                                ref="vehicleOwnerAddressCountry"
                                v-model="computedCustomerCountry"
                                :options="addressCountries"
                                :showLabels="false"
                                :option-height="29"
                                :max-height="203"
                                :close-on-select="true"
                                placeholder="Select Country"
                                track-by="key"
                                label="value"
                                :disabled="!card.customer.customer_id || !isStatusActive"
                                style="opacity: 1"
                                @select="autoUpdateCardCustomer"
                            >
                            </multiselect>
                          </div>
                        </div>

                        <!--                                                <div v-if="card.customer.customer_type === 'B'" class="form-group row">-->
                        <!--                                                    <label for="abn" class="col-lg-4 col-form-label">Business ABN</label>-->
                        <!--                                                    <div class="col-lg-8">-->
                        <!--                                                        <input type="text" v-model="card.customer.abn" class="form-control" id="abn" placeholder="Business ABN" :disabled="!card.customer.customer_id"-->
                        <!--                                                               @change="autoUpdateCardCustomer">-->
                        <!--                                                    </div>-->
                        <!--                                                </div>-->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 wrapper-vehicle-block" style="padding-right: 0">
                    <!-- Vehicle block -->
                    <vehicle-block
                        ref="vehicle-block"
                        :card="card"
                        :vehiclePaintCodes="vehiclePaintCodes"
                        :propsIsAutoSave="isAutoSave"
                        :propsEstimateMethodology="estimate.rates.estimate_methodology"
                        :propsEstimate="estimate"
                        :isEstimateEdit="true"
                        @loadPaintCodes="loadPaintCodes"
                        @setUpdateData="setUpdateData"
                        @changedColour="changedColour"
                        @changePaintMaterial="changePaintMaterial"
                        @addNewVehiclePaintCode="addNewVehiclePaintCode"
                        :properties="properties"
                    ></vehicle-block>
                  </div>
                  <div class="col-md-4 pr-0" style="height: 780px">
                    <div v-if="isMobileOnly" style="height: 10px; width: 100%; background: #e3e4e7; margin-bottom: 7px;" class=""></div>
                    <tabs :is-need-save-tabs="false" @changed="changedSubTabs" class="estimates-edit-sub-tabs"
                          :options="{useUrlFragment: false, defaultTabHash: 'estimates-values' }">
                      <tab name="Estimates Values" id="estimates-values">
                        <div class="card">
                          <div class="card-block rs-scroll rs-scroll--x bg-white" style="padding-top: 5px !important;">
                            <div class="row shop-light">
                              <label class="col-sm-7">Card Number</label>
                              <label class="col-sm-5">
                                <div class="form-control" style="height: 32px">
                                  <router-link :to="'/cards/view/' + card_id">
                                    <span
                                        v-b-tooltip.hover="{customClass: 'ps-tooltip', title: `Card Number`, placement: 'left'}"
                                        style="font-weight: bold">{{ card.card_number }}</span>
                                  </router-link>
                                </div>
                              </label>
                            </div>
                            <div v-for="estItem in itemsList"
                                 :key="estItem.id"
                                 class="row shop-light">
                              <label class="col-sm-7">
                                Date Created
                                <template v-if="estItem.type == 'supplement'">{{ estItem.number }}
                                </template>
                              </label>
                              <div class="col-sm-5 additional-data-picker-block" style="margin-bottom: 10px;">
                                <date-picker :is-disabled="!isStatusActive"
                                             @input="saveItemsList(estItem.id, {estimate: {dateCreated: estItem.dateCreated}})"
                                             v-model="estItem.dateCreated"></date-picker>
                              </div>
                            </div>
                            <div class="row shop-bold">
                              <label class="col-sm-7">Estimate Amount</label>
                              <label class="col-sm-5">{{ computedEstimateAmount | formatMoney }}</label>
                            </div>
                            <div class="row shop-light">
                              <label class="col-sm-7">Part Mark-Up Profit</label>
                              <label
                                  class="col-sm-5">{{
                                  (estimateAmount.parts_markup_profit === '') ? '$0.00' : estimateAmount.parts_markup_profit
                                }}</label>
                            </div>
                            <div class="row shop-light">
                              <label class="col-sm-7">Labour Profit</label>
                              <label class="col-sm-5"></label>
                            </div>
                          </div>
                        </div>
                      </tab>
                      <tab name="Parts" id="parts">
                        <div class="card">
                          <div class="card-block rs-scroll rs-scroll--x bg-white">
                            <div class="row shop-light">
                              <label class="col-sm-7">Card Number</label>
                              <label class="col-sm-5">
                                <div class="form-control" style="height: 32px">
                                  <router-link :to="'/cards/view/' + card_id">
                                    <span
                                        v-b-tooltip.hover="{customClass: 'ps-tooltip', title: `Card Number`, placement: 'left'}"
                                        style="font-weight: bold">{{ card.card_number }}</span>
                                  </router-link>
                                </div>
                              </label>
                            </div>
                            <div class="row shop-light">
                              <label class="col-sm-7">Part Purchase Order</label>
                              <label
                                  class="col-sm-5">{{
                                  (estimateAmount.parts_purchase_order === '') ? '&#45;&#45;' : estimateAmount.parts_purchase_order
                                }}</label>
                            </div>
                            <div class="row shop-light">
                              <label class="col-sm-7">Part Cost</label>
                              <label class="col-sm-5">--</label>
                            </div>
                            <div class="row shop-light">
                              <label class="col-sm-7">Part Received Status</label>
                              <label class="col-sm-5">--</label>
                            </div>
                          </div>
                        </div>
                      </tab>

                    </tabs>
                    <div style="display: block" class="card ex-card wizard-bottom"
                         :class="{'progress-top': selectedVehicleSubTab == 'parts', 'progress-bottom': selectedVehicleSubTab == 'parts'}">
                      <small-form-wizard
                          title="Progress"
                          :current-status-id="card.card_status"
                          :statuses="card.statuses"
                          :progress="cardProgress.widthActivePercent"
                          @change="onChangeCardProgress"
                          @full-clicked="activityTabChange"
                      />
                    </div>

                    <div class="medium-rectangle-b-promo-block">
                      <advert-banner
                          v-if="!isMobile"
                          :bannerType="2"
                      />
                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="col-md-8 reset-padd">
                    <!-- Insurance block -->
                    <insurance-block
                        :card="card"
                        :assessors="assessors"
                        :insurers="insurers"
                        @updateInsurance="autoUpdateInsurance"
                        @setDefaultValues="setDefaultValues"
                        @updateTotalLoss="autoUpdateVehicleTotalLoss"
                        :isDisabledIsurerName="properties.isFromIag"
                    ></insurance-block>
                  </div>
                  <div class="col-md-4 p-0 reset-padd padd-left-15">
                    <div class="card">
                      <div class="card-header bg-navyblue">
                        <strong>Rates</strong>
                      </div>
                      <div class="card-block rs-scroll rs-scroll--x bg-white">
                        <div class="form-group row">
                          <label for="estimate_methodology" class="col-sm-3 col-form-label">Estimate Methodology</label>
                          <div class="col-sm-9">
                            <multiselect
                                id="estimate_methodology"
                                v-model="computedEstimateMethodology"
                                :options="computedEstimateMethodologies"
                                :showLabels="false"
                                :option-height="29"
                                :max-height="203"
                                open-direction="bottom"
                                :close-on-select="true"
                                placeholder="Select State"
                                :disabled="!isStatusActive"
                                style="opacity: 1"
                                track-by="key"
                                label="value"
                                @input="selectedEstimateMethodology"
                                @select="autoUpdateRates"
                            >
                            </multiselect>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="rr" class="col-sm-3 col-form-label">RR</label>
                          <div class="col-sm-9">
                            <number-formatter ref="rr" v-model="estimate.rates.rr" type="text" class="form-control"
                                              id="rr" placeholder="RR Amount"
                                              format="$0,0.00"
                                              :disabled="estimate.rates.insurer_rate_id === 0 || !isStatusActive || isDisabledRates || isDisabledRatesRR"
                                              @onChange="autoUpdateRates"></number-formatter>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="repair" class="col-sm-3 col-form-label">Repair</label>
                          <div class="col-sm-9">
                            <number-formatter ref="repair" type="text" v-model="estimate.rates.repair"
                                              class="form-control" id="repair" placeholder="Repair"
                                              format="$0,0.00"
                                              :disabled="estimate.rates.insurer_rate_id === 0 || !isStatusActive || isDisabledRates || isDisabledRatesRepair"
                                              @onChange="autoUpdateRates"></number-formatter>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="paint" class="col-sm-3 col-form-label">Paint</label>
                          <div class="col-sm-9">
                            <template v-if="isShowPaintRateForCustomMethodology">
                              <span v-if="estimate.rates.paint == 0 || estimate.rates.paint=='0.00'"
                                    class="form-control close-edit-cursor">$0.00 - {{
                                  estimate.rates.paint_material != 'not_set' ? estimate.rates.paint_material : ''
                                }} RATE NOT SET</span>
                              <span v-else class="form-control close-edit-cursor">${{ estimate.rates.paint }} - SET BY PAINT MATERIAL</span>
                            </template>
                            <template v-else>
                              <number-formatter ref="paint" type="text" v-model="estimate.rates.paint"
                                                class="form-control" id="paint" placeholder="Paint"
                                                format="$0,0.00"
                                                :disabled="estimate.rates.insurer_rate_id === 0 || !isStatusActive || isDisabledRates || isDisabledRatesPaint"
                                                @onChange="autoUpdateRates"/>
                            </template>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="paint_material" class="col-sm-3 col-form-label">Paint Material</label>
                          <div class="col-sm-9">
                            <multiselect
                                class="rates-paint-material"
                                ref="RatesPaintMaterial"
                                id="paint_material"
                                v-model="estimate.rates.paint_material"
                                :options="paintMaterials.map(data => data.key)"
                                :custom-label="opt => paintMaterials.find(x => x.key == opt).value"
                                :showLabels="false"
                                :option-height="29"
                                :max-height="203"
                                :close-on-select="true"
                                :disabled="!isStatusActive"
                                style="opacity: 1"
                                @select="autoUpdateRates"
                                @input="selectedPaintMaterial"
                                :class="{ 'show-red-border-for-paint-material': isShowRedBorderForPaintMaterial }"
                            >
                            </multiselect>
                            <small v-if="isShowRedBorderForPaintMaterial"
                                   class="form-text show-help-for-paint-material">
                              Please select a value to be saved.
                            </small>
                            <small v-if="isShowRedBorderIfNewPaintColour"
                                   class="form-text show-help-for-paint-material">
                              You have created a new Paint Colour. Please set a default paint material code.
                            </small>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="partmarkup" class="col-sm-3 col-form-label">Part Markup</label>
                          <div class="col-sm-9">
                            <number-formatter ref="partmarkup" type="text" v-model="estimate.rates.partmarkup"
                                              class="form-control" id="partmarkup"
                                              placeholder="Part Markup"
                                              format="0.00%"
                                              :percentage="true"
                                              :is-disabled="!isStatusActive"
                                              @onChange="autoUpdateRates"></number-formatter>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="mechanical" class="col-sm-3 col-form-label">Mechanical</label>
                          <div class="col-sm-9">
                            <number-formatter type="text"
                                              class="form-control" id="partmarkup"
                                              placeholder="Mechanical"
                                              format="$0,0.00"
                                              :is-disabled="!isStatusActive"
                                              v-model="estimate.rates.mechanical"
                                              @onChange="autoUpdateRates"></number-formatter>
                          </div>
                        </div>
                        <!--<div class="form-group row">
                    <label for="ntar" class="col-sm-3 col-form-label">NTAR vehicle list</label>
                    <div class="col-sm-9">
                      <input type="text" v-model="estimate.rates.ntar" class="form-control" id="ntar" placeholder="NTAR vehicle list" :disabled="estimate.rates.insurer_rate_id !== 0">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="ltar" class="col-sm-3 col-form-label">LTAR vehicle list</label>
                    <div class="col-sm-9">
                      <input type="text" v-model="estimate.rates.ltar" class="form-control" id="ltar" placeholder="LTAR vehicle list" :disabled="estimate.rates.insurer_rate_id !== 0">
                    </div>
                  </div>-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="currentTab === 'notes'" id="card-notes" role="tabpanel">
                <card-notes
                    ref="cardNotes"
                    :notes="notes"
                    :card_id="card.card_id"
                    @loadNotes="loadNotes">
                </card-notes>
              </div>
              <div v-show="currentTab === 'itemList'+(itemList.id)"
                   v-for="(itemList, itemIndex) in itemsList"
                   :key="'itemList'+(itemList.id)"
                   role="tabpanel">
                <item-list
                    :properties="properties"
                    :isFromIag="properties.isFromIag"
                    :isAutoSave="isAutoSave"
                    :timesForItemPart="computedTimesForItemPart"
                    :vehicleBody="card.vehicle.body"
                    :estimate="itemList"
                    :iagOrmItems="iagOrmItems"
                    :card="card"
                    :estimateId="itemList.id"
                    :currentTab="$route.params.subTab == 'Part' && $route.params.itemsListId == itemList.id? 'Part': 'RR'"
                    :isShowPaintSetupCalculation="itemList.isShowPaintSetupCalculation"
                    :isShowEnvironmentLevyCalculation="itemList.isShowEnvironmentLevyCalculation"
                    :isSentToIntegrationSystem="estimate.isSentToIntegrationSystem"
                    :isEstimateForButterfly="estimate.isEstimateForButterfly"
                    :isInsuranceRepairYes="isInsuranceRepairYes"
                    :isRSEstimateMethodology="isRSEstimateMethodology"
                    :isEstimateMethodologyCustom="isEstimateMethodologyCustom"
                    :insurance="card.insurance"
                    :estimateMethodology="estimate.rates.estimate_methodology"
                    :estimateParts="itemList.parts"
                    :rates="estimate.rates"
                    :isVisibleToPDRTech2="itemList.isVisibleToPDRTech"
                    :removeEstimateParts="removeEstimateParts"
                    @loadTimesForItemPart="loadTimesForItemPart"
                    @autoSaveMessageUpdate="value => autoSaveMessage = value"
                    @saveItems="saveItemsList"
                    @updateCalculation="updateCalculation"
                    @updateShowImportPdfParts="updateShowImportPdfParts"
                    @beforeDebouncedUnsavedChanges="beforeDebouncedUnsavedChanges"
                />
              </div>
              <div v-if="currentTab === 'images'" id="upload-images" role="tabpanel">
                <div>
                  <vue-dropzone
                      v-if="isStatusActive"
                      v-on:vdropzone-file-added="addImgUpload"
                      v-on:vdropzone-success="successImgUpload"
                      v-on:vdropzone-complete="completeImgUpload"
                      v-on:vdropzone-sending="sendImgUpload"
                      ref="imgUpDrop"
                      id="imgUploadDrop"
                      class="dropify-wrapper dropzoneContainer"
                      style="height: auto;"
                      :options="imageUploadDropzoneOptions"
                      :useCustomSlot="true">
                    <div class="dropify-message " style="transform: translateY(0%);">
                      <template v-if="isMobile">
                        <i class='bx bx-camera drop-clickable'></i>
                        <p class="drop-down-text drop-clickable">Take a Photo</p>
                      </template>
                      <template v-else>
                        <i class='bx bx-cloud-upload'></i>
                        <p class="drop-down-text">Drag and Drop Images Here</p>
                      </template>
                      <p class="text-or mb-0-5">Or</p>
                      <div class="text-sm-center mb-1 ex-image-upload-buttons">
                        <button type="button"
                                class="btn btn-primary waves-effect waves-light browse-btn browse-btn-images drop-clickable">
                          Browse Images
                        </button>
                        <button @click.prevent="clickCancelDropzoneImages($event)" type="button"
                                class="btn btn-secondary waves-effect waves-light cancel-btn">Cancel
                        </button>
                      </div>
                    </div>
                  </vue-dropzone>
                </div>

                <div class="row additional-estimate-images-block">
                  <image-lightbox
                      :isPreviewImage="'true'"
                      :fromComponent="'estimate'"
                      :position="'below_drag_area'"
                      :imageList="imageSource"
                      :showContextMenu="true"
                      :boardInId="boardInId"
                      :boardDepartureId="boardDepartureId"
                      :is-delete="true"
                      @updateCategoryFunc="updateImageCategory"
                      @removeImage="deleteImage"
                      :path="''"
                  ></image-lightbox>
                </div>
              </div>
              <div v-if="currentTab === 'files'" id="upload-files" role="tabpanel">
                <vue-context ref="rightClickMenuForFiles">
                  <ul slot-scope="item">
                    <li v-if="item.data && !item.data.isCardAccess" @click="addToCardFiles(item.data)">Add to Card
                      Files
                    </li>
                    <li v-if="item.data &&  item.data.isCardAccess" @click="removeFromCardFiles(item.data)">Remove from
                      Card Files
                    </li>
                    <li @click="remTableFile(item.data.id)">Delete File</li>
                  </ul>
                </vue-context>
                <!--                              <card-files @beforeDebouncedAutoSave="beforeDebouncedAutoSave"></card-files>-->
                <div class="row">
                  <div class="w-100 card-files">
                    <div class="row nav-title pagination-block-bottom">
                      <div class="col-md-8 p-0">
                        <b-table
                            class="rs-scroll rs-scroll--y noselect"
                            responsive
                            bordered
                            :items="files"
                            :fields="fields"
                            :current-page="cardsCurrentPage"
                            :per-page="cardsPerPage"
                            @row-contextmenu="openMenuForFiles"
                        >
                          <template v-slot:cell(name)="data">
                            <a class="file-name" :download="data.item.name"
                               :href="data.item.url">{{ data.item.name }}</a>
                          </template>
                          <template v-slot:cell(uploaded_by)="data">
                            <span class="uploaded-by">{{ data.item.user }}</span>
                          </template>
                          <template v-slot:cell(created_by)="data">
                            <span class="uploaded-date">{{ data.item.date }}</span>
                          </template>
                          <template v-slot:cell(fileSize)="data">
                            <span class="file-size">{{ data.item.fileSize | formatFileSize }}</span>
                          </template>
                          <template v-slot:cell(action)="data">
                            <a v-if="isShopManagerUser || isProductionManagerUser || isEstimatorUser || isPDRTechnicianUser"
                               @click="remTableFile(data.item.id)"
                               class="trash-icon"
                               v-b-tooltip.hover="{customClass: 'ps-tooltip', title: 'Delete File', placement:'leftbottom'}"
                            >
                              <svg width="18px" height="20px" viewBox="0 0 18 20" version="1.1"
                                   xmlns="http://www.w3.org/2000/svg"
                                   xmlns:xlink="http://www.w3.org/1999/xlink">
                                <!-- Generator: sketchtool 60.1 (101010) - https://sketch.com -->
                                <desc>Created with sketchtool.</desc>
                                <g id="UI-Design" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                  <g id="Dashboard-Redesign-(Detail-Cards)Files"
                                     transform="translate(-1264.000000, -933.000000)" fill="#FF5E5E"
                                     fill-rule="nonzero">
                                    <g id="Group-4" transform="translate(265.000000, 933.000000)">
                                      <g id="trash" transform="translate(999.000000, 0.000000)">
                                        <path
                                            d="M6,2 L6,1 C6,0.44771525 6.44771525,0 7,0 L11,0 C11.5522847,0 12,0.44771525 12,1 L12,2 L16,2 C17.1045695,2 18,2.8954305 18,4 L18,5 C18,6.1045695 17.1045695,7 16,7 L15.867,7 L15.187,17.2 C15.081727,18.775582 13.773095,20 12.194,20 L5.826,20 C4.24834545,20 2.94028051,18.7780028 2.833,17.204 L2.137,7 L2,7 C0.8954305,7 0,6.1045695 0,5 L0,4 C0,2.8954305 0.8954305,2 2,2 L6,2 Z M16,4 L2,4 L2,5 L16,5 L16,4 Z M4.141,7 L4.828,17.068 C4.86376888,17.5927957 5.29998676,18.0001655 5.826,18 L12.194,18 C12.7207338,18 13.1572356,17.5915853 13.192,17.066 L13.862,7 L4.142,7 L4.141,7 Z M7,8 C7.55228475,8 8,8.44771525 8,9 L8,16 C8,16.5522847 7.55228475,17 7,17 C6.44771525,17 6,16.5522847 6,16 L6,9 C6,8.44771525 6.44771525,8 7,8 Z M11,8 C11.5522847,8 12,8.44771525 12,9 L12,16 C12,16.5522847 11.5522847,17 11,17 C10.4477153,17 10,16.5522847 10,16 L10,9 C10,8.44771525 10.4477153,8 11,8 Z"
                                            id="Shape"></path>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                            </a>
                          </template>
                        </b-table>
                        <!--                                    <table class="table">-->
                        <!--                                      <thead class="bg-navyblue">-->
                        <!--                                      <tr>-->
                        <!--                                        &lt;!&ndash;<th>Select</th>&ndash;&gt;-->
                        <!--                                        <th>File Name</th>-->
                        <!--                                        <th>Uploaded By</th>-->
                        <!--                                        <th class="text-center">Date</th>-->
                        <!--                                        <th class="text-center">Delete</th>-->
                        <!--                                      </tr>-->
                        <!--                                      </thead>-->
                        <!--                                      <tbody>-->
                        <!--                                      <tr v-for="(file, index) in files">-->
                        <!--                                        &lt;!&ndash;<td><input type="checkbox" /></td>&ndash;&gt;-->
                        <!--                                        <td><a :href="file.url" target="_blank">{{file.name}}</a></td>-->
                        <!--                                        <td>{{file.user}}</td>-->
                        <!--                                        <td class="text-center">{{file.date}}</td>-->
                        <!--                                        <th class="text-center"><i @click="remTableFile(index)" class="ti-trash clickable"></i></th>-->
                        <!--                                      </tr>-->
                        <!--                                      </tbody>-->
                        <!--                                    </table>-->
                      </div>
                      <div class="col-md-4">
                        <div>
                          <vue-dropzone
                              v-if="isStatusActive"
                              v-on:vdropzone-removed-file="removeFileDropzone"
                              v-on:vdropzone-file-added="addFileUpload"
                              v-on:vdropzone-complete="completeFileUpload"
                              v-on:vdropzone-sending="sendFileUpload"
                              v-on:vdropzone-success="successFileUpload"
                              ref="fileUpDrop"
                              id="fileUploadDrop"
                              class="dropify-wrapper dropzoneContainer"
                              style="height: auto;"
                              :options="fileUploadDropzoneOptions"
                              :useCustomSlot=true>
                            <div class="dropify-message" style="transform: translateY(0%);">
                              <i class='bx bx-cloud-upload'></i>
                              <p class="dnd-title">Drag and Drop File Here</p>
                              <p class="text-or mb-0-5 dnd-or">Or</p>
                              <div class="text-sm-center mb-1 ex-image-upload-buttons">
                                <button type="button"
                                        class="btn btn-primary waves-effect waves-light browse-btn browse-btn-files">
                                  Browse Files
                                </button>
                                <button @click="clickCancelDropzoneFiles" type="button"
                                        class="btn btn-secondary waves-effect waves-light cancel-btn">Cancel
                                </button>
                              </div>
                            </div>

                          </vue-dropzone>
                        </div>
                      </div>
                    </div>
                    <block-pagination
                        :role="'Files'"
                        :arrayOfSomeone="files"
                        :arrayOfSomeoneFiltered="files"
                        :currentPage="cardsCurrentPage"
                        @changedCurrentPage="value => cardsCurrentPage = value"
                        :perPage="cardsPerPage"
                        @changedPerPage="value => cardsPerPage = value"
                    >
                    </block-pagination>
                  </div>
                </div>
              </div>
              <!--                            <div v-if="supplement_number === 0 && currentTab === 'supplements'" id="supplements" role="tabpanel">-->
              <!--                                <estimate-supplements-->
              <!--                                        :supplements="supplements"-->
              <!--                                        :total-supplements="totalSupplements"-->
              <!--                                        @removeSupplement="removeSupplement"-->
              <!--                                />-->
              <!--                            </div>-->
              <div v-if="currentTab === 'activity'" id="activity" role="tabpanel">
                <div class="row sticky" :style="`top: ${topSticky}px`">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 additional-card-progress-scroll">
                    <rs-form-wizard
                        :current-status="card.card_status"
                        :statuses="card.statuses"
                        :progress="cardProgress.widthActivePercent"
                        @change="onChangeCardProgress"
                    />
                  </div>


                  <div class="col-md-12">
                    <div class="border-top"></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-lg-10 col-xl-8">
                    <div class="row activity-list-header px-0">
                      <div class="col-xs-6">
                        <h4>ACTIVITY LIST</h4>
                      </div>
                      <div class="col-md-6">
                        <div class="navbar-nav nav dropdown dropdown-options show inline float-right mr-0">
                                                    <span class="btn waves-effect waves-light ex-options-button"
                                                          data-toggle="dropdown"
                                                          aria-haspopup="true"
                                                          aria-expanded="true">
                                                            {{ activitySortTypeText }}
                                                            <span class="dropdown-arrow  pull-right"
                                                                  style="box-sizing: border-box; width: 30px; border-left: 1px solid rgba(27, 30, 56, 0.25);">
                                                            <i class="fa fa-chevron-down pull-right"></i>
                                                </span>
                                                    </span>
                          <div class="dropdown-menu dropdown-menu-right animated fadeInUp">
                            <a @click="changeActivitySortBy(activitySortTypes.email)"
                               class="dropdown-item text-primary p-1 clickable"><i class="fa fa-envelope-o"
                                                                                   aria-hidden="true"></i>
                              {{ activitySortTypes.email }}</a>
                            <a v-if="isSmsAvailable" @click="changeActivitySortBy(activitySortTypes.sms)"
                               class="dropdown-item text-primary p-1 clickable"><i class="fa fa-envelope-o"
                                                                                   aria-hidden="true"></i>
                              {{ activitySortTypes.sms }}</a>
                            <a @click="changeActivitySortBy(activitySortTypes.external)"
                               class="dropdown-item text-primary p-1 clickable"><i class="fa fa-external-link"
                                                                                   aria-hidden="true"></i>
                              {{ activitySortTypes.external }}</a>
                            <a @click="changeActivitySortBy(activitySortTypes.assignment)"
                               class="dropdown-item text-primary p-1 clickable"><i class="fa fa-user"
                                                                                   aria-hidden="true"></i>
                              {{ activitySortTypes.assignment }}</a>
                            <a @click="changeActivitySortBy(activitySortTypes.status_change)"
                               class="dropdown-item text-primary p-1 clickable"><i
                                class="fa fa-pencil-square-o" aria-hidden="true"></i>
                              {{ activitySortTypes.status_change }}</a>
                            <a v-if="this.activitySortTypeText != 'Sort By' && this.activitySortTypeText != 'Show All'"
                               @click="changeActivitySortBy(activitySortTypes.show_all)"
                               class="dropdown-item text-primary p-1 clickable"
                               style="padding-left: 28px !important">{{ activitySortTypes.show_all }}</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-lg-10 col-xl-8">
                    <activity-list
                        :activity="activity"
                        :newTask="newTask"
                        :isOpenNewTaskForm="isOpenNewTaskForm"
                        :cardId="card.card_id"
                        :estimateId="$route.params.estimate_id"
                        :filteredListAssignedTo="getterVisibleUsers"
                        @loadActivity="loadActivity"
                        @saveTask="saveTask"
                        @saveNewTask="saveNewTask"
                        @closeTask="closeTask"
                        @deleteTask="deleteTask"
                        @deleteActivity="deleteActivity"
                        @closeNewTask="closeNewTask"
                    >
                    </activity-list>
                  </div>
                  <div class="col-xl-4">
                    <div class="desktop-b-promo-block estimare-activity-list-b-promo">
                      <advert-banner
                          v-if="!isMobile"
                          :bannerType="4"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <amazon-ads></amazon-ads>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-wizard class="delete-supp-modal" ref="deleteSuppModal" finishButtonText="Ok" @on-complete="removeSupplement">
      <modal-wizard-tab title="Deletion of Supplement">
        <div style="margin-bottom: 15px; margin-top:5px">
          Do you want to Delete this Supplement?
        </div>
      </modal-wizard-tab>
    </modal-wizard>
    <modal-wizard ref="paintMaterialNotificationModal" v-bind:hideCancelButton="true" finishButtonText="Ok"
                  @on-complete="paintMaterialNotificationCompleted" id="paintMaterialNotificationModal">
      <modal-wizard-tab title="Form Check - Notification">
        <template>
          <h5 style="text-align: center; padding: 30px; line-height: 1.6">
            A selection in the Paint Material field has not been made. <br/>
            Please select a value to be saved.
          </h5>
          <div style="padding: 0 20px; line-height: 1.8; margin-bottom:30px">
            Paint Material: This field allows for the system to automatically to apply the paint times and calculate
            materials for vehicles with a shedule number.
          </div>
        </template>
      </modal-wizard-tab>
    </modal-wizard>

    <div class="estimate-preview-visual">
      <modal-wizard ref="previewADJPreEstimateModal" cancelButtonText="Close" finishButtonText="Print PDF"
                    @on-complete="downloadPreAdjEstimate">
        <modal-wizard-tab
            :title="isSupplementItemListTab? ' Print Pre Adjusted Supplement':' Print Pre Adjusted Estimate'"
            description="" title-icon-class="ti-align-right" :tabData="estimateToCustomer">
          <template slot-scope="props">
            <div style="display: none">{{ sctollToTop() }}</div>

            <div class="invoice">
              <header class="invoice-header">
                <div class="invoice-logo">
                  <img :src="vendorInfo.logo" style="height: 150px; width: 300px;" alt="">
                </div>
                <div class="invoice-info">
                  <h1 class="invoice-title">ESTIMATE</h1>
                  <table class="header-table">
                    <tr>
                      <td class="fz16">{{ props.vendor.business_name }}</td>
                    </tr>
                    <tr>
                      <td>ABN : {{ props.vendor.abn }}</td>
                    </tr>
                    <tr>
                      <td>License: {{ props.vendor.license_number }}</td>
                    </tr>
                    <tr v-if="props.vendor.postal_address">
                      <td>{{ props.vendor.postal_address }}</td>
                    </tr>
                    <tr v-if="!props.vendor.postal_address">
                      <td>{{ props.vendor.postal_street }} {{ props.vendor.postal_suburb }}</td>
                    </tr>
                    <tr v-if="!props.vendor.postal_address">
                      <td>{{ props.vendor.postal_state }} {{ props.vendor.postal_country }}</td>
                    </tr>
                    <tr>
                      <td>Email: {{ props.vendor.email }}</td>
                    </tr>
                    <tr>
                      <td>Phone: {{ props.vendor.phone_area_code }} {{ props.vendor.phone }}</td>
                    </tr>
                  </table>

                  <table class="header-table">
                    <tr>
                      <td><strong>Estimate Number:</strong> <span>{{ props.estimate.estimate_number }}<template
                          v-if="props.estimate.supplement_number && props.estimate.supplement_number>0">-{{
                          props.estimate.supplement_number
                        }}</template></span>
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Estimator:</strong> <span>{{ props.estimate.estimator }}</span></td>
                    </tr>
                    <tr>
                      <td><strong>Date:</strong> <span>{{ props.estimate.created_on }}</span></td>
                    </tr>
                    <tr>
                      <td><strong>Expiry:</strong> <span>{{ props.estimate.expires_on }}</span></td>
                    </tr>
                  </table>
                </div>
              </header>

              <main class="main-flex">
                <table class="main-table m0 table-fixed owner-vehicle-title">
                  <thead>
                  <tr>
                    <th colspan="2">Vehicle &amp; Owner</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="mobile-disabled">
                    <th>Owner Details</th>
                    <th>Vehicle Details</th>
                  </tr>
                  <tr>
                    <td class="w50 vat">
                      <table class="main-inner owner-details">
                        <tr>
                          <td>Owner Name</td>
                          <td>{{ props.customer.customer_name }}</td>
                        </tr>
                        <tr>
                          <td>Home Phone</td>
                          <td>{{ props.customer.phone }}</td>
                        </tr>
                        <tr>
                          <td>Mobile Phone</td>
                          <td>{{ props.customer.mobile }}</td>
                        </tr>
                        <tr>
                          <td>Email</td>
                          <td>{{ props.customer.email }}</td>
                        </tr>
                        <tr v-if="props.customer.customer_type == 'B'">
                          <td>ABN</td>
                          <td>{{ props.customer.abn }}</td>
                        </tr>
                        <tr>
                          <td>Insurer Name</td>
                          <td>{{ props.insurance.insurer_name }}</td>
                        </tr>
                        <tr>
                          <td>Claim Number</td>
                          <td>{{ props.insurance.claim_number }}</td>
                        </tr>
                        <tr v-if="props.rates.estimate_methodology == 'ntar'">
                          <td>NTAR Schedule</td>
                          <td></td>
                        </tr>
                      </table>
                    </td>
                    <td class="w50 vat">
                      <table class="vehicle-details">
                        <tr>
                          <td class="w50 vat">
                            <table class="main-inner">
                              <tr>
                                <td>Make</td>
                                <td>{{ props.customer_vehicle.make }}</td>
                              </tr>
                              <tr>
                                <td>Model</td>
                                <td>{{ props.customer_vehicle.model }}</td>
                              </tr>
                              <tr>
                                <td>Series</td>
                                <td v-if="!props.properties.isHideSeries">{{ props.customer_vehicle.series }}</td>
                              </tr>
                              <tr v-if="!isEstimateMethodologyCustom && card.vehicle.series_shedule_number != ''">
                                <td>Schedule Number</td>
                                <td v-if="isRSEstimateMethodology"></td>
                                <td v-else>{{ card.vehicle.series_shedule_number }}</td>
                              </tr>
                              <tr>
                                <td>Transmission</td>
                                <td>{{ props.customer_vehicle.transmission }}</td>
                              </tr>
                              <tr>
                                <td>Paint Code</td>
                                <td>{{ props.customer_vehicle.colour }}</td>
                              </tr>
                            </table>
                          </td>
                          <td class="w50 vat">
                            <table class="main-inner">
                              <tr>
                                <td>Rego</td>
                                <td>{{ props.customer_vehicle.rego_number }}</td>
                              </tr>
                              <tr>
                                <td>VIN Number</td>
                                <td>{{ props.customer_vehicle.vin }}</td>
                              </tr>
                              <tr>
                                <td>Cylinders</td>
                                <td>{{ props.customer_vehicle.cylinders }}</td>
                              </tr>
                              <tr>
                                <td>Build Date</td>
                                <td>{{ props.customer_vehicle.dom }}</td>
                              </tr>
                              <tr>
                                <td>Odometer</td>
                                <td>{{ props.customer_vehicle.odometer }}</td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table
                    v-if="props.line_items.lines.RR.length>0 || props.line_items.lines.Paint.length>0 || props.line_items.lines.Repair.length>0"
                    class="main-table m0">
                  <thead>
                  <tr>
                    <th>Repairs</th>
                  </tr>
                  </thead>
                </table>
                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.RR.length && props.line_items.summary['RR-Hrs-SubTotal-Str'] != ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>R&amp;R</th>
                    <th class="text-center">Hrs</th>
                    <th class="text-center">Rate</th>

                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.RR">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">{{ line.hrs_str }}</td>
                    <td class="text-right">{{ line.rate_str }}</td>

                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="rr-subtotal-hrs">
                    <td class="font-bold text-align-right">Subtotal Hrs</td>
                    <td class="text-center">{{ props.line_items.summary['RR-Hrs-SubTotal-Str'] }}</td>
                    <td></td>

                    <td></td>
                  </tr>
                  <tr class="rr-subtotal-amount">
                    <td></td>

                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['RR-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.RR.length && props.line_items.summary['RR-Hrs-SubTotal-Str'] == ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>R&amp;R</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.RR">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="rr-subtotal-amount">
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['RR-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.Repair.length && props.line_items.summary['Repair-Hrs-SubTotal-Str'] != ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>Repair</th>
                    <th class="text-center">Hrs</th>
                    <th class="text-center">Rate</th>

                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Repair">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">{{ line.hrs_str }}</td>
                    <td class="text-right">{{ line.rate_str }}</td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="rr-subtotal-hrs">
                    <td class="font-bold text-align-right">Subtotal Hrs</td>
                    <td class="text-center">{{ props.line_items.summary['Repair-Hrs-SubTotal-Str'] }}</td>
                    <td></td>

                    <td></td>
                  </tr>
                  <tr class="rr-subtotal-amount">
                    <td></td>
                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Repair-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.Repair.length && props.line_items.summary['Repair-Hrs-SubTotal-Str'] == ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>Repair</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Repair">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="rr-subtotal-amount">
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Repair-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.Paint.length && props.line_items.summary['Paint-Hrs-SubTotal-Str'] != ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>Paint</th>
                    <th class="text-center">Paint Material</th>
                    <th class="text-center">Hrs</th>
                    <th class="text-center">Rate</th>

                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Paint">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">{{ line.paint_type_str }}</td>
                    <td class="text-center">{{ line.hrs_str }}</td>
                    <td class="text-right">{{ line.rate_str }}</td>

                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="paint-subtotal-hrs">
                    <td colspan="2" class="text-right color-dark-grey">Subtotal Hrs</td>
                    <td class="text-center">{{ props.line_items.summary['Paint-Hrs-SubTotal-Str'] }}</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr class="paint-subtotal-amount">
                    <td></td>
                    <td></td>
                    <td colspan="2" class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right">{{ props.line_items.summary['Paint-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.Paint.length && props.line_items.summary['Paint-Hrs-SubTotal-Str'] == ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>Paint</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Paint">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="paint-subtotal-amount">
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Paint-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table class="repairs-total main-table main-total-table"
                       v-if="!!props.line_items.lines.Paint.length || !!props.line_items.lines.Repair.length || !!props.line_items.lines.RR.length">
                  <tbody>
                  <tr v-if="props.line_items.summary['Labour-Hrs-Str'] != ''">
                    <td class="font-bold text-align-right">Total Labour Hours</td>
                    <td class="text-align-right">{{ props.line_items.summary['Labour-Hrs-Str'] }}</td>
                  </tr>
                  <tr>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-align-right">{{ props.line_items.summary['Labour-Cost-Str'] }}</td>
                  </tr>
                  </tbody>
                </table>

                <table class="main-table estimate-parts border-t" v-if="!!props.line_items.lines.Part.length">
                  <thead class="th-fz12">
                  <tr>
                    <th>Parts</th>
                    <th>Part No</th>
                    <th class="text-center">Qty</th>
                    <th class="text-center">M/up</th>
                    <th class="text-center">Unit Price</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Part">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="font-bold" style="word-break: break-all;">{{ line.part_num }}</td>
                    <td class="font-bold text-center">{{ line.qty }}</td>
                    <td class="text-center">{{ line.mup }}%</td>
                    <td class="text-right">{{ line.rate_str }}</td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="parts-subtotal-hrs">
                    <td></td>

                    <td></td>
                    <td></td>
                    <td colspan="2" class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Part-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-parts border-t" v-if="!!props.line_items.lines.Materials.length">
                  <thead class="th-fz12">
                  <tr>
                    <th>Materials</th>
                    <th class="text-center">Hrs</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Materials">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">{{ line.hrs_str }}</td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="parts-subtotal-hrs">
                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Materials-Total-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-other border-t"
                       v-if="!!props.line_items.lines.Sublet.length && props.line_items.summary['Sublet-Hrs-SubTotal-Str'] != ''">
                  <thead class="th-fz12">
                  <tr>
                    <th>Sublet</th>
                    <th class="text-center">Repairer</th>
                    <th class="text-center">Hrs</th>
                    <th class="text-center">Rate</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Sublet">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">{{ line.repairer }}</td>
                    <td class="text-center">{{ line.hrs_str }}</td>
                    <td class="text-right">{{ line.rate_str }}</td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="paint-subtotal-hrs">
                    <td class="text-right color-dark-grey" colspan="2">Subtotal Hrs</td>
                    <td class="text-center">{{ props.line_items.summary['Sublet-Hrs-SubTotal-Str'] }}</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr class="paint-subtotal-amount">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Sublet-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table class="main-table estimate-other border-t"
                       v-if="!!props.line_items.lines.Sublet.length && props.line_items.summary['Sublet-Hrs-SubTotal-Str'] == ''">
                  <thead class="th-fz12">
                  <tr>
                    <th>Sublet</th>
                    <th class="text-center">Repairer</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Sublet">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">{{ line.repairer }}</td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="paint-subtotal-amount">
                    <td class="text-right font-bold" colspan="2">Subtotal Amount</td>
                    <td class="text-center">{{ props.line_items.summary['Sublet-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-sublet m0 border-t" v-if="!!props.line_items.lines.Other.length">
                  <thead class="th-fz12">
                  <tr>
                    <th>Other</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Other">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="paint-subtotal-amount">
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Other-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <!--PDR-->
                <table class="main-table estimate-pdr m0 border-t"
                       v-if="props.line_items.lines.PDR && props.line_items.lines.PDR.length>0">
                  <thead class="th-fz12">
                  <tr>
                    <th>PDR</th>
                    <th class="text-center">Material</th>
                    <th class="text-center">Action</th>
                    <th class="text-center">Qty</th>
                    <th class="text-center">Price</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(line, index) in props.line_items.lines.PDR" :key="index">
                    <td>
                      <div style="white-space: pre-line; align-text-top;">{{ line.name }}</div>
                      <div v-if="line.comment">Comment : {{ line.comment }}</div>
                    </td>
                    <td class="text-center align-text-top">
                      <template v-if="line.type === 'Panel'">{{ line.material }}</template>
                    </td>
                    <td class="text-center  align-text-top">
                      <template v-if="line.type === 'Panel'">{{ line.action|valuePDRMaterial }}</template>
                    </td>
                    <td class="text-center  align-text-top">{{ line.qty }}</td>
                    <td class="text-right  align-text-top">{{ line.price_str }}</td>
                    <td class="text-right  align-text-top">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="paint-subtotal-amount">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['PDR-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table  m0">
                  <thead>
                  </thead>
                  <tbody></tbody>
                </table>
                <table class="parts-total main-table main-total-table">
                  <tbody>
                  <tr v-if="props.line_items.countSubtotal && props.line_items.countSubtotal > 1">
                    <td class="color-dark-grey right">Total</td>
                    <td class="right">{{ props.line_items.summary.Total_str }}</td>
                  </tr>
                  <tr>
                    <td class="font-bold text-right border-bottom">GST</td>
                    <td class="text-right border-bottom">{{ props.line_items.summary.GST_str }}</td>
                  </tr>
                  <tr>
                    <td class="color-dark-grey right"><strong>Total Inc GST</strong></td>
                    <td class="color-dark-grey right"><strong>{{ props.line_items.summary.GrandTotal_str }}</strong>
                    </td>
                  </tr>
                  </tbody>
                </table>

              </main>
              <footer>
                <table class="footer-table">
                  <thead>
                  <tr>
                    <th>Terms</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td v-html="props.terms"></td>
                  </tr>
                  </tbody>
                </table>
              </footer>
            </div>
          </template>
        </modal-wizard-tab>
      </modal-wizard>
    </div>

    <div class="estimate-preview-visual">
      <modal-wizard ref="previewEstimateModal" cancelButtonText="Close" finishButtonText="Print PDF"
                    @on-complete="downloadEstimate">
        <modal-wizard-tab :title="isSupplementItemListTab? 'Preview Supplement':'Preview Estimate'" description=""
                          title-icon-class="ti-align-right" :tabData="estimateToCustomer">
          <template slot-scope="props">
            <div style="display: none">{{ sctollToTop() }}</div>

            <div class="invoice">
              <header class="invoice-header">
                <div class="invoice-logo">
                  <img :src="vendorInfo.logo" style="height: 150px; width: 300px;" alt="">
                </div>
                <div class="invoice-info">
                  <h1 class="invoice-title">ESTIMATE</h1>
                  <table class="header-table">
                    <tr>
                      <td class="fz16">{{ props.vendor.business_name }}</td>
                    </tr>
                    <tr>
                      <td>ABN : {{ props.vendor.abn }}</td>
                    </tr>
                    <tr>
                      <td>License: {{ props.vendor.license_number }}</td>
                    </tr>
                    <tr v-if="props.vendor.postal_address">
                      <td>{{ props.vendor.postal_address }}</td>
                    </tr>
                    <tr v-if="!props.vendor.postal_address">
                      <td>{{ props.vendor.postal_street }} {{ props.vendor.postal_suburb }}</td>
                    </tr>
                    <tr v-if="!props.vendor.postal_address">
                      <td>{{ props.vendor.postal_state }} {{ props.vendor.postal_country }}</td>
                    </tr>
                    <tr>
                      <td>Email: {{ props.vendor.email }}</td>
                    </tr>
                    <tr>
                      <td>Phone: {{ props.vendor.phone_area_code }} {{ props.vendor.phone }}</td>
                    </tr>
                  </table>

                  <table class="header-table">
                    <tr>
                      <td><strong>Estimate Number:</strong> <span>{{ props.estimate.estimate_number }}<template
                          v-if="props.estimate.supplement_number && props.estimate.supplement_number>0">-{{
                          props.estimate.supplement_number
                        }}</template></span>
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Estimator:</strong> <span>{{ props.estimate.estimator }}</span></td>
                    </tr>
                    <tr>
                      <td><strong>Date:</strong> <span>{{ props.estimate.created_on }}</span></td>
                    </tr>
                    <tr>
                      <td><strong>Expiry:</strong> <span>{{ props.estimate.expires_on }}</span></td>
                    </tr>
                  </table>
                </div>
              </header>

              <main class="main-flex">
                <table class="main-table m0 table-fixed owner-vehicle-title">
                  <thead>
                  <tr>
                    <th colspan="2">Vehicle &amp; Owner</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="mobile-disabled">
                    <th>Owner Details</th>
                    <th>Vehicle Details</th>
                  </tr>
                  <tr>
                    <td class="w50 vat">
                      <table class="main-inner owner-details">
                        <tr>
                          <td>Owner Name</td>
                          <td>{{ props.customer.customer_name }}</td>
                        </tr>
                        <tr>
                          <td>Home Phone</td>
                          <td>{{ props.customer.phone }}</td>
                        </tr>
                        <tr>
                          <td>Mobile Phone</td>
                          <td>{{ props.customer.mobile }}</td>
                        </tr>
                        <tr>
                          <td>Email</td>
                          <td>{{ props.customer.email }}</td>
                        </tr>
                        <tr v-if="props.customer.customer_type == 'B'">
                          <td>ABN</td>
                          <td>{{ props.customer.abn }}</td>
                        </tr>
                        <tr>
                          <td>Insurer Name</td>
                          <td>{{ props.insurance.insurer_name }}</td>
                        </tr>
                        <tr>
                          <td>Claim Number</td>
                          <td>{{ props.insurance.claim_number }}</td>
                        </tr>
                        <tr v-if="props.rates.estimate_methodology == 'ntar'">
                          <td>NTAR Schedule</td>
                          <td></td>
                        </tr>
                      </table>
                    </td>
                    <td class="w50 vat">
                      <table class="vehicle-details">
                        <tr>
                          <td class="w50 vat">
                            <table class="main-inner">
                              <tr>
                                <td>Make</td>
                                <td>{{ props.customer_vehicle.make }}</td>
                              </tr>
                              <tr>
                                <td>Model</td>
                                <td>{{ props.customer_vehicle.model }}</td>
                              </tr>
                              <tr>
                                <td>Series</td>
                                <td v-if="!props.properties.isHideSeries">{{ props.customer_vehicle.series }}</td>
                              </tr>
                              <tr v-if="!isEstimateMethodologyCustom && card.vehicle.series_shedule_number != ''">
                                <td>Schedule Number</td>
                                <td v-if="isRSEstimateMethodology"></td>
                                <td v-else>{{ card.vehicle.series_shedule_number }}</td>
                              </tr>
                              <tr>
                                <td>Transmission</td>
                                <td>{{ props.customer_vehicle.transmission }}</td>
                              </tr>
                              <tr>
                                <td>Paint Code</td>
                                <td>{{ props.customer_vehicle.colour }}</td>
                              </tr>
                            </table>
                          </td>
                          <td class="w50 vat">
                            <table class="main-inner">
                              <tr>
                                <td>Rego</td>
                                <td>{{ props.customer_vehicle.rego_number }}</td>
                              </tr>
                              <tr>
                                <td>VIN Number</td>
                                <td>{{ props.customer_vehicle.vin }}</td>
                              </tr>
                              <tr>
                                <td>Cylinders</td>
                                <td>{{ props.customer_vehicle.cylinders }}</td>
                              </tr>
                              <tr>
                                <td>Build Date</td>
                                <td>{{ props.customer_vehicle.dom }}</td>
                              </tr>
                              <tr>
                                <td>Odometer</td>
                                <td>{{ props.customer_vehicle.odometer }}</td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table
                    v-if="props.line_items.lines.RR.length>0 || props.line_items.lines.Paint.length>0 || props.line_items.lines.Repair.length>0"
                    class="main-table m0">
                  <thead>
                  <tr>
                    <th>Repairs</th>
                  </tr>
                  </thead>
                </table>
                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.RR.length && props.line_items.summary['RR-Hrs-SubTotal-Str'] != ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>R&amp;R</th>
                    <th class="text-center">Hrs</th>
                    <th class="text-center">Rate</th>

                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.RR">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">{{ line.hrs_str }}</td>
                    <td class="text-right">{{ line.rate_str }}</td>

                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="rr-subtotal-hrs">
                    <td class="font-bold text-align-right">Subtotal Hrs</td>
                    <td class="text-center">{{ props.line_items.summary['RR-Hrs-SubTotal-Str'] }}</td>
                    <td></td>

                    <td></td>
                  </tr>
                  <tr class="rr-subtotal-amount">
                    <td></td>

                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['RR-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.RR.length && props.line_items.summary['RR-Hrs-SubTotal-Str'] == ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>R&amp;R</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.RR">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="rr-subtotal-amount">
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['RR-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.Repair.length && props.line_items.summary['Repair-Hrs-SubTotal-Str'] != ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>Repair</th>
                    <th class="text-center">Hrs</th>
                    <th class="text-center">Rate</th>

                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Repair">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">{{ line.hrs_str }}</td>
                    <td class="text-right">{{ line.rate_str }}</td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="rr-subtotal-hrs">
                    <td class="font-bold text-align-right">Subtotal Hrs</td>
                    <td class="text-center">{{ props.line_items.summary['Repair-Hrs-SubTotal-Str'] }}</td>
                    <td></td>

                    <td></td>
                  </tr>
                  <tr class="rr-subtotal-amount">
                    <td></td>
                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Repair-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.Repair.length && props.line_items.summary['Repair-Hrs-SubTotal-Str'] == ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>Repair</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Repair">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="rr-subtotal-amount">
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Repair-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.Paint.length && props.line_items.summary['Paint-Hrs-SubTotal-Str'] != ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>Paint</th>
                    <th class="text-center">Paint Material</th>
                    <th class="text-center">Hrs</th>
                    <th class="text-center">Rate</th>

                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Paint">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">{{ line.paint_type_str }}</td>
                    <td class="text-center">{{ line.hrs_str }}</td>
                    <td class="text-right">{{ line.rate_str }}</td>

                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="paint-subtotal-hrs">
                    <td colspan="2" class="text-right color-dark-grey">Subtotal Hrs</td>
                    <td class="text-center">{{ props.line_items.summary['Paint-Hrs-SubTotal-Str'] }}</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr class="paint-subtotal-amount">
                    <td></td>
                    <td></td>
                    <td colspan="2" class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right">{{ props.line_items.summary['Paint-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table class="main-table estimate-repairs m0"
                       v-if="!!props.line_items.lines.Paint.length && props.line_items.summary['Paint-Hrs-SubTotal-Str'] == ''">
                  <thead class="bg-white th-fz12">
                  <tr>
                    <th>Paint</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Paint">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="paint-subtotal-amount">
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Paint-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table class="repairs-total main-table main-total-table"
                       v-if="!!props.line_items.lines.Paint.length || !!props.line_items.lines.Repair.length || !!props.line_items.lines.RR.length">
                  <tbody>
                  <tr v-if="props.line_items.summary['Labour-Hrs-Str'] != ''">
                    <td class="font-bold text-align-right">Total Labour Hours</td>
                    <td class="text-align-right">{{ props.line_items.summary['Labour-Hrs-Str'] }}</td>
                  </tr>
                  <tr>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-align-right">{{ props.line_items.summary['Labour-Cost-Str'] }}</td>
                  </tr>
                  </tbody>
                </table>

                <table class="main-table estimate-parts border-t" v-if="!!props.line_items.lines.Part.length">
                  <thead class="th-fz12">
                  <tr>
                    <th>Parts</th>
                    <th>Part No</th>
                    <th class="text-center">Qty</th>
                    <th class="text-center">M/up</th>
                    <th class="text-center">Unit Price</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Part">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="font-bold" style="word-break: break-all;">{{ line.part_num }}</td>
                    <td class="font-bold text-center">{{ line.qty }}</td>
                    <td class="text-center">{{ line.mup }}%</td>
                    <td class="text-right">{{ line.rate_str }}</td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="parts-subtotal-hrs">
                    <td></td>

                    <td></td>
                    <td></td>
                    <td colspan="2" class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Part-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-parts border-t" v-if="!!props.line_items.lines.Materials.length">
                  <thead class="th-fz12">
                  <tr>
                    <th>Materials</th>
                    <th class="text-center">Hrs</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Materials">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">{{ line.hrs_str }}</td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="parts-subtotal-hrs">
                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Materials-Total-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-other border-t"
                       v-if="!!props.line_items.lines.Sublet.length && props.line_items.summary['Sublet-Hrs-SubTotal-Str'] != ''">
                  <thead class="th-fz12">
                  <tr>
                    <th>Sublet</th>
                    <th class="text-center">Repairer</th>
                    <th class="text-center">Hrs</th>
                    <th class="text-center">Rate</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Sublet">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">{{ line.repairer }}</td>
                    <td class="text-center">{{ line.hrs_str }}</td>
                    <td class="text-right">{{ line.rate_str }}</td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="paint-subtotal-hrs">
                    <td class="text-right color-dark-grey" colspan="2">Subtotal Hrs</td>
                    <td class="text-center">{{ props.line_items.summary['Sublet-Hrs-SubTotal-Str'] }}</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr class="paint-subtotal-amount">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Sublet-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <table class="main-table estimate-other border-t"
                       v-if="!!props.line_items.lines.Sublet.length && props.line_items.summary['Sublet-Hrs-SubTotal-Str'] == ''">
                  <thead class="th-fz12">
                  <tr>
                    <th>Sublet</th>
                    <th class="text-center">Repairer</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Sublet">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-center">{{ line.repairer }}</td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="paint-subtotal-amount">
                    <td class="text-right font-bold" colspan="2">Subtotal Amount</td>
                    <td class="text-center">{{ props.line_items.summary['Sublet-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table estimate-sublet m0 border-t" v-if="!!props.line_items.lines.Other.length">
                  <thead class="th-fz12">
                  <tr>
                    <th>Other</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="line in props.line_items.lines.Other">
                    <td class="font-bold">{{ line.name }}
                      <div v-if="!isEmpty(line.manual_pdf_comment)" class="font-weight-normal">
                        Comment: <span>{{ line.manual_pdf_comment }}</span>
                      </div>
                    </td>
                    <td class="text-right">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="paint-subtotal-amount">
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['Other-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>
                <!--PDR-->
                <table class="main-table estimate-pdr m0 border-t"
                       v-if="props.line_items.lines.PDR && props.line_items.lines.PDR.length>0">
                  <thead class="th-fz12">
                  <tr>
                    <th>PDR</th>
                    <th class="text-center">Material</th>
                    <th class="text-center">Action</th>
                    <th class="text-center">Qty</th>
                    <th class="text-center">Price</th>
                    <th class="text-center">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(line, index) in props.line_items.lines.PDR" :key="index">
                    <td>
                      <div style="white-space: pre-line; align-text-top;">{{ line.name }}</div>
                      <div v-if="line.comment">Comment : {{ line.comment }}</div>
                    </td>
                    <td class="text-center align-text-top">
                      <template v-if="line.type === 'Panel'">{{ line.material }}</template>
                    </td>
                    <td class="text-center  align-text-top">
                      <template v-if="line.type === 'Panel'">{{ line.action|valuePDRMaterial }}</template>
                    </td>
                    <td class="text-center  align-text-top">{{ line.qty }}</td>
                    <td class="text-right  align-text-top">{{ line.price_str }}</td>
                    <td class="text-right  align-text-top">{{ line.total_str }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr class="paint-subtotal-amount">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="font-bold text-right">Subtotal Amount</td>
                    <td class="text-right font-bold">{{ props.line_items.summary['PDR-Total-SubTotal-Str'] }}</td>
                  </tr>
                  </tfoot>
                </table>

                <table class="main-table  m0">
                  <thead>
                  </thead>
                  <tbody></tbody>
                </table>
                <table class="parts-total main-table main-total-table">
                  <tbody>
                  <tr v-if="props.line_items.countSubtotal && props.line_items.countSubtotal > 1">
                    <td class="color-dark-grey right">Total</td>
                    <td class="right">{{ props.line_items.summary.Total_str }}</td>
                  </tr>
                  <tr>
                    <td class="font-bold text-right border-bottom">GST</td>
                    <td class="text-right border-bottom">{{ props.line_items.summary.GST_str }}</td>
                  </tr>
                  <tr>
                    <td class="color-dark-grey right"><strong>Total Inc GST</strong></td>
                    <td class="color-dark-grey right"><strong>{{ props.line_items.summary.GrandTotal_str }}</strong>
                    </td>
                  </tr>
                  </tbody>
                </table>

              </main>
              <footer>
                <table class="footer-table">
                  <thead>
                  <tr>
                    <th>Terms</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td v-html="props.terms"></td>
                  </tr>
                  </tbody>
                </table>
              </footer>
            </div>
          </template>
        </modal-wizard-tab>
      </modal-wizard>
    </div>
    <transition name="slide-fade">
      <div v-if="pinImage" class="image-pin-area rs-scroll rs-scroll--transparent">
        <div>
          <div class="vissible-sm">
            <label class="pin-image">Pin Images
              <input type="checkbox" name="pinimage" v-model="pinImage">
              <span class="pin-checkmark"></span>
            </label>
          </div>
          <vue-dropzone
              v-on:vdropzone-file-added="addImgUpload"
              v-on:vdropzone-complete="completeImgUpload"
              v-on:vdropzone-sending="sendImgUpload"
              v-on:vdropzone-success="successImgUpload"
              ref="imgUpDrop"
              id="imgUploadDrop2"
              class="dropify-wrapper dropzoneContainer"
              style="height: auto;"
              :options="itemsListImageUploadDropzoneOptions"
              :useCustomSlot="true">
            <div class="dropify-message" style="transform: translateY(0%);">
              <img src="../../assets/img/layouts/bx-cloud-upload.svg"/>
              <p>Drag or Drop File</p>
            </div>
          </vue-dropzone>
        </div>
        <image-lightbox
            :isPreviewImage="'true'"
            :fromComponent="'estimate'"
            :position="'pin_images'"
            @updateCategoryFunc="updateImageCategory"
            :imageList="imageSource"
            @removeImage="deleteImage"
            :path="''"
            class="pin-image-lightbox"
        ></image-lightbox>
      </div>
    </transition>
    <!--        <div v-if="drag.debug" style="padding: 10px; border: 1px solid #E9E9E9; border-radius: 4px; margin: 10px; background-color: #F9F9F9; position: fixed; bottom: 5px; right: 5px;">-->
    <!--            <div><strong>Drag Debug</strong></div>-->
    <!--            <div>sourceItem: {{ drag.sourceItem.prt }} id: {{ drag.sourceItem.id }}</div>-->
    <!--            <div>targetItem: {{ drag.targetItem.name }} id: {{ drag.targetItem.id }}</div>-->
    <!--            <div>sourceIndex: {{ drag.sourceIndex }}</div>-->
    <!--            <div>targetIndex: {{ drag.targetIndex }}</div>-->
    <!--            <div>isDragOverEmptyItem: {{ isDragOverEmptyItem }}</div>-->
    <!--        </div>-->
    <div class="modal fade" id="noteBoxModal" tabindex="-1" role="dialog" aria-labelledby="noteboxModalLabel"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 style="display: inline-block" class="modal-title" id="noteboxModalLabel">
              {{ note_id ? 'Edit Note' : 'New Note' }}</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="message-text" class="form-control-label">Note:</label>
              <textarea v-model="note" class="form-control" id="message-text" rows="10"
                        style="height: auto;"></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="saveNote" type="button" class="btn btn-primary mr-1" data-dismiss="modal"><i
                class="ti-save"></i> Save Note
            </button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal"><i class="ti-close"></i>Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.show-help-for-body {
  font-size: 95% !important;
  color: red;
  margin-top: .75rem !important;
}

.progress-top {
  margin-top: 40px !important;
}

.progress-bottom {
  margin-bottom: 57px !important;
}

.delete-supp-modal .modal-dialog {
  width: 370px;
}
</style>

<style>
/*.multiselect__select {*/
/*    display: inline-block;*/
/*    font: normal normal normal 14px/1 FontAwesome;*/
/*    font-size: inherit;*/
/*    text-rendering: auto;*/
/*    -webkit-font-smoothing: antialiased;*/
/*}*/

/*.multiselect__select:before {*/
/*    content: "\f107";*/
/*    border: none;*/
/*}*/
</style>

<style>
.show-help-for-paint-material {
  font-size: 95% !important;
  color: red;
  margin-top: .75rem !important;
}

.nav-link span.tag {
  top: auto !important;
}

.send-to-report td {
  width: 11%;
}

#estimate-item-list .tab-special tbody tr:hover .form-control {
  background: #F9F9F9 !important;
}

#estimate-item-list .tab-special tbody tr:hover select.form-control {
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAArElEQVRIS+2T0Q3CMAxEXzdgk3YEmIgRSjfoRjACbMII6CSQQhrHzkclkOKvNrresy/uwM417OxPB7gJ94h+P6ILsAJPo9UDcAYWa5TaJct8Bu7AqQCR+RWY3gDpN1UDyOAGjAVIav4AjtaU3pqWIOry03nVXEIPIE0O0Zlicc2jgByi95B5CyCF6NnMPL/lSETpN4pLZa1t0xa5f2lE0DpBxPNL0wFuZP8f0Qs+eB0Z+AOfuQAAAABJRU5ErkJggg==") right center no-repeat !important;
}

#estimate-item-list .tab-special tbody tr .form-control:focus {
  background: #FFFFFF !important;
}

#estimate-item-list .tab-special tbody tr:hover select.form-control option {
  background: #FFFFFF !important;
}

#estimate-item-list .tab-special tbody tr:hover select.form-control option:hover {
  background: #F3F3F3 !important;
  color: #35495E !important;
  font-weight: 700;
}

#estimate-item-list .tab-special tbody tr select.form-control:focus {
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAArElEQVRIS+2T0Q3CMAxEXzdgk3YEmIgRSjfoRjACbMII6CSQQhrHzkclkOKvNrresy/uwM417OxPB7gJ94h+P6ILsAJPo9UDcAYWa5TaJct8Bu7AqQCR+RWY3gDpN1UDyOAGjAVIav4AjtaU3pqWIOry03nVXEIPIE0O0Zlicc2jgByi95B5CyCF6NnMPL/lSETpN4pLZa1t0xa5f2lE0DpBxPNL0wFuZP8f0Qs+eB0Z+AOfuQAAAABJRU5ErkJggg==") right center no-repeat !important;
}

#estimate-item-list .tab-special select.form-control:focus {
  border: 1px solid #5E6571;
}

.wizard-nav.wizard-nav-pills li .wizard-icon-circle {
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
  cursor: pointer;
}

.wizard-nav.wizard-nav-pills li .stepTitle {
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
  cursor: pointer;
}

.wizard-nav.wizard-nav-pills li.active .stepTitle {
  color: #4F5D71 !important;
}

.wizard-nav.wizard-nav-pills li:hover .wizard-icon-circle {
  border-color: #4F5D71 !important;
}

.wizard-nav.wizard-nav-pills li:hover .stepTitle {
  color: #4F5D71 !important;
}

.wizard-nav.wizard-nav-pills li.active:hover .stepTitle {
  color: #4F5D71 !important;
}

.wizard-nav.wizard-nav-pills .wizard-icon-container {
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}

.image-pin-area {
  position: fixed;
  width: 220px;
  height: calc(100% - 60px);
  overflow-y: auto;
  display: block;
  background: linear-gradient(180deg, #1C1F3A 0%, #161931 53.69%, #282C48 100%);
  left: 0;
  z-index: 999999;
  top: 60px;
  padding: 15px;
}

.image-pin-area .dropzone {
  padding: 7px;
}

.image-pin-area .dropzone .dz-preview {
  margin: 6px;
}

.image-pin-area .dropify-wrapper {
  height: auto;
}

.image-pin-area .col-sm-3 {
  width: 100%;
  padding: 0;
}

.image-pin-area .col-sm-3 .box.box-block.bg-grey {
  padding: 0;
}

.image-pin-area .col-sm-3 .box.box-block.bg-grey .wrap.img-fluid {
  width: 100%;
  height: auto;
}

.pin-image {
  display: flex;
  align-items: center;
  position: relative;
  color: #34495E;
  height: 27px;
  font-weight: 600;
  font-size: 13px;
  padding-top: 8px;
  padding-left: 35px;
  margin-bottom: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}

@media screen and (max-width: 991px) {
  .pin-image {
    margin-bottom: 15px;
  }
}

/* Hide the browser's default checkbox */
.pin-image input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.V3 .estimates-edit-page .pin-checkmark {
  position: absolute;
  top: 5px;
  left: 0;
  height: 25px;
  width: 25px;
  border: 1px solid rgba(27, 30, 56, 0.25);
  border-radius: 3px;
  background-color: #F8F4F4;
  border: 1px solid #DFDFDF;
}

/* On mouse-over, add a grey background color */
.V3 .estimates-edit-page .pin-image:hover input ~ .pin-checkmark {
  background-color: #CCCCCC;
  border-color: #CCCCCC;
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}

/* When the checkbox is checked, add a blue background */
.V3 .estimates-edit-page .pin-image input:checked ~ .pin-checkmark {
  background-color: #5E79FF;
  border-color: #5E79FF;
}

/* Style the checkmark/indicator */
.V3 .estimates-edit-page .pin-image .pin-checkmark:after {
  /*top: 4px;*/
  /*left: 4px;*/
  /*width: 5px;*/
  /*height: 5px;*/
  /*border-radius: 50%;*/
  /*background: white;*/
}

.vissible-sm {
  display: none;
}

@media screen and (max-width: 991px) {
  .vissible-sm {
    display: block;
  }
}

#paintMaterialNotificationModal div.modal-content {
  width: 70%;
  margin-left: 15%;
}
</style>

<style scoped>
.right-col {
  margin-top: 5px;
  margin-right: 8px;
}

@media (max-width: 1500px) {
  .right-col {
    margin-top: 15px;
  }
}

.tabs-absolute-right {
  display: inline-flex;
  margin-right: 30px;
}

.tabs-absolute-right-notes-btn {
  margin-right: 160px;
}

.tab-content {
  padding: 10px 0;
}

.color-dark-grey {
  color: #3F3F3F !important
}

.fz16 {
  font-size: 16px !important
}

.w50 {
  width: 50%
}

.vat {
  vertical-align: top
}

.m0 {
  margin: 0 !important
}

.border-b {
  border-bottom: 1px solid silver !important
}

.border-t {
  border-top: 1px solid silver !important
}

.bg-white {
  background: #FFFFFF !important
}

.th-fz12 th {
  font-size: 12px !important
}

.invoice {
  width: 820px;
  margin: 25px auto
}

.invoice-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.invoice .main-table {
  margin: 0 0 20px;
  width: 100%;
  border-collapse: collapse
}

.invoice .main-table tr.empty-row td, .invoice .main-table tr.empty-row th {
  height: 20px
}

.invoice .main-table .vehicle-details {
  width: 100%
}

.invoice .parts-required {
  margin-bottom: 0
}

.invoice .parts-required td:nth-child(1), .invoice .parts-required th:nth-child(1) {
  width: 355px
}

.invoice .parts-required td:last-child, .invoice .parts-required th:last-child {
  width: 70px
}

.invoice .estimate-repairs td:first-child, .invoice .estimate-repairs th:first-child {
  width: 550px
}

.invoice .estimate-repairs td:nth-child(2), .invoice .estimate-repairs th:nth-child(2) {
  width: 55px
}

.invoice .estimate-repairs td:last-child, .invoice .estimate-repairs th:last-child {
  width: 70px
}

.invoice .estimate-other td:first-child, .invoice .estimate-other th:first-child {
  width: 550px
}

.invoice .estimate-other td:nth-child(2), .invoice .estimate-other th:nth-child(2) {
  width: 55px
}

.invoice .estimate-other td:last-child, .invoice .estimate-other th:last-child {
  width: 70px
}

.invoice .estimate-sublet td:first-child,
.invoice .estimate-sublet th:first-child,
.invoice .estimate-pdr th:first-child {
  width: 605px
}

.invoice .estimate-sublet td:last-child,
.invoice .estimate-sublet th:last-child {
  width: 70px
}

.invoice .estimate-parts td:first-child, .invoice .estimate-parts th:first-child {
  width: 400px
}

.invoice .estimate-parts td:nth-child(2), .invoice .estimate-parts th:nth-child(2) {
  width: 150px
}

.invoice .estimate-parts td:nth-child(3), .invoice .estimate-parts th:nth-child(3) {
  width: 55px
}

.invoice .estimate-parts td:last-child, .invoice .estimate-parts th:last-child {
  width: 70px
}

.invoice .estimate-pdr th:first-child {
  width: 605px
}

.invoice .estimate-pdr th:nth-child(2),
.invoice .estimate-pdr th:nth-child(3) {
  width: 9rem;
}

.invoice .estimate-pdr th:nth-child(5),
.invoice .estimate-pdr th:last-child {
  width: 86px;
}

.invoice .parts-total td:last-child {
  width: 70px;
  padding-left: 15px
}

.invoice .tax-subtotal-hrs td:first-child {
  width: 560px
}

footer {
  clear: both
}

.footer-table {
  width: 100%;
  border-top: 1px solid silver;
  border-bottom: 1px solid silver
}

.footer-table td, .footer-table th {
  text-align: left
}

.footer-table th {
  padding: 16px 8px 10px;
  font-size: 12px
}

.footer-table td {
  padding: 0 8px 16px;
  font-size: 11px;
  color: #595959
}

#parts-details {
  margin-top: -11px;
}

#parts-details .btn-outline-primary:hover {
  background-color: #E0EAF6;
  color: #0275D8;
}

#parts-details .btn-outline-primary.active:hover {
  background-color: #3E70C9;
}

.timeline {
  padding-left: 15px;
}

.V3 .estimates-edit .dropzoneContainer {
  margin: 5px 15px;
  width: auto;
  border: 1px dashed rgba(27, 30, 56, 0.25);
  border-radius: 3px;
  background: white !important;
  min-width: 125px;
}

.V3 .estimates-edit .dropify-wrapper .dropify-message span.file-icon:before {
  content: '\E800';
  font-weight: 800;
  font-size: 37px;
  color: #5E79FF;
}

.V3 .estimates-edit .dropify-wrapper .dropify-message .drop-down-text {
  font-family: "Nunito Sans";
  color: #1C1F39;
  font-size: 13px;
  font-weight: bold;
}

.btnNotBorder {
  border-color: #FAFAFA !important;
}

.btnNotBorder:hover {
  background-color: #FAFAFA !important;
  color: #142742 !important;
}

.btnNotBorder .fa-sort-down {
  left: unset !important;
  margin: 0 !important;
  top: 5px !important;
  font-size: 14px !important;
  width: 20px !important;
  height: auto !important;
}

.dropdownLinks-container {
  flex-direction: column;
  position: absolute;
  border: none;
  background-color: #FAFAFA;
  right: 20px;
  top: 28px;
  height: auto;
  padding: 0;
  margin: 0;
}

.dropdownLinks-links {
  position: relative;
  background: white;
  border: 1px solid #B8B8B8;
}

.dropdownLinks-links:after,
.dropdownLinks-links:before {
  bottom: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.dropdownLinks-links:after {
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #FFFFFF;
  border-width: 5px;
  right: 12px;
  background-clip: padding-box;
}

.dropdownLinks-links:before {
  border-color: rgba(184, 184, 184, 0);
  border-bottom-color: #B8B8B8;
  border-width: 6px;
  right: 11px;
  background-clip: padding-box;
}

.activtyPopupIcon {
  position: unset !important;
  margin: 0 !important;
  font-size: 10px !important;
}

.box-block-grey {
  background: #F1F1F1;
}

.select-parts-check-all {
  font-weight: 500;
  margin-top: 8px;
}

.select-parts-check-all input {
  transform: translateX(calc(50% + 2px));
}

.select-parts-check-all label {
  transform: translateX(8px);
}

#SelectImages4 {
  background: #F1F1F1;
  margin-top: -15px;
  margin-bottom: 30px;
}

.vertical-top {
  vertical-align: top;
}

.vertical-middle {
  vertical-align: middle;
}

.autosave {
  color: #142742;
  font-size: 13px;
  margin-left: 100px;
}

.vue-form-wizard.xs {
  padding-bottom: 0px !important;
  overflow: auto;
}

.wizard-nav {
  overflow: hidden;
}

.vue-form-wizard .wizard-nav-pills a, .vue-form-wizard .wizard-nav-pills li {
  max-width: 89px;
}

.vue-form-wizard .wizard-nav-pills {
  flex-wrap: nowrap;
}

.vue-form-wizard.xs .wizard-icon-circle {
  width: 30px !important;
  height: 30px !important;
}

#activity .wizard-progress-with-circle {
  background-color: rgba(27, 30, 56, 0.12);
  border-radius: 5px;
  /* to keep border radius */
  overflow: hidden;
}

#activity .vue-form-wizard .wizard-tab-content {
  min-height: 1px;
  padding-bottom: 0;
  border-top: 1px solid transparent;
  margin-top: 0px;
  padding: 5px;
}


.wizard-icon.ti-check {
  font-weight: bold;
}

.vue-form-wizard.xs .wizard-navigation .wizard-progress-with-circle {
  height: 2px !important;
  top: 19px !important;
}

.vue-form-wizard.xs .wizard-nav-pills > li.active > a .wizard-icon {
  font-size: 12px !important;
  color: #5E79FF;
}

.wizard-navigation {
  overflow-x: auto;
}

#activity .wizard-navigation {
  float: left;
  margin-top: 18px;
  margin-left: 0;
}

.vue-form-wizard .wizard-icon-circle .wizard-icon-container {
  border-radius: 50%;
}

#activity .vue-form-wizard .wizard-header {
  padding: 15px 30px;
  padding-bottom: 0px;
}

#activity .wizard-icon-circle ~ .stepTitle {
  font-size: 12px;
  font-weight: 600;
  padding: 5px 38px;
}

.card-block {
  position: relative;
}

.tabs-absolute-right {
  display: inline-flex;
  margin-right: 10px;
}

@media screen and (max-width: 991px) {
  .tabs-absolute-right {
    position: relative;
    top: 0px;
    right: 0;
    z-index: 99;
    float: left;
  }
}

.styled-tabs {
  width: 302px;
  border: 1px solid #142742;
  border-radius: 3px;
}

.styled-tabs .nav-link {
  width: 150px;
  text-align: center;
  border: none;
  color: #142742;
  font-size: 14px;
  font-weight: bold;
  padding: 0.3em 0;
}

.styled-tabs .nav-item .active {
  background: #142742;
  color: #FFFFFF;
}

.styled-tabs .nav-item .active:focus {
  background: #142742;
  color: #FFFFFF;
}

.slide-fade-enter-active {
  transition: all .2s ease;
}

.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(-10px);
  opacity: 0;
}

table.main-total-table td.right {
  text-align: right;
}

.estimate_amount {
  border: 1px solid rgba(0, 0, 0, .125);
}

.header_estim_amount h4 {
  width: 60%;
  margin-bottom: 0px;
}

.header_estim_amount h4.amountValue {
  width: 40%;
  margin-bottom: 0px;
}

.header_estim_amount {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 10px;
  border-bottom: 1px solid rgba(0, 0, 0, .125);
}

.body_estim_amount {
  padding: 0 10px;
}

.body_estim_amount > ul > li > span:first-child {
  width: 60%;
}

.body_estim_amount > ul > li > span:last-child {
  width: 40%;
}

.body_estim_amount > ul > li {
  display: flex;
  padding: 5px 0;
  justify-content: space-between;
  align-items: center;
}

.body_estim_amount > ul {
  margin-bottom: 0;
  padding: 0;
}

.filterAssigned:before {
  top: -19px;
  border-color: transparent transparent transparent #BDBDBD;
  border-width: 9px;
  left: 30px;
}

.filterAssigned:after {
  top: -18px;
  border-color: transparent transparent transparent #FFFFFF;
  border-width: 9px;
  left: 30px;
}

.filterAssigned:after, .filterAssigned:before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  transform: rotate(-90deg);
}

.saveAsTemplateList li {
  border-bottom: none !important;
}

.addTemplateList li {
  border-bottom: none !important;
}

.tabs-component ul > li .loaderAssignTo {
  position: absolute;
  max-width: 30px;
  top: 5px;
  right: -36px;
}

.tabs-component ul > li {
  position: relative;
}

.searchInput {
  width: calc(100% - 20px);
}

.filterAssigned > input {
  border: 1px solid rgba(27, 30, 56, .25);
  padding: 2px 7px;
  /*added*/
  margin: 0px 7px;
  width: 90% !important;
  border-radius: 5px;
}

.filterAssigned > ul > li {
  padding: 5px 10px;
  cursor: pointer;
  font-weight: bold !important;

}

.filterAssigned > ul > li:hover {
  background-color: rgba(94, 121, 255, 0.1) !important;
  color: #5E79FF !important;
  border-bottom: 1px solid transparent;
  font-weight: bold !important;
}

.li-in-save-as-template:hover {
  background-color: rgba(94, 121, 255, 0.1) !important;
  color: #5E79FF !important;
}

.filterAssigned > ul {
  padding: 0;
  height: auto;
  max-height: 300px;
  overflow: auto;
  margin-top: 4px;
}

.filterAssigned {
  position: absolute;
  left: 0;
  z-index: 9999;
  background-color: #FFFFFF;
  border: 1px solid #BDBDBD;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  padding: 5px 0px;
  transition: 0.4s;
  top: 100%;
  transform: translateY(10px);
  opacity: 0;
  visibility: hidden;
  width: auto;
  min-width: 190px;
  max-width: 300px;
}

.context-level {
  width: 100% !important;
  left: calc(100% + 1px) !important;
}

.openFilterAssigned {
  opacity: 1;
  visibility: visible;
  transform: translateY(0px);
}
</style>

<style scoped>
.V3 .tab-pane {
  background: white;
}

.V3 .container-fluid .row .col-md-3 {
  padding: 0px !important;
}

.V3 .container-fluid .row .col-md-9 {
  padding: 0px !important;
}

.V3 .template-tabs.mt-2 .nav-tabs.nav-tabs-2:first {
  margin-bottom: 0px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
}

.V3 ul.nav.nav-4 {
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  margin-right: 10px;
  scrollbar-width: thin;
}

.V3 ul.nav.nav-4 li {
  position: relative;
}

.V3 ul.nav.nav-4 .nav-item.active {
  background-color: rgba(94, 121, 255, 0.1) !important;
}

.V3 ul.nav.nav-4 .nav-item.active a:focus {
  background-color: rgba(94, 121, 255, 0.1) !important;
}

.V3 ul.nav.nav-4 .nav-item.active .nav-link {
  color: black;
}

.V3 ul.nav.nav-4 .nav-item.active::after {
  content: "";
  position: absolute;
  left: 0px;
  bottom: 0px;
  height: 100%;
  width: 5px;
  border-radius: 0 5px 5px 0;
  background-color: #5E79FF;;
}

.V3 .tab-pane .col-md-5 .col-md-6 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.V3 .new-estimate-item {
  color: #5E79FF !important;
}

.V3 .new-estimate-item i {
  color: #5E79FF !important;
}

.V3 .search-input {
  background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMThweCIgaGVpZ2h0PSIxOHB4IiB2aWV3Qm94PSIwIDAgMTggMTgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA2MiAoMTAxMDEwKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT4wNjRFQjU4Ni05NzJDLTRBMzktQjgwMy0zRUJDNTg1OEI0OTY8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGcgaWQ9IlVJLURlc2lnbiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgb3BhY2l0eT0iMC41Ij4KICAgICAgICA8ZyBpZD0iRGFzaGJvYXJkLVJlZGVzaWduLShWaWV3LUFzc2Vzb3JzKSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyNTIuMDAwMDAwLCAtMTU4LjAwMDAwMCkiIGZpbGw9IiMyNzJBNDMiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxnIGlkPSJUb3AiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI1MC4wMDAwMDAsIDYxLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTExIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4NDAuMDAwMDAwLCA4Ny4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0ic2VhcmNoIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjIuMDAwMDAwLCAxMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTguMSwxMy41IEMxMC4wMjkyMzQyLDEzLjUgMTEuODExOTIwMSwxMi40NzA3NjU4IDEyLjc3NjUzNzIsMTAuOCBDMTMuNzQxMTU0NCw5LjEyOTIzNDIgMTMuNzQxMTU0NCw3LjA3MDc2NTggMTIuNzc2NTM3Miw1LjM5OTk5OTk4IEMxMS44MTE5MjAxLDMuNzI5MjM0MTUgMTAuMDI5MjM0MiwyLjcgOC4xLDIuNyBDNS4xMTc2NjIzOCwyLjcgMi43MDAwMDAwOCw1LjExNzY2MjM4IDIuNzAwMDAwMDgsOC4xIEMyLjcwMDAwMDA4LDExLjA4MjMzNzYgNS4xMTc2NjIzOCwxMy41IDguMSwxMy41IFogTTEzLjc4OCwxMi41MTU0IEwxNy4wMSwxNS43Mzc0IEMxNy4yNDM3OTU2LDE1Ljk2MzUzMzYgMTcuMzM3Mzg1MSwxNi4yOTgyMjAzIDE3LjI1NDc5OCwxNi42MTI4MjUxIEMxNy4xNzIyMTA4LDE2LjkyNzQyOTkgMTYuOTI2Mjk5MywxNy4xNzI5OTM5IDE2LjYxMTU3OCwxNy4yNTUxMzYgQzE2LjI5Njg1NjcsMTcuMzM3Mjc4IDE1Ljk2MjMwMjcsMTcuMjQzMjE1MiAxNS43MzY1LDE3LjAwOTEgTDEyLjUxNDUsMTMuNzg3MSBDOS41MTE2MzA2LDE2LjExODA3MTcgNS4yMTQwMTM2MiwxNS43MTI5ODE0IDIuNjk5NTk1NzIsMTIuODYxOTU0MSBDMC4xODUxNzc4MywxMC4wMTA5MjY5IDAuMzIwMzg0NzkzLDUuNjk2Mzc4NCAzLjAwODM4MTYsMy4wMDgzODE2IEM1LjY5NjM3ODQsMC4zMjAzODQ3OTMgMTAuMDEwOTI2OSwwLjE4NTE3NzgzIDEyLjg2MTk1NDEsMi42OTk1OTU3MiBDMTUuNzEyOTgxNCw1LjIxNDAxMzYyIDE2LjExODA3MTcsOS41MTE2MzA2IDEzLjc4NzEsMTIuNTE0NSBMMTMuNzg4LDEyLjUxNTQgWiIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=') no-repeat center right;
  background-position: right 7px center;
  width: 100%;
}

.V3 .search-input:focus {
  width: 100% !important;
}

@media screen and (max-width: 767px) {
  .V3 .active.ml-2 {
    margin-left: 0 !important;
  }
}

.V3 .left-side {
  background: #DFEBF8;
  padding-bottom: 110px;
}

.V3 .left-side hr {
  width: 100%;
  border-bottom: 2px solid #C0D8EF;
  margin: 20px 0;
}

.V3 .left-side h3 {
  color: #142742;
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
  margin-top: 20px;
  margin-bottom: 10px;
}

.V3 .p-20 {
  padding: 20px;
}

.V3 .mt-3 {
  margin-top: 2.3rem !important;
}

.V3 .btn.btn-primary.mt-1.mb-1 {
  margin-bottom: 0.5rem;
}

.V3 .filed-md {
  display: block;
  width: 100%;
  background: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #DDDDDD;
  padding: 15px;
}

.V3 .filed-md::placeholder {
  color: #818A91;
  font-size: 14px;
  font-weight: 600;
}

.V3 .search-field {
  padding-left: 45px;
}

.V3 .search-label {
  position: absolute;
}

.V3 .search-label i {
  position: relative;
  display: block;
  font-size: 20px;
  color: #818A91;
  transform: translate(15px, 17px);
}

.V3 .left-side-nav {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.V3 .left-side-nav li {
  display: flex;
  justify-content: space-between;
  color: #142742;
  font-size: 14px;
  padding: 13px 20px;
  -webkit-transition: 0.2s linear;
  -moz-transition: 0.2s linear;
  -o-transition: 0.2s linear;
  transition: 0.2s linear;
}

.V3 .left-side-nav li:hover {
  background: #EFF5FA;
  color: #0672C3;
}

.V3 .left-side-nav li.active {
  background: #EFF5FA;
}

.V3 .left-side-nav button {
  cursor: pointer;
  width: 20px;
  padding: 0;
  margin-left: 5px;
}

.V3 .left-side-nav i {
  font-size: 20px;
  margin-left: 10px;
}

.V3 .left-side-nav .ti-write {
  color: #142742;
}

.V3 .left-side-nav .ti-trash {
  color: #D0021B;
}

.V3 .nav-tabs.nav-tabs-2 {
  /* border: none;*/
  /*   height: 50px; */
}

.V3 .estimate-items th {
  height: 48px;
  background-color: rgba(27, 30, 56, 0.1) !important;
  color: #1C1F39 !important;
  font-size: 13px;
  font-weight: bold;
  line-height: 18px;
}

.V3 .estimates-edit .browse-btn {
  height: 38px;
  width: 126px;
  border-radius: 3px;
  background-color: #5E79FF;
  color: white;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
}

.V3 .estimates-edit .cancel-btn {
  box-sizing: border-box;
  height: 39px;
  width: 127px;
  border: 1px solid rgba(28, 31, 57, 0.25);
  border-radius: 3px;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
}

.V3 .estimates-edit #upload-images .bx {
  font-size: 37px;
  color: #5E79FF;
}

.V3 .estimates-edit .text-or {
  color: #1C1F39;
  font-family: "Nunito Sans";
  font-weight: 700;
  opacity: 0.25;
  font-size: 13px;
}

.V3 .estimates-edit .tab-content {
  padding-left: 0;
}

.V3 .estimates-edit .pin-checkmark {
  background-color: #FFFFFF;
}

.V3 .estimates-edit #upload-files .dnd-or {
  opacity: 0.25;
  color: #1C1F39;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
}

.V3 .estimates-edit #upload-files .dnd-title {
  color: #1C1F39;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
}

.V3 .estimates-edit #upload-files i {
  font-size: 37px;
  color: #5E79FF
}

</style>
<style scoped>
.tabs-absolute-right {
  display: inline-flex;
  margin-right: 30px;
}

.V3 .estimates-edit-page .col-form-label {
  padding: 8px 0;
}

.V3 .estimates-edit-page .pin-image {
  align-items: center;
  position: relative;
  color: #34495E;
  height: 27px;
  font-weight: 600;
  font-size: 13px;
  padding-top: 8px;
  padding-left: 35px;
  margin-bottom: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}

/* Hide the browser's default checkbox */
.V3 .estimates-edit-page .pin-image input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create the checkmark/indicator (hidden when not checked) */
.V3 .estimates-edit-page .pin-checkmark i {
  margin: auto;
  width: 16px;
  display: none;
  font-size: 26px;
  color: white;
  margin-left: -2px;
  margin-top: -2px;
}

/* Show the checkmark when checked */
.V3 .estimates-edit-page .pin-image input:checked ~ .pin-checkmark i {
  display: block;
}

.V3 .estimates-edit-page .card-block {
  padding: 13px;
}

.V3 .estimates-edit-page .shop-bold {
  font-size: 14px;
  line-height: 19px;
  font-weight: bold;
}

.V3 .estimates-edit-page .shop-bold .col-sm-7 {
  padding-left: 0;
}

.V3 .estimates-edit-page .shop-light {
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  display: flex;
  align-items: center;
}

.V3 .estimates-edit-page .shop-light .col-sm-7 {
  padding-left: 0;
}

.V3 .estimates-edit-page .progress {
  border-top: 1px solid rgba(27, 30, 56, 0.25);
  padding-top: 15px;
}

.V3 .estimates-edit-page .progress h2 {
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
}

.V3 .estimates-edit-page .progress .full-activity {
  color: #5E79FF;
  font-size: 13px;
  font-weight: 600;
}

.tabs-absolute-right-notes-btn {
  margin-right: 160px;
}

.button.button.button--light {
  position: relative;
  cursor: pointer;
  border: 0px;
}

.button.button.button--light:active {
  top: 1px;
}

.pdr-menu {
}

.pdr-menu__item {
  position: relative;
}

.pdr-menu__button {
  cursor: pointer;
  border: 0px;
  padding: 0px;
  background: transparent;
}

.pdr-menu__comment {
  position: absolute;
  display: none;
  border-radius: 5px;
  overflow: hidden;
  right: -65%;
  top: 10px;
  background-color: #FFFFFF;

  /* copied from vue-context */
  border: 1px solid #BDBDBD;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);

}

.pdr-menu__item.has-comment:hover .pdr-menu__comment,
.pdr-menu__item.has-comment:focus .pdr-menu__comment,
.pdr-menu__item.has-comment:active .pdr-menu__comment {
  display: flex;
}

.pdr-menu__comment textarea {
  min-height: 100px;
  width: 174px;
  border: 0px;
  padding: 10px;
}

.pdr-visible-icon {
  position: relative;
}

.disabled.pdr-visible-icon:after {
  display: none;
}

.pdr-visible-icon:after {
  content: '/';
  display: grid;
  place-items: center;
  position: absolute;
  top: -5px;
  left: -1px;
  font-weight: 900;
  font-size: 28px;
  transform: rotate(300deg);
  width: 24px;
  height: 24px;
  overflow: hidden;
  text-shadow: -1px -2px #DDDDDD;
}

.V3 .estimates-edit-page.is-mobile .form-control {
  padding-right: 20px !important;
}

.V3 .estimates-edit-page.is-mobile .nav-4 .nav-link {
  padding: .5rem .35rem;
}

.V3 .estimates-edit-page.is-mobile .nav-4 .nav-link i {
  margin-right: .35rem;
}

.V3 .vh-height-65 {
  overflow-x: hidden;
  overflow-y: auto;
}

.checkbox-group {
  display: flex;
  flex-wrap: wrap;
}

.checkbox-p {
  padding-bottom: 10px;
  padding-right: 10px;
}

@media (max-width: 991px) {
  .col-lg-8 {
    float: right;
    width: 66.666667%;
  }
}

.V3 .nav-tabs.nav-tabs-2.is-mobile {
  display: block;
}
</style>


<style>
/* Style to be used with invoice-view and invoice-excess */

/* HEADER TABLE */
.invoice-info {
  padding-right: 5px;

  font-size: 12px;
  letter-spacing: 0;
  line-height: 16px;

  margin-bottom: 10px;
}

.invoice-title {
  color: #1C1F39;
  font-family: "Nunito Sans";
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 2px;
  line-height: 24px;
  margin: 0 0 20px;
}

.invoice .header-table {
  margin: 0 0 20px
}

.invoice .header-table td {
  color: #1C1F39;
}

/* CONTENT TABLE */
.invoice .main-table thead th,
.invoice .main-table tbody th {
  padding: 8px 15px;
  background: rgba(27, 30, 56, 0.12);
}

.invoice .main-table td, .invoice .main-table th {
  text-align: left;
  border-bottom: 1px solid white;

}

.invoice .main-table thead th {
  padding: 8px 15px;
  font-size: 13px;
  font-weight: 700;
}

.invoice .main-table tbody th, .invoice .main-table tfoot th {
  padding: 8px 15px;
  color: #3F3F3F;
  font-size: 12px;
  font-weight: 700;
}

.invoice .main-table thead th {
  border-radius: 3px;
}

.invoice .main-table tbody th:first-child {
  border-radius: 3px 0 0 3px;
}

.invoice .main-table tbody th:last-child {
  border-radius: 0 3px 3px 0;
}

/* Owner details */
.invoice .main-table .vehicle-details td,
.invoice .main-table .main-inner td {
  border: none;
  color: #1C1F39;
}

.invoice .main-table .main-inner td:first-child {
  min-width: 110px;
  width: 40%;
  font-weight: 700;
}

.invoice .main-table tbody td,
.invoice .main-table tfoot td {
  padding: 5px 15px;
  color: #1C1F39;
  font-size: 12px;
  /* font-weight: 400; */
}

.invoice .main-table tbody tr:first-child td,
.invoice .main-table tfoot td:first-child td {
  /* padding-top: 5px; */
}

.invoice .repairs-total tbody td {
  padding: 5px 15px;
  border: none;
}

.invoice .main-total-table {
  margin-bottom: 20px;
  width: auto !important;
  float: right;
}

.invoice .main-total-table tr:last-child td {
  border-bottom: 0
}

.latest_amount_table td.border-bottom,
.invoice td.border-bottom {
  position: relative;
  border-bottom: 1px solid rgba(27, 30, 56, 0.25);
}

.latest_amount_table td:last-child.border-bottom::after,
.invoice td:last-child.border-bottom::after {
  content: "+";
  position: absolute;
  font-size: 22px;
  bottom: -17px;
  right: -5px;
}

.latest_amount_table td:last-child.border-bottom::after {
  bottom: -8px;
}

.invoice-view .main-table tfoot td.subtotal-right {
  text-align: right;
  padding-right: 25px;
  font-weight: 700;
}

.hasSubContext {
  position: relative;
  padding-right: 5px !important;
}

.icon-right {
  transform: translate(100%, -3px) !important;
  font-size: 21px !important;
}

@media screen and (max-width: 400px) {
  .estimate-preview-visual .tab-content {
    padding: 10px 0 !important;
  }
}
</style>
<style>
@media screen and (min-width: 1598px) {
  .sticky {
    background-color: white;
    z-index: 111;
    top: 204px;
    position: sticky;
    position: -webkit-sticky;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1598px) {
  .sticky {
    background-color: white;
    z-index: 111;
    top: 242px;
    position: sticky;
    position: -webkit-sticky;
  }
}
</style>

<style scoped>
.error-text {
  color: red !important;
}

.white-text {
  color: white !important;
}

.nav-title {
  padding: 10px 15px 0 15px;
}

.invoice .main-table tbody td, .invoice .main-table tfoot td {
  padding: 5px 10px;
}

@media screen and (max-width: 767px) {
  .nav-title {
    padding: 0 10px 0 15px;
  }
}

@media screen and (max-width: 767px) {
  .reset-padd {
    padding-right: 0px;
  }

  .add-padd-mobile {
    padding-right: 15px;
    padding-left: 15px;
  }

  .padd-left-15 {
    padding-left: 15px !important;
  }

  .checkbox-group {
    flex-direction: column;
  }
}

.checkbox-group {
  display: flex;
  flex-wrap: wrap;
}

.checkbox-p {
  padding-bottom: 10px;
  padding-right: 10px;
}

.close-edit-cursor {
  cursor: not-allowed;
}

@media (min-width: 1400px) {
  .numeric-qty {
    min-width: 2.5rem !important;
  }
}

@media screen and (max-width: 991px) {
  .invoice-header {
    flex-direction: column;
  }

  .table-fixed {
    table-layout: fixed;
  }

  .vat {
    display: block;
  }

  .owner-details tr {
    padding-left: 5px;
  }

  .invoice {
    width: 540px;
  }

  .main-flex {
    display: flex;
    flex-direction: column;
  }

  .mobile-disabled {
    display: none;
  }

  .invoice .main-table .vehicle-details td,
  .invoice .main-table .main-inner td {
    padding: 5px 0;
  }
}

@media screen and (max-width: 767px) {
  .invoice-header {
    flex-direction: column;
  }

  .invoice .main-total-table {
    float: left;
  }
}

@media screen and (max-width: 576px) {
  .invoice {
    width: 95%;
  }

  .invoice .main-table thead th {
    padding: 8px 5px;
  }

  .invoice .main-table tbody td, .invoice .main-table tfoot td {
    padding: 5px 0;
  }

  .block-position-wrap {
    flex-wrap: wrap;
    padding-left: 15px;
    justify-content: flex-end;
  }

  .V3 .estimates-edit-page .col-form-label {
    padding-left: 0 !important;
    text-align: left !important;
    min-width: 48px !important;
  }

  .V3 .estimates-edit-page.is-mobile .form-control {
    padding: 0.5rem 5px !important;
  }
}

.V3 .card-header {
  min-height: 48px;
  height: auto;
  align-items: center;
  transform: none;
}


.V3 .card-header {
  padding: 5px 15px !important;
}

.additional-menu-icon {
  position: absolute;
  right: 10px;
  top: 13px;
}

.trash-icon {
  cursor: pointer;
}

.estimate-item-comment {
  position: absolute;
  border-radius: 5px;
  overflow: hidden;
  width: 148px !important;
  height: 121px !important;
  left: 177px !important;
  background-color: #FFFFFF;
  border: 1px solid #BDBDBD;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 20%), 0 1px 5px 0 rgb(0 0 0 / 12%);
}

.estimate-item-comment textarea {
  height: 119px;
  width: 146px;
  border: none;
  padding: 0.75rem;
  resize: none;
}

.comment-limit-text {
  position: absolute;
  bottom: -5px;
  left: 6px;
  color: #A2ABAE;
}

.save-comment-icon {
  position: absolute;
  bottom: 7px;
  left: 124px;
  font-size: 27px;
  color: #73716C;
}

.save-comment-icon:hover {
  color: #5E79FF;
}

@media screen and (max-width: 1670px) {
  .additional-padding-btn {
    padding-bottom: 10px;
  }
}

.tooltip {
  top: 32px !important;
}

@media screen and (max-width: 1024px) {
  .header-display-name {
    display: none;
  }
}
</style>

<style>
.ghost-items {
  display: flex;
  width: 100%;
  background-color: #F9F9F9 !important;
  border: 2px solid rgba(94, 121, 255, 0.5) !important;
  box-shadow: 0 0 0 0.3rem rgba(94, 121, 255, 0.25);
  border-radius: 3px;
  box-sizing: border-box;
}

.ghost-items a {
  color: #5E6571;
  font-family: "Nunito Sans", sans-serif;
  font-size: 12px;
  font-stretch: 100%;
  background: white;
  border: 1px solid rgba(28, 31, 57, 0.25);
  border-radius: 3px;
  width: calc(100% - 1.5rem);
  line-height: 32px;
  padding: 0 2px;
  display: block;
  margin: .75rem;
}

.ghost-items a:hover {
  color: #5E6571;
}

.ghost-items a > div {
  display: none !important;
}

.ghost-items::after {
  content: "";
}

.V3 .estimates-edit-page .page-header .page-header-nav-pin-images {
  bottom: 22px;
}
</style>

<style>
.additional-data-picker-block .vc-popover-content-wrapper {
  position: fixed !important;
  z-index: 99999;
}

@media screen and (max-width: 767px) {
  .additional-data-picker-block .vc-popover-content-wrapper {
    position: inherit !important;
    z-index: 99999;
    transform: translate3d(-50px, 10px, 0px) !important;
  }
}

.rs-scroll-new-y::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

.V3 .estimates-edit-page .medium-rectangle-b-promo img {
  width: 300px !important;
  height: 250px !important;
}
</style>

<style scoped>
.estimate-items-wrapper {
  margin-right: 10px;
  margin-left: 10px;
}

@media (max-width: 767px) {
  .modal {
    top: 30% !important;
  }
}

.estimate-items-title {
  height: 48px;
  background-color: rgba(27, 30, 56, .1) !important;
  color: #1C1F39 !important;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  display: flex;
  align-items: center;
}

.estimate-items-title-content {
  padding: 0.75rem;
  width: 95px;
  flex-grow: 0;
}

.V3 .estimates-edit-page .medium-rectangle-b-promo-block div {
  width: 300px;
  height: 250px;
}
</style>




